import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Dialog,
  DialogContent,
  CircularProgress,
  IconButton,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  InputLabel,
  Chip,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Radio } from "@material-ui/core";
import { RadioGroup } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import { Checkbox } from "@material-ui/core";
import { ArrowBack, Delete, Error } from "@mui/icons-material";
import { InputAdornment, MenuItem, Select } from "@material-ui/core";
import VendorCode from "./Dropdowns/VenderCode";
import UsersByRole from "./Dropdowns/UsersByRole";
import GL_Table from "./Tables/GL_Table";
import GL_Table_V2 from "./Tables/GL_Table_V2";
import Vendor_Table from "./Tables/Vendor_Table";
import CommentHistory from "./Tables/CommentHistory";
import PODetail from "./Tables/PoDetail_Table";
import ExpenseTable from "./Tables/ExpenseTable";
import ExpenseTable_V2 from "./Tables/ExpenseTable_V2";
import SearchUsersRole from "./Dropdowns/SearchUserRole";
import {
  // clearState,
  createInvoiceByIR,
  createNewInvoice,
  createNewInvoiceByEFDV,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  getPODetails,
  uploadAdditioalDocumentFile,
  uploadFile,
  changeInvoiceStatus,
  uploadFile_v1,
  getDNDetails,
  getRefrenceDataList,
  getDN_ITN_Details,
  getAllInvoiceDetailByInvoiceId,
  getAllInvoiceDetailByInvoiceIdForImport,
  getUsersByRole,
  getTaxUserForNonPo,
  getVendorDetail,
  getLoamApprover,
  getVendorByPOForBlock,
  // getVendorDetailForVendorBlock,
  // getg_laccount,
  getMethodForPageRefresh,
  updateLoamReviewer,
  getAllUsers,
  getVendorAdvance,
  getDuplicateInvoiceCheck,
} from "../actions";
import InvoiceGuideLine from "./InvoiceGuidLines/InvoiceGuideLine";
import ProceedBtn from "./InvoiceGuidLines/proceedbtn";
import CustomSnackbar from "../../../CustomSnackbar";
import moment from "moment";
import { getUserRoles } from "../../Home/actions";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { demandType, category, invoiceType } from "../../Home/constant";
import { useNavigate, useLocation } from "react-router-dom";
import getParameterByName from "../../../Functions/functions";
import axios from "axios";
import { addZeroes, formatDateTimeForBackend } from "../../../Functions";
import ChangeIrModal from "../Components/Modals/ChangeIrModal";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import { Role } from "../../../Redux/Actions/Role";
// import isAboveToday from "../../../Functions/isAboveToday";
import isOldDateValidate from "../../../Functions/isOldDateValidate";
import OldDateWarning from "./InvoiceGuidLines/OldDateWarning";
import { Download } from "@material-ui/icons";
import downloadAttachments from "../../../Functions/downloadAttachments";
import PoDetail_Table_V2 from "./Tables/PoDetail_Table_V2";
import WarningBox from "../Components/WarningBox";
import DebugDialog from "./InvoiceDialogs/DebugDialog";
import isFutureDate from "../../../Functions/isFutureDate";
import jwt from "jsonwebtoken";
import Heading from "../../../StyledComponents/Heading/Heading";
import AlterImg from "../../../assets/images/AlterImg.jpeg";
import POAlertDialog from "./Tables/PoTableAlert";
import { Backdrop } from "@material-ui/core";
// import I2pheading from "../../../layouts/FullLayout/Header/I2pheading";
import ThreeWayCheckModal from "../../../components/ConfirmModal/ThreeWayCheckModal";
import POTableFor_Model from "./Tables/POTableFor_Model";
import { getAllInvoiceDetailByInvoiceIdV2 } from "../ProcessInvoice/actions";
import PageNotFound from "./PageNotFound";
import ReviewerModal from "../Components/Modals/ReviewerModal";
// import AdjustAdvanceModal from "../Components/Modals/AdvanceAdjustmentmodal";
import CustomerCode from "./Dropdowns/CustomerCode";
import FCA_Details_Table from "./Tables/FCA_Details_Table";
import Agreement_Details_Table from "./Tables/Agreement_Details_Table";
import Provice_Stamp_Duty_Table from "./Tables/Provice_Stamp_Duty_Table";
import DepartmentCoordinatorRent from "../DepartmentCoordinator/DepartmentCoordinatorRent";
import ProvinceModal from "../Components/Modals/ProvinceModal";
import RTBLineItems_Table from "./Tables/RTBLineItems_Table";

const token = localStorage.getItem("user_token");
const user = jwt.decode(token);

// const useStyles = makeStyles((dashboardStyle) => ({
//   helperText: {
//     marginLeft: 0,
//   },
// }));
const useStyles = makeStyles(dashboardStyle);
const radioStyle = {
  // color: "#C5C7CD",
  "&.Mui-checked": {
    color: "#0095DA",
  },
  "&.Mui-disabled": {
    color: "rgb(157, 166, 171)", // Change the color to black when disabled
  },
};
const radioLabel = {
  color: "black",
};
const tableBorder = {
  border: "none",
};
const tableheading = {
  border: "none",
  fontWeight: "bold",
};
const NewInvoice = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const edit = getParameterByName("edit");
  const status = getParameterByName("status");
  const [reviewerModal,setReviewerModal]=useState(false)
  const invoicePayload = {
    Invoice_id: invoiceId,
  };

  const dispatch = useDispatch();
  const state = useSelector((state) => state.Role);
  const role = {
    roleId: roleId,
    roleName: roleName,
  };
  const [selectedRole, setSelectedRole] = useState(
    role
      ? { roleName: role?.roleName ? role?.roleName : state?.roleName || "" }
      : ""
  );
  const [filteredUserData,setFilteredUserData ]= useState([]);

  const [multipleData, setMultipleData] = useState({
    invoice_Type: [],
  });

  let depDisable =
    edit === "false" &&
    (selectedRole?.roleName === "I2P Initiator" ||
      selectedRole?.roleName === "IR" ||
      selectedRole?.roleName === "Import" ||
      selectedRole?.roleName === "EFDV Initiator" ||
      selectedRole?.roleName === "HR")
      ? // (user?.Location !== "1" &&
        //   selectedRole?.roleName === "IR" &&
        //   (status === "SendToIRFromDeptCoordinator" || status === "SendToIRFromIP"))
        true
      : false;

  let disable =
    edit === "false" &&
    (selectedRole?.roleName === "I2P Initiator" ||
      selectedRole?.roleName === "IR" ||
      selectedRole?.roleName === "Import" ||
      selectedRole?.roleName === "EFDV Initiator" ||
      selectedRole?.roleName === "HR")
      ? true
      : false;

  const [roles, setRoles] = useState([]);
  const [rolesNavigate, setRolesNavigate] = useState([]);
  const [search_val, setSearch_val] = useState("");
  const [filter, setFilter] = useState(""); //  state  to set grn, (working) => filter the po detail on popup.
  const [rolesLoading, setRolesLoading] = useState(false);
  const [poLoading, setPoTableLoading] = useState(false);
  const [poBasedState, setPoBasedState] = useState("PO");
  const [warningFlag, setWarningFlag] = useState(false);
  const [buyerStatus, setBuyerStatus] = useState(false);
  const [PRInitiatorStatus, setPRInitiatorStatus] = useState(false);
  const [invoiceCategory, setInvoiceCategory] = useState("Other");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [dNInvoicesorITNInvoices, setDNInvoicesOrITNInvoices] =
    useState("DN Invoices");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);
  const [attachmentLoader, setAttchmentLoader] = useState(false);
  const [invoiceloader, setInvoiceloader] = useState(false);
  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);
  const [openProceedBtn, setOpenProceedBtn] = useState(false);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [InvalidWarningDateState, setInvalidWarningDateState] = useState("");
  const [initialState2, setinitialState2] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [loamCheck, setLoamCheck] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");
  const [openWarningBox, setOpenWarningBox] = useState(false);
  // const [currentStateForDeleteion, setCurrentStateForDeleteion] = useState("");
  const [attachmentURL, setAttachmentURL] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [alertMessageforPO, setAlertMessageForPO] = useState(false);
  const [vendorblock, setvendorblock] = useState(false);
  const [deleteLoader, setdeleteLoader] = useState(false);

  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [showDepartmentCordinator, setShowDepartmentCordinator] =
    useState(false);
  const [po_dn_State, setPo_dn_State] = useState("PO");
  const [userData, setUserData] = useState([]);
  const [reviewerData, setReviewerData] = useState([]);
  const [reviewer, setReviewer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [des, setDES] = useState("");
  const [vendorList, setVendorList] = useState([]);
  const [PoCreatedForBuyer, setPoCreatedForBuyer] = useState("");
  const [loamLoading, setLoamLoading] = useState(false);

  const [isConfirmatoryPO , setIsConfirmatoryPO] = useState(false)
  const [poCreated, setPOcreated] = useState({
    POCreatedForBuyer: "",
    PRCreatedForInitiator: "",
  });
  const [showGLTable, setShowGLTable] = useState({
    showForDES : false,
    showForRENT : false
  });
   const[isDuplicateInvoice, setIsDuplicateInvoice] = useState("")
   const [openDuplicateCheckWarning, setOpenDuplicateCheckWarning] = useState(false)
  const additionalUsers = [
    {
      UserID: "32cb8f5b-2251-4ae8-a6a2-f9422a4da9cb",
      PersonalNumber: "10010590",
      Name: "Muhammad Hammad Bhojani ",
      CareerLadder: "HGRL 17",
    },
    {
      UserID: "5f446097-03e8-4951-ad47-4389b5a14e4b",
      PersonalNumber: "10010454",
      Name: "Jawad Akhter ",
      CareerLadder: "HGRL 17",
    },
    {
      UserID: "6d1bfa3a-6cba-4239-860e-d7fdc3879988",
      PersonalNumber: "10010098",
      Name: "Iftikhar Ul Haq ",
      CareerLadder: "HGRL 16",
    },
    {
      UserID: "82b1bab5-028e-4dbc-aec5-230ac1cfa1e1",
      PersonalNumber: "10010821",
      Name: "Muhammad Asad Rafique ",
      CareerLadder: "HGRL 12",
    },
    {
      UserID: "44584900-7d91-460e-91f2-8b9b82bbe35f",
      PersonalNumber: "10009675",
      Name: "Kumar Das ",
      CarrierLadder: "HGRL 15",
    },
    {
      UserID: "d32ca310-3e0b-4c6c-a288-12f5028541f8",
      PersonalNumber: "991455",
      Name: "Daniyal Shakeel ",
      CarrierLadder: "",
    },
  ];
  const [allowToProceed, setAllowToProceed] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);
  useEffect(() => {
    if (invoicePayload.Invoice_id) {
      getMethodForPageRefresh(
        invoicePayload.Invoice_id,
        status,
        setAllowToProceed,
        setPageLoader
      );
    }
  }, [invoicePayload.Invoice_id, status]);
  useEffect(() => {
    getVendorDetail("", setVendorList, setLoading);
  }, []);

  const getUsers = async () => {
    getUsersByRole("IR", setUserData, setLoading);
  };
  useEffect(() => {
    getUsers();
  }, []);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [temp_ActualPoDetail, setTemp_ActualPoDetail] = useState({
    invoicePORef_List: [
      // {
      //   po_Ref_Id: 0,
      //   reF_DOC_IT: "",
      //   val_Loccur: 0, // GRN amount
      //   currency: "", // currency
      //   quantity: "", // GRN quantity
      //   delivUnit: "",
      //   poNumber: "", // poNumber
      //   poItem: "", //  item #
      //   poItemText: "",
      //   refDoc: "", // GRN No
      //   plant: "",
      //   reF_DOC_NO: "",
      //   reF_DOC_NO_LONG: "",
      //   assetNumber: "",
      //   kschl: "",
      //   vText: "",
      //   invoice_Id: 0,
      //   created_by: "",
      //   created_on: new Date(),
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: "", // consumed Amount
      //   balancE_QTY: "",
      //   balancE_VAL: "",
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   conD_ST_NO: "",
      //   conD_COUNT: "",
      //   doC_YEAR: "",
      //   sheeT_ITEM: "",
      //   dN_NO: "",
      //   seQ_NO: "",
      //   disT_IND: "",
      //   ordeR_UNIT: "",
      //   ordeR_QTY: "",
      //   sO_NO: "",
      //   sO_ITEM: "",
      // },
    ],
  }); // this temp_ActualPoDetail is used to load data on po detail table on the page.
  const [temparary_PoDetail, setTemparary_PoDetail] = useState({
    invoicePORef_List: [],
  }); // this temparary_PoDetail will load in pop - table

  const [copyOfPoDetail, setCopyOfPoDetail] = useState({
    copyInvoicePORef_List: [],
  }); // this is used to save the copy of data, when user enter po and dn number. and whenz get po from getInvoiceByInvoiceIdAndRoleId

  const [dnVendorDetail, setdnVendorDetail] = useState({
    dnVendorDetail_List: [],
  }); // thi is used for to show vendor codes on popup menue when user enter dn number

  const [false_PoDetail, setFalse_PoDetail] = useState({
    invoicePORef_List: [],
  });
  // const [selected_PoRec, setSelected_PoRec] = useState({
  //   invoicePORef_List: [],
  // });
  // this selected_PoRec will contain checked PO_rec of popup  table
  const [selectdnVendorDetail, setselectdnVendorDetail] = useState({
    selectdnVendorDetail_List: [],
  });

  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);

  const [selectedTotal, setSelectedTotal] = useState(0);
  const [balance, setBalance] = useState(0);

  const [openIrModal, setOpenIrModal] = useState(false);
  const [dragfile, setDragFile] = useState(false);
  const [newTab, setNewTab] = useState(false);
  const [openDebugDialog, setOpenDebugDialog] = useState(false);
  const [count, setcount] = useState({});
  const [taxuser, setTaxuser] = useState([]);
  const [preData, setPreData] = useState({
    pO_No: "",
    delv_Note_No: "",
    firstTime: true,
  }); // to resolve issue for buyer and logistic.
  const [typeByPo, setTypeByPo] = useState(false);
  const [typeByDN, setTypeByDN] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const [higherLoamApprover, sethigherLoamApprover] = useState(false);
  const [isPOError, setIsPOError] = useState({
    isPOError: false,
    pomessage: "",
  });
  const [openProvince , setOpenProvince] = useState(false)
  const [formState, setFormState] = useState({
    isInitiator:
      state?.roleName === "I2P Initiator" ||
      state?.roleName === "Department Coordinator"
        ? true
        : false,
    isDeptCordinator: false,
    isHR: state?.roleName === "HR" ? true : false,
    isPCDV: state?.roleName === "EFDV Initiator" ? true : false, // EFDV initiator
    isVPPayment: false,
    courier_Tracking_No: "",
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: state?.roleName === "Import" ? true : false,
    isLogistics: false,
    // submission_Date: moment().format("YYYY-MM-DD"),
    submission_Date: new Date(),
    po_Date :"",
    dueOn: moment().format("YYYY-MM-DD"),
    plant_Code : "",
    isDraft: false,
    pO_Based: true,
    isPSID: false,
    psid: "",
    loam_approver: "",
    urgent: false,
    mpasEFDV : false,
    skipTaxStep: false,
    isQuickPay: false,
    eInvoice: true,
    isReturn: false,
    isProceed: true,
    isDelete: false,
    isQuick: false,
    isBuyerPR: false,
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    Shipment_NO: "",
    // adjustAdvance : false,
    // courier_tracking_no: "",
    delv_Note_No: "",
    barcode_No: "",
    courier_Tracking_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "Other",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    logisticsTeam: "",
    loamReviewer: [],
    vendor_Code: "",
    vendor_Name: "",
    distributor_Code: '',
    // in case of rent of department coordinator
    provinceDuty : [],
    FCA_Details: [],
    Agreement_Details : [],
    stamp_Duty_Calculations : [],
    stampDuty : 0,
    // invoice_Date: moment().format("YYYY-MM-DD"),
    invoice_Date:
      state?.roleName === "EFDV Initiator" ? moment().format("YYYY-MM-DD") : "",

    date: "", // this is for HR page
    fs_Doc_Date: "", // this is for HR page
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    comments: "",
    aditional_Comments: "",
    updated_By: "ABC",
    buyer: "",
    prInitiator: "",
    fsDocumentDate: moment().format("YYYY-MM-DD"),
    fsDocumentNumber: "",
    //RTB work
    // rtbId : "",
    // additionalDocIds_array: [], // additional documents in array
    invoice_Accounts_list: [
      {
        rowId: Math.random(),
        accountId: 0,
        customerAccountNo : "",
        invoice_Id: 0, // number for departCord
        glAccount: undefined,
        accountType: "Debit",
        costCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        wbsElement: "",
        horizonId: "",
        vendor_Code: "",
        amount: 0,
        profitCenter: "",
        department: "",
        description: "",
        fsDocNo: "",
        // fsDocDate: "",
      },
    ],

    vendor_Details: [
      {
        // vendorCode: "",
        // VendorName: "",
        vendor_Code: "",
        vendor_Name: "",
        amount: "",
      },
    ],
    // rtbLineItems_List : [],

    invoicePORef_List: [
      // {
      //   po_Ref_Id: 0,
      //   reF_DOC_IT: "",
      //   val_Loccur: 0, // GRN amount
      //   currency: "", // currency
      //   quantity: "", // GRN quantity
      //   delivUnit: "",
      //   poNumber: "", // poNumber
      //   poItem: "", //  item #
      //   poItemText: "",
      //   refDoc: "", // GRN No
      //   plant: "",
      //   reF_DOC_NO: "",
      //   reF_DOC_NO_LONG: "",
      //   assetNumber: "",
      //   kschl: "",
      //   vText: "",
      //   invoice_Id: 0,
      //   : "",
      //   created_on: new Date(),
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: "", // consumed Amount
      //   balancE_QTY: "",
      //   balancE_VAL: "",
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   conD_ST_NO: "",
      //   conD_COUNT: "",
      //   doC_YEAR: "",
      //   sheeT_ITEM: "",
      //   dN_NO: "",
      //   seQ_NO: "",
      //   disT_IND: "",
      //   ordeR_UNIT: "",
      //   ordeR_QTY: "",
      //   sO_NO: "",
      //   sO_ITEM: "",
      // },
    ],

    Expense_Accounts_list: [
      // Invoice_Accounts_list for back-end
      {
        expenseDate: moment().format("YYYY-MM-DD"),
        description: "",
        amount: 0,
        glAccount: "",
        costCenter: "",
        fixedAsset: "",
        tType: "",
        profitCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        department: "",
      },
    ],
    // Invoice_Clearingvendor_list: [
    //   {
    //     vendorCode: "",
    //      VendorName: "",
    //     amount: "",
    //   },
    // ],
    Invoice_Clearingvendor_list: [
      {
        vendorCode: "",
        // VendorName: "",
        amount: "",
      },
    ],
    attachment_Sr: [],
    invoiceDebugData_List: [
      // {
      //   id: 0,
      //   invoice_Id: 0,
      //   poNumber: "",
      //   vendorAmount: "",
      //   sapAmount: "",
      //   difference: ""
      // }
    ],
    verified: false,
    IsSendToBuyer: false
  });
  const [loamApprover, setLoamApprover] = useState(false);
  const [loamUser, setLoamUser] = useState([]);
  const [invoice_Amount_formatted, setInvoice_Amount_formatted] = useState(0);

  const [isParallel, setIsParallel] = useState(state?.roleName === "Department Coordinator" ? "Sequential" : "Parallel")
  const [showModal , setShowModal] = useState(false)
  const [vendorAdvanceData, setVendorAdvanceData] = useState([]);
  useEffect(()=>{
    const selectedUserIds = formState?.loamReviewer;
    const newFilteredData = reviewerData?.filter(user => !selectedUserIds?.includes(user?.userId));
    setFilteredUserData(newFilteredData);
  },[formState])

  useEffect(()=>{
    setFilteredUserData(reviewerData)
  },[reviewerData])

  useEffect(() => {
    getUsersByRole("Reviewer", setReviewerData, setLoading);
  }, []);
  useEffect(() => {
    if (selectedRole?.roleName === "Import") {
      getLoamApprover(
        // "Import logistics and agent charges",
        "import/export related clearing & miscellaneous charges",
        formState.invoice_Amount,
        setLoamUser,
        setLoading,
        additionalUsers
      );
    }
  }, [selectedRole, formState.invoice_Amount]);
  const highest_amount = 0;  const [CeoCostCenter, setCeoCostCenter] = useState(false);
  const getRefrenceDataCostCenter = async (refKey) => {
    const data = {
      refKey,
    };
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatList_v1`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
      params: data,
    })
      .then(async (res) => {
        setCeoCostCenter(res.data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    getRefrenceDataCostCenter("CeoCostCenter");
  }, []);
   const getLoamApprover2 = async () => {
      setLoamLoading(true);
      if (formState?.invoice_Type) {
        var invParam = [];
        formState?.invoice_Accounts_list?.forEach(function (item, i) {
          if (item.amount) {
            var _cc =
              item.costCenter == undefined || item.costCenter == ""
                ? ""
                : item.costCenter;
            if (_cc != "")
              _cc =
                _cc.split("-").length > 0
                  ? item?.costCenter?.split("-")[0].trim()
                  : "";
            var _inv = invParam.filter((i) => i.cost_center == _cc);
            if (_inv.length > 0) {
              _inv[0].invoice_amount =
                parseFloat(_inv[0].invoice_amount) + parseFloat(item.amount);
            } else {
              invParam.push({
                invoice_amount: item.amount?.toString(),
                cost_center: _cc,
                invoice_type: formState?.invoice_Type || "",
                personal_number: user?.personal_number
                  ? user?.personal_number
                  : "",
              });
            }
          }
        });
        var _invParam = [];
        invParam.forEach(function (item, i) {
          if (parseFloat(item.invoice_amount) >= parseFloat(highest_amount)) {
            // app.highest_amount = item.invoice_amount;
            _invParam.push({
              invoice_amount: item.invoice_amount?.toString(),
              cost_center: item.cost_center.trim(),
              invoice_type: item.invoice_type,
              personal_number: user?.personal_number ? user?.personal_number : "",
            });
          }
        });
        // let payload = [];
        // if (
        //   formState?.invoice_Type &&
        //   newFormState?.invoice_Accounts_list?.length === 0
        // ) {
        //   payload.push({
        //     invoice_type: formState?.invoice_Type || "",
        //     cost_center: "",
        //     invoice_amount: formState.invoice_Amount
        //       ? formState.invoice_Amount?.toString()
        //       : "0",
        //     personal_number: user?.personal_number ? user?.personal_number : "",
        //   });
        // } else {
        //   payload.push(
        //     ...newFormState?.invoice_Accounts_list.map((item) => ({
        //       invoice_type: formState?.invoice_Type || "",
        //       // cost_center: item?.costCenter?.CostCenterCode || "",
        //       cost_center: item?.costCenter || "",
        //       invoice_amount: formState.invoice_Amount
        //         ? formState.invoice_Amount?.toString()
        //         : "0",
        //       personal_number: user?.personal_number ? user?.personal_number : "",
        //     }))
        //   );
        // }
  
        await axios({
          method: "post", //you can set what request you want to be
          url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetApprovers`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            "Content-Type": "application/json",
          },
          data: _invParam,
          // data: payload,
        })
          .then(async (res) => {
            if (res?.data[0]?.Error) {
              // Handle the case when the API response contains an error message
              console.error(res.data[0].Error);
  
              // setLoamUser(additionalUsers);
              setLoamUser([]);
            } else if (res?.data && res?.data?.length > 0) {
              if (
                CeoCostCenter.length > 0 &&
                CeoCostCenter[0].ReferenceText !== ""
              ) {
                let _b = false;
                CeoCostCenter[0].ReferenceText.split(",").forEach((reference) => {
                  if (!_b) {
                    _b =
                      formState?.invoice_Accounts_list?.filter(
                        (i) => i.costCenter == reference
                      ).length > 0;
                  }
                });
  
                if (
                  !_b &&
                  res?.data.filter((i) => i?.CareerLadder === "HGRL 24").length >
                    0
                ) {
                  res?.data.splice(res?.data?.length - 1, 1);
                }
                // Set the filtered data to loamApprovers state
              }
              // const combinedUsers = [...res.data, ...additionalUsers];
              const combinedUsers = res.data; // for production build
              // Combine the API response data with the additional list of users
              const uniqueUsersMap = {};
  
              //  filter out duplicates
              combinedUsers.forEach((user) => {
                const key = `${user?.CareerLadder}-${user?.Name}`;
                uniqueUsersMap[key] = user;
              });
  
              // Extract unique users from the map and convert them back to an array
              const uniqueUsers = Object.values(uniqueUsersMap);
  
              setLoamUser(uniqueUsers);
            }
  
            setLoamLoading(false);
          })
          .catch((err) => {
            setLoamLoading(false);
          });
      }
    };
  useEffect(() => {
        getLoamApprover2();
    }, [
      formState?.invoice_Accounts_list,
    ]);

    const getLoamApproverForEFDV = async () => {
      setLoamLoading(true);
      const match = multipleData.PCDVSegments?.find(
        segment => segment?.ReferenceProp1 === user?.PersonalNumber
    );
      let payload = [];
      payload.push(
        ...formState?.Expense_Accounts_list.map((item) => ({
          invoice_type: match?.ReferenceCode,
          cost_center: item?.costCenter?.split("-")[0].trim() || "",
          invoice_amount: formState.invoice_Amount ? formState.invoice_Amount.toString() : "0",
          personal_number: user?.PersonalNumber ? user?.PersonalNumber : "",
        }))
      );
  
      await axios({
        method: "post", //you can set what request you want to be
        url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetApprovers`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
        // data: formState,
        data: payload,
      })
        .then(async (res) => {
          if (res?.data[0]?.Error) {
            // Handle the case when the API response contains an error message
            console.error(res.data[0].Error);
  
            // setLoamUser(additionalUsers);
            setLoamUser([]);
          } else if (res?.data && res?.data?.length > 0) {
            // const combinedUsers = [...res.data, ...additionalUsers];
            const combinedUsers = res.data; // for production build
            // Combine the API response data with the additional list of users
            const uniqueUsersMap = {};
  
            //  filter out duplicates
            combinedUsers.forEach((user) => {
              const key = `${user?.CareerLadder}-${user?.Name}`;
              uniqueUsersMap[key] = user;
            });
  
            // Extract unique users from the map and convert them back to an array
            const uniqueUsers = Object.values(uniqueUsersMap);
  
            setLoamUser(uniqueUsers);
          }
  
          setLoamLoading(false);
        })
        .catch((err) => {
          setLoamLoading(false);
        });
    };

      const getLoamApproverForDistributor = async () => {
      setLoamLoading(true);
      const match = multipleData.loamApprover?.find(
        segment => segment?.ReferenceProp2 === "Director Sales"
    );

    console.log(match, "match  in match")

      await axios({
        method: "get", //you can set what request you want to be
        url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeList_v1/${match?.ReferenceCode}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
        
      })
        .then(async (res) => {
          console.log(res, "res in loam api")
          if (res?.data[0]?.Error) {
            // Handle the case when the API response contains an error message
            console.error(res.data[0].Error);
  
            // setLoamUser(additionalUsers);
            setLoamUser([]);
          } else if (res?.data && res?.data?.length > 0) {
            // const combinedUsers = [...res.data, ...additionalUsers];
            const combinedUsers = res.data; // for production build

            console.log(combinedUsers, "combinedUsers in loam api")
            // Combine the API response data with the additional list of users
            const uniqueUsersMap = {};
  
            //  filter out duplicates
           combinedUsers.forEach((user) => {
  const key = `${user?.employeeCode || user?.PersonalNumber}-${user?.employeeName || user?.Name}`;
  uniqueUsersMap[key] = {
    UserID: user?.id || user?.UserID || "",
    PersonalNumber: user?.employeeCode || user?.PersonalNumber || "",
    Name: user?.employeeName || user?.Name || "",
    CarrierLadder: user?.carrierLadder || user?.CarrierLadder || ""
  };
});
            // Extract unique users from the map and convert them back to an array
            const uniqueUsers = Object.values(uniqueUsersMap);

            console.log(uniqueUsers, "uniqueUsers in loam api")
  
            setLoamUser(uniqueUsers);
          }
  
          setLoamLoading(false);
        })
        .catch((err) => {
          setLoamLoading(false);
        });
    };
  
    useEffect(() => {
      if (formState?.isPCDV && formState?.mpasEFDV ) {
        getLoamApproverForEFDV();
      } 
      if(formState?.invoice_Type === "Final Settlement - Distributor"){
        getLoamApproverForDistributor()
      }
    }, [
      formState?.invoice_Amount, 
     // formState?.Expense_Accounts_list,
      formState?.invoice_Type,
      formState?.isPCDV , 
      formState?.mpasEFDV
    ]);
    
  // var boolValue = JSON.parse(formState.isVPPayment);
  const [open, setOpen] = React.useState(false);
  const [openfordn, setOpenForDN] = React.useState(false);
  const [attachError, setAttachError] = useState("");
  const [erralertMessage, setErrAlertMessage] = useState("");
  const [forVendorAlert, setForVendorAlert] = useState(false);
  const [docError, setDocError] = useState("");
  const [threeWayMismatchItems, setThreeWayMismatchItems] = useState([]);
  const [threeWayMismatchModal, setThreeWayMismatchModal] = useState(false);
  const imgRef = React.createRef();

  const [dimensions, setDimension] = React.useState({
    height: null,
    width: null,
  });

  const imgStyle = { height: dimensions.height, width: dimensions.width };
  const Stylecolor = {
    color: "black",
  };
  const initialHeight = imgRef.current?.clientHeight;
  const initialWidth = imgRef.current?.clientWidth;
  const handleZoomIn = () => {
    // Fetching current height and width
    let height = imgRef.current.clientHeight;
    let width = imgRef.current.clientWidth;

    // Increase dimension(Zooming)
    setDimension({
      height: height + 20,
      width: width + 20,
    });
  };

  useEffect(() => {
    setFormState((formState) => ({
      ...formState,
      irUser:
        selectedRole?.roleName === "I2P Initiator" ||
        selectedRole?.roleName === "Department Coordinator"
          ? ""
          : formState?.irUser
          ? formState?.irUser
          : user?.LoginId,
          ipUser:
          selectedRole?.roleName === "IR" || (selectedRole.roleName === "EFDV Initiator" && formState?.mpasEFDV)
            ? formState?.ipUser
              ? formState?.ipUser
              : user?.LoginId
            : "",
          
      }));
  }, [ selectedRole?.roleName , formState?.mpasEFDV]);
  const handleZoomout = () => {
    setDimension({
      height: initialHeight,
      width: initialWidth,
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleDNOpen = () => {
    setOpenForDN(true);
  };
  const handleDNClose = () => {
    setOpenForDN(false);
    setdnVendorDetail((dnVendorDetail) => ({
      ...dnVendorDetail,
      dnVendorDetail_List: [],
    }));
  };

  

  const handleClose = () => {
    setOpen(false);
    // setSearch_val("");
    // setTemparary_PoDetail((temparary_PoDetail) => ({
    //   ...temparary_PoDetail,
    //   invoicePORef_List: [],
    // }));
  };
  function areObjectsEqual(obj1, obj2) {
    return (
      obj1.POItem === obj2.POItem &&
      obj1.PONumber === obj2.PONumber &&
      obj1.RefDoc === obj2.RefDoc &&
      obj1.DN_NO === obj2.DN_NO
    );
  }
  const submitPopup = () => {
    // setFormState((formState) => ({
    //   ...formState,
    //   invoicePORef_List: [
    //     ...temp_ActualPoDetail.invoicePORef_List,
    //     ...selected_PoRec.invoicePORef_List,
    //   ],
    // }));

    // add the selected po records from pop up to main table
    let filteredData = temparary_PoDetail.invoicePORef_List.filter(
      (data) => data.selected === true
    );

    let newArray = filteredData.concat(
      temp_ActualPoDetail.invoicePORef_List.filter(
        (item1) => !filteredData.some((item2) => areObjectsEqual(item1, item2))
      )
    );
    // filteredData = [...temp_ActualPoDetail.invoicePORef_List, ...filteredData];

    setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
      ...temp_ActualPoDetail,
      invoicePORef_List: newArray,
    }));
    checkBal(newArray);
    handleClose();
    // setSearch_val("");
    // setTemparary_PoDetail((temparary_PoDetail) => ({
    //   ...temparary_PoDetail,
    //   invoicePORef_List: [],
    // }));
  };
  const [multiValLoading, setMultiValLoading] = useState(false);

  const [successMessage, setSuccessMessage] = useState("");
  const [Post, setPost] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [specialCharError, setSpecialCharError] = useState(false);
  const [specialCharErrorMsg, setSpecialCharErrorMsg] = useState("");
  const multiVal = async (e) => {
    setSearch_val(e.target.value);
    setMultiValLoading(true);
    temparary_PoDetail.invoicePORef_List = [];
    const chunks = e.target.value.split(" ");
    const chunkedData = [];
    for (let i = 0; i < chunks.length; i += 20) {
      chunkedData.push(chunks.slice(i, i + 20));
    }

    let config = {};
    for (let j = 0; j < chunkedData.length; j++) {
      const chunk = chunkedData[j];
      if (po_dn_State === "PO") {
        config = {
          method: "get",
          url: `${process.env.REACT_APP_API_URL}/sap-endpoint/get-multiple-po-data/${chunk}`,
          // params: data,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            "Content-Type": "application/json",
          },
        };
      } else {
        let d = {};
        if (formState?.isLogistics) {
          d = {
            po_no:
              formState?.invoice_Type === "ITN"
                ? chunk.join(",").replace(/,/g, " ")
                : "",
            dn_no:
              formState?.invoice_Type === "DN"
                ? chunk.join(",").replace(/,/g, " ")
                : "",
          };
        } else {
          d = {
            po_no: "",
            dn_no: chunk.join(",").replace(/,/g, " "),
          };
        }
        config = {
          method: "POST",
          url: `${process.env.REACT_APP_API_URL}/sap-endpoint/GetMultipleDNData_v1`,
          // params: data,
          data: d,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            "Content-Type": "application/json",
          },
        };
      }

      await axios(config)
        .then(function (response) {
          let isDifferentVendor = false;
          let diffPOS = "";
          const parsed =
            po_dn_State === "PO" ? response?.data : JSON.parse(response?.data);

          parsed.forEach(function (i, k) {
            if (i != undefined && (i.DN_NO == undefined || i.DN_NO == ""))
              i.DN_NO = i.RefDocNo;
          });

          if (parsed.length > 0) {
            var _vendor = parsed.filter(
              (i) =>
                i.Vendor_Code != "" && i.Vendor_Code != formState.vendor_Code
            );
            if (_vendor.length == 0) {
              formState.vendor_Code = parsed[0].Vendor_Code;
              formState.vendor =
                parsed[0].Vendor_Code + " - " + parsed[0].Vendor_Name;
              formState.po_Date = parsed[0].DOC_DATE;
              formState.plant_Code = parsed[0].PLANT_CODE;
            } else if (_vendor.length > 0) {
              isDifferentVendor = true;
              diffPOS = _vendor
                .map((i) => i.PONumber)
                .filter(function (value, index, self) {
                  return self.indexOf(value) == index;
                })
                .toString();
            }
          }
          if (parsed.length > 0) {
            const invoicePORef_List = parsed?.filter(
                 (i) =>
                   i.Vendor_Code === "" || i.Vendor_Code === formState.vendor_Code
               )?.map((item, index) => ({
              id: index,
              AssetNumber: item.AssetNumber,
              BALANCE_QTY: item.BALANCE_QTY,
              BALANCE_VAL: item.BALANCE_VAL,
              COND_COUNT: item.COND_COUNT,
              COND_ST_NO: item.COND_ST_NO,
              Currency: item.Currency,
              DIST_IND: item.DIST_IND,
              DN_NO: item.DN_NO,
              DOC_DATE: item.DOC_DATE,
              DOC_YEAR: item.DOC_YEAR,
              DelivUnit: item.DelivUnit,
              Dlvqty: item.Dlvqty,
              // INPUT_QTY: Number(item?.Quantity) - Number(item.INVOICE_QTY),
              // INPUT_VAL: Number(item?.Val_Loccur) - Number(item.INVOICE_VAL),
              INPUT_QTY: Number(item?.BALANCE_QTY),
              INPUT_VAL: Number(item?.BALANCE_VAL),
              INVOICE_QTY: item.INVOICE_QTY,
              INVOICE_VAL: item.INVOICE_VAL,
              KSCHL: item.KSCHL,
              ORDER_QTY: item.ORDER_QTY,
              ORDER_UNIT: item.ORDER_UNIT,
              POItem: item.POItem,
              POItemText: item.POItemText,
              PONumber: item.PONumber,
              Plant: item.Plant,
              uniT_PRICE : item.UNIT_PRICE, 
              Poqty: item.Poqty,
              Quantity: item.Quantity,
              RefDoc: item.RefDoc,
              RefDocIT: item.RefDocIT,
              RefDocNo: item.RefDocNo,
              RefDocNoLong: item.RefDocNoLong,
              SEQ_NO: item.SEQ_NO,
              SHEET_ITEM: item.SHEET_ITEM,
              SHEET_NO: item.SHEET_NO,
              SO_ITEM: item.SO_ITEM,
              SO_NO: item.SO_NO,
              VText: item.VText,
              Val_Gr_Loc: item.Val_Gr_Loc,
              Val_Iv_Loc: item.Val_Iv_Loc,
              Val_Loccur: item.Val_Loccur,
              Vendor_Code: item.Vendor_Code,
              Vendor_Name: item.Vendor_Name,
              DOC_DATE: item.DOC_DATE,
              invoice_Id: Number(invoicePayload?.Invoice_id),
              selected: formState?.isLogistics ? true : false,
            }));

            temparary_PoDetail.invoicePORef_List = [
              ...temparary_PoDetail.invoicePORef_List,
              ...invoicePORef_List,
            ];

            // setTemparary_PoDetail(() => ({
            //   invoicePORef_List: [
            //     ...temparary_PoDetail.invoicePORef_List,
            //     ...invoicePORef_List,
            //   ],
            // }));
            if(isDifferentVendor){
              setIsPOError((isPOError) => ({
              ...isPOError,
              isPOError: true,
              pomessage:
                "PO Number(s): " +
                diffPOS +
                " are from other vendors, please select PO of the same vendor",
            }));
            }else{
            setIsPOError((isPOError) => ({
              ...isPOError,
              isPOError: false,
              pomessage: "",
            }));}
          } else {
            setTemparary_PoDetail(() => ({
              invoicePORef_List: [],
            }));
            setIsPOError((isPOError) => ({
              ...isPOError,
              isPOError: true,
              pomessage:
                "PO Number(s): " +
                diffPOS +
                " are from other vendors, please select PO of the same vendor",
            }));
          }

          // setMultiValLoading(false);
        })
        .catch(function (error) {
          setMultiValLoading(false);
        });
    }
    const str = JSON.stringify(temparary_PoDetail.invoicePORef_List);
    const tempParse = JSON.parse(str);
    setTemparary_PoDetail(() => ({
      invoicePORef_List: tempParse,
    }));
    setMultiValLoading(false);
  };

  const filterByGrn = (grn) => {
    const filteredByGrn = temparary_PoDetail.invoicePORef_List.filter(
      (x) => x.RefDoc === grn
    );
  };
  const [searchWithPo, setSearchWithPo] = useState(true);
  const [invoicedelete, setInvoiceDelete] = useState("");
  const [Autoskip, setAutoSkip] = useState(false);
  useEffect(()=>{
  // (formState?.invoice_Type === "Final Settlement - Distributor" && formState?.loamReviewer?.length !== 0) ||
  if (
  typeof successMessage === 'number' &&
  (
    (formState?.invoice_Type !== "Final Settlement - Distributor" && !invoiceId && formState?.loamReviewer?.length !== 0)
  )
) {
      setErrorMessage("")
      changeInvoiceStatus(
        successMessage,
      'SendToReviewerFromIR',
        setConfirmationModal,
        setAttachInvoiceLoading, 
  setSuccessMessage,
  setErrorMessage,
     navigate,
      formState.comments,
      formState.aditional_Comments,
      setPost
    );
    (typeof successMessage == 'number' || successMessage=='Invoice has been Submitted Successfully') && updateLoamReviewer(
      successMessage,
      formState,
      setSuccessMessage,
      setErrorMessage,
      setLoading,
      ()=>{},
      navigate,
      setAllowToProceed
    );
    }
  },[successMessage])
  const deleteAttachmentFunc = () => {
    const data = {
      Id: invoicedelete?.id,
    };

    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
      const deleteId = invoicedelete?.id;
        const final = attachmentURLList
          .map(item => {
            if (Array.isArray(item)) {
              // filter inside nested array
              return item.filter(inner => inner?.id !== deleteId);
            }
            // handle plain object
            return item?.id !== deleteId ? item : null;
          })
          .filter(Boolean); // remove nulls and empty entries
        const files = formState.additionalDocIds.filter(
          (x, i) => x.path !== invoicedelete?.path
        );
        const filteredAttachmentsSR = formState?.attachment_Sr.filter(
          (x) => x !== invoicedelete?.id
        );
        setAttachmentURLList(final);
        setFormState((formState) => ({
          ...formState,
          additionalDocIds: files,
          attachment_Sr: filteredAttachmentsSR,
        }));

        // formState.additionalDocIds.map((f, index) => {
        //   const s = f?.path?.split("\\");
        //   const ss = s[s.length - 1];
        //   // const files = formState.additionalDocIds.filter((x, i) => {
        //   //   const n = x?.path
        //   //   const nn = n[n.length - 1];
        //   //   return nn !== ss;
        //   // });

        // });
      // --- FIX: Update the preview if the deleted file was being previewed ---
      if (attachmentURL && attachmentURL.id === deleteId) {
        if (final.length > 0) {
          setAttachmentURL(final[0]);
        } else {
          setAttachmentURL("");
        }
      }
        setdeleteLoader(false);
        setOpenWarningBox(false);
        setInvoiceDelete('');
        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response.data);
      });
  };

  const deleteInvoice = () => {
    const data = {
      Id: formState?.invoice_attachment?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
               const final = attachmentURLList?.filter(
  (item) => item?.id !== formState?.invoice_attachment?.id
);
        // const final = attachmentURLList?.filter(function (item) {
        //   return ![formState.invoice_attachment?.path].includes(item);
        // });
const filteredAttachmentsSR = formState?.attachment_Sr.filter(
  (x) => x !== formState?.invoice_attachment?.id
);
        // const filteredAttachmentsSR = formState?.attachment_Sr.filter(
        //   (x) => x !== invoicedelete?.id
        // );
        setAttachmentURLList(final);
        setFormState((formState) => ({
          ...formState,
          invoice_attachment: "",
          attachment_Sr: filteredAttachmentsSR,
        }));
        invoice_attachmentRef.current.value = null;
        setOpenWarningBox(false);
        setdeleteLoader(false);
        setSuccessMessage(response.data);
      // --- FIX: Update the preview attachmentURL ---
      if (final.length > 0) {
        setAttachmentURL(final[0]);
      } else {
        setAttachmentURL("");
      }
      // --- END FIX ---
      })
      .catch(function (error) {
        setErrorMessage(error.response.data);
      });
  };
  // const [vendorCode, setVendorCode] = useState([]);
  const changeHandler = (e) => {
    const { name, value } = e.target;

    // if (name === "invoice_Amount") {
    //   // Remove existing commas and parse the value as a number
    //   const cleanedValue = String(value).replace(/,/g, "").replace(".", ",");
    //   // const cleanedValue = value.replace(/,/g, "");

    //   // Check if the cleaned value is a valid number
    //   if (cleanedValue.trim() !== "" && !isNaN(cleanedValue)) {
    //     const numericValue = parseFloat(cleanedValue);
    //     const formattedValue = numericValue.toLocaleString("en-US", {
    //       minimumFractionDigits: 0,
    //       maximumFractionDigits: 3,
    //     });

    //     setFormState((formState) => ({
    //       ...formState,
    //       [name]: formattedValue,
    //     }));
    //   } else {
    //     // If the input is not a valid number, update the state with an empty string
    //     setFormState((formState) => ({
    //       ...formState,
    //       [name]: "",
    //     }));
    //   }
    // }
    // if (name == "invoice_Amount") {
    //   const decimalCount = (value?.split(".")[1] || []).length;
    //   setFormState((formState) => ({
    //     ...formState,
    //     [name]: decimalCount > 3 ? Number(value).toFixed(3) : value,

    //     // [name]: !isNaN(value) && Number(value) % 1 !== 0 ? Number(value).toFixed(3) : value,
    //   }));
    // } else {
    //   setFormState((formState) => ({
    //     ...formState,
    //     [name]: value,
    //   }));
    // }
 

    if (name === "invoice_Amount") {
      // Remove non-numeric characters
      let cleanedValue = value.replace(/[^\d.]/g, "");
      const decimalIndex = cleanedValue.indexOf(".");
      if (decimalIndex !== -1) {
        cleanedValue = cleanedValue.substring(0, decimalIndex + 4);
      }

      // Check if the input is a valid number
      if (/^\d*\.?\d*$/.test(cleanedValue) || cleanedValue === "") {
        // Apply formatting logic for integers and decimals
        const formattedValue =
          cleanedValue === ""
            ? cleanedValue
            : cleanedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas for thousands

        setFormState((prevState) => ({
          ...prevState,
          [name]: cleanedValue,
          [`${name}_formatted`]: formattedValue,
          // [name]: formattedValue,
        }));
        setInvoice_Amount_formatted(formattedValue);
      }
    } else {
      // If the input is not a valid number, update the state with the original value
      setFormState((formState) => ({
        ...formState,
        [name]: value,
      }));
    }
    if (name === "invoice_Type") {
      if (
        value === "DES" ||
        value === "Pre Approved Payment" ||
        value === "Credit Note"
      ) {
        setFormState((formState) => ({
          ...formState,
          skipTaxStep: true,
          taxTeam: "",
        }));
        setAutoSkip(false);
      } else {
        setFormState((formState) => ({
          ...formState,
          skipTaxStep: Autoskip ? true : false,
        }));
      }

      if (
        value === "DES" ||
        value === "Pre Approved Payment" ||
        value === "Credit Note" || 
        value === "Final Settlement - Distributor"
      ) {
      
        setFormState((formState) => ({
          ...formState,
          skipTaxStep: true,
          taxTeam: "",
        }));
        setAutoSkip(false);

        if( value === "Final Settlement - Distributor"){
        setFormState((formState) => ({
          ...formState,
           skipTaxStep: true,
          taxTeam: "",
          dept_coordinator : ""
        }));
        }
      } else {
        setFormState((formState) => ({
          ...formState,
          skipTaxStep: Autoskip ? true : false,
        }));
      }
      // getTaxUserForNonPo(value, setTaxuser, setFormState); this is for tax user drop down on invoice type selection Low Value
    }
    if (name === "pO_No") {
      // type in po text field
      setTypeByPo(true);

      // for other than logistic invoices

      // if( !formState.isLogistics &&  !formState.invoice_Type === "DN" && !formState.invoice_Type === "ITN"){
      if (!formState.isLogistics) {
        setSearchWithPo(true);
        // getVendorByPO(value, "vendor_Code", setFormState);
      }
    }
    if (name === "delv_Note_No") {
      if (value) {
        setTypeByDN(true);
        setSearchWithPo(false);
      } else {
        // we do it true because when delv_Note_No field goes empty then it search with po...
        setSearchWithPo(true);
      }

      // getDNDetails(
      //   value,
      //   setPoTableLoading,
      //   setTemp_ActualPoDetail,
      //   invoicePayload?.Invoice_id,
      //   formState,
      //   setCopyOfPoDetail
      // );
    }
    if (name === "demandType") {
      // if (value !== "Spare Parts" && value !== "Material") {
      //   setFormState((formState) => ({
      //     ...formState,
      //     pO_No: "",
      //   }));
      //   setPoBasedState("Non-PO");
      // } else {
      //   setPoBasedState("PO");
      // }
      if (value === "Spare Parts" || value === "Material") {
        setPoBasedState("PO");
      } else {
        if (value === "Deposit") {
          setFormState((formState) => ({
            ...formState,
            pO_No: "",
            isPSID: false,
            psid: "",
          }));
        } else if (value === "Samples") {
          setFormState((formState) => ({
            ...formState,
            pO_No: "",
          }));
        }
        setPoBasedState("Non-PO");
      }
    }
  };
  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      (selectedRole?.roleName === "Import" &&
        formState.demandType === "Deposit") ||
      (selectedRole?.roleName === "Import" &&
        formState.demandType === "Samples")
    ) {
      show = false;
    }
    // if (
    //   selectedRole?.roleName === "Import" &&
    //   formState.demandType === "Samples"
    // ) {
    //   show = false;
    // }
    return show;
  };
  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = true;
    }

    return show;
  };
  useEffect(() => {
    if (search_val) {
      const value = {
        target: {
          value: search_val,
        },
      };
      multiVal(value);
    }
  }, [po_dn_State]);

  useEffect(() => {
    if (selectedRole?.roleName === "HR") {
      setPoBasedState("Non-PO");
    }
  }, []);
  // to upload the file and get path.
  const poBasedHandler = (e) => {
    setPoBasedState(e.target.value);
    setFormState((formState) => ({
      ...formState,
      isDeptCordinator: false,
      dept_coordinator:
        e.target.value === "PO"
          ? ""
          : selectedRole?.roleName === "IR"
          ? user?.LoginId
          : "",
      pO_Based: e.target.value === "PO" ? true : false,
      vendor_Code: "",
      dueOn : "",
      grn_No: "",
      pO_No: e.target.value === "PO" ? formState.pO_No : "",
    }));
  };
  // const invoiceCatogeryHandler = (e) => {
  //   setInvoiceCategory(e.target.value);
  // };
  useEffect(() => {
    if (state.roleName === "Department Coordinator") {
      setPoBasedState("Non-PO");
      setFormState((formState) => ({
        ...formState,
        // isDeptCordinator: true,
        // dept_coordinator: user?.LoginId,
        pO_Based: false,
      }));
    }
  }, [state]);
  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue?.roleName === "I2P Initiator" ? true : false,
      isHR: newValue?.roleName === "HR" ? true : false,
      isPCDV: newValue?.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue?.roleName === "Import" ? true : false,
      isLogistics: newValue?.roleName === "Logistic" ? true : false,
      isDeptCordinator:
        newValue?.roleName === "Department Coordinator" ? true : false,
    }));
    setSelectedRole(newValue);
  };

  const calculateTotalGLAmount = () => {
    const totalGLAmount = formState?.invoice_Accounts_list?.reduce(
      (accumulator, currentValue) => {
        const amountWithoutCommas = String(currentValue?.amount).replace(
          /,/g,
          ""
        );
        const numericAmount = Number(Number(amountWithoutCommas)?.toFixed(2));

        return accumulator + numericAmount;
        // return accumulator + Number(Number(currentValue?.amount)?.toFixed(2));
      },
      0
    );
    return totalGLAmount;
  };

  useEffect(() => {
    if (selectedRole?.roleName === "HR") {
      const totalAmount = calculateTotalGLAmount();
      setFormState((formState) => ({
        ...formState,
        invoice_Amount: totalAmount?.toFixed(2).toString(),
      }));
      setInvoice_Amount_formatted(totalAmount?.toLocaleString());
    }
  }, [formState?.invoice_Accounts_list]);
  const confirmedForInvoiceCreation = () => {
    // let totalAmount = 0;
    // if (selectedRole?.roleName === "HR") {
    //   totalAmount = formState.invoice_Accounts_list.reduce(
    //     (accumulator, currentValue) => {
    //       return accumulator + Number(currentValue.amount);
    //     },
    //     0
    //   );
    // }
    const totalGLAmount = calculateTotalGLAmount();
    if (selectedRole?.roleName === "IR") {
      let inputVal = true;
      let inputQty = true;
      for (let i = 0; i < temp_ActualPoDetail?.invoicePORef_List?.length; i++) {
        const item = temp_ActualPoDetail?.invoicePORef_List[i];
        if (item.selected === true) {
          if (item?.INPUT_QTY <= 0) {
            inputQty = false;
          }
          if (item?.INPUT_VAL <= 0) {
            inputVal = false;
          }
        }
      }
      const isSelected = temp_ActualPoDetail?.invoicePORef_List?.findIndex(
        (x) => x.selected === true
      );

      if (formState?.isReturn || formState?.isDelete || formState?.isQuick) {
        changeInvoiceStatus(
          formState.invoice_Id,
          statusForPayload,
          setConfirmationModal,
          setAttachInvoiceLoading,
          setSuccessMessage,
          setErrorMessage,
          navigate,
          formState.comments,
          formState.aditional_Comments,
          setPost
        );
      } else if (
        formState?.pO_Based &&
        isSelected == "-1" &&
        !formState?.isBuyerPR
      ) {
        setErrorMessage("Please select GRN");
        setOpenProceedBtn(false);
      } else if (!inputVal && !formState?.isBuyerPR) {
        setErrorMessage("Input Value can't be 0 in PO Table");
        setOpenProceedBtn(false);
      } else if (!inputQty && !formState?.isBuyerPR) {
        setErrorMessage("Input Quantity can't be 0 in PO Table");
        setOpenProceedBtn(false);
      } else {

    
        createInvoiceByIR(
          formState,
          temp_ActualPoDetail,
          setFormState,
          poBasedState,
          setErrorMessage,
          setSuccessMessage,
          setAttachInvoiceLoading,
          setOpenProceedBtn,
          navigate,
          rolesNavigate,
          searchWithPo,
          buyerStatus,
          PRInitiatorStatus,
          setPost
        );
       
      }
    } else if (selectedRole?.roleName === "EFDV Initiator") {
      if (formState?.isReturn || formState?.isDelete || formState?.isQuick) {
        changeInvoiceStatus(
          formState.invoice_Id,
          statusForPayload,
          setConfirmationModal,
          setAttachInvoiceLoading,
          setSuccessMessage,
          setErrorMessage,
          navigate,
          formState.comments,
          formState.aditional_Comments,
          setPost
        );
      }else{
      createNewInvoiceByEFDV(
        formState,
        setFormState,
        setErrorMessage,
        setSuccessMessage,
        setAttachInvoiceLoading,
        setOpenProceedBtn,
        navigate,
        setPost
      );}
    } else if (formState?.isDelete) {
      changeInvoiceStatus(
        formState.invoice_Id,
        statusForPayload,
        setConfirmationModal,
        setAttachInvoiceLoading,
        setSuccessMessage,
        setErrorMessage,
        navigate,
        formState.comments,
        formState.aditional_Comments,
        setPost
      );
    }else if (selectedRole?.roleName === "I2P Initiator" && formState?.isDelete) {
      changeInvoiceStatus(
        formState.invoice_Id,
        statusForPayload,
        setConfirmationModal,
        setAttachInvoiceLoading,
        setSuccessMessage,
        setErrorMessage,
        navigate,
        formState.comments,
        formState.aditional_Comments,
        setPost
      );
    }
    else {
      if (selectedRole?.roleName === "Import" && loamApprover) {
        setErrorMessage("Loam Approver user configuration is missing");
      }
      // else if (
      //   selectedRole?.roleName === "HR"
      //   // &&
      //   // totalGLAmount?.toFixed(2) !== Number(formState.invoice_Amount)
      // ) {
      //   console.log("totalGLAmount", totalGLAmount);
      //   console.log("formState.invoice_Amount", formState.invoice_Amount);
      //   console.log("totalGLAmount?.toFixed(2)", totalGLAmount?.toFixed(2));
      //   console.log(
      //     "Difference",
      //     totalGLAmount?.toFixed(2) !== Number(formState.invoice_Amount)
      //   );
      //   // setErrorMessage("GL Entries amount must be equal to invoice amount.");
      //   // setOpenProceedBtn(false);
      // }
      else {

        let parallel  ;
      if(isParallel == "Sequential"){
       parallel = false
      }
      if(isParallel == "Parallel"){
        parallel = true
      }

      const updatedFormState = {
        ...formState , 
        isParallel: parallel,
        isInitiator:(selectedRole?.roleName === "Department Coordinator" && (formState.invoice_Type=='DES' ||  formState.invoice_Type=='Rent'))?false:formState.isInitiator,
        isDeptCordinator: (selectedRole?.roleName === "Department Coordinator" && (formState.invoice_Type=='DES' || formState.invoice_Type=='Rent'))?true:false,
        skipTaxStep:(selectedRole?.roleName === "Department Coordinator" && (formState.invoice_Type=='DES' || formState.invoice_Type=='Rent'))?true:formState.skipTaxStep,
        dept_coordinator:(selectedRole?.roleName === "Department Coordinator" && (formState.invoice_Type=='DES' || formState.invoice_Type=='Rent'))?user?.LoginId:formState.dept_coordinator,
      }

        createNewInvoice(
          updatedFormState,
          setFormState,
          poBasedState,
          setErrorMessage,
          setSuccessMessage,
          setAttachInvoiceLoading,
          setOpenProceedBtn,
          navigate,
          rolesNavigate,
          setPost
        );
      }
    }
  };

  const checkBal = (tempArray) => {
    let t = 0;
    let totalItems = tempArray.filter((data) => data.selected === true);
    t = totalItems
      .map((balance) => Number(balance?.inpuT_VAL || balance?.INPUT_VAL))
      .reduce((total, item) => total + item, 0);
    setSelectedTotal(t);
  };
  const validateSpecialCharacters = (text) => {
    return /[!@#$%^&*()_+={}\[\]:;"'<>,?/~\\-`]/.test(text);
  };
  const validateExpenseAccountsList = (expenseAccountsList) => {
    const invalidRows = [];

    expenseAccountsList?.forEach((item, index) => {
      if (validateSpecialCharacters(item.description)) {
        invalidRows.push(index + 1);
      }
    });

    return invalidRows;
  };
  const expenseTableValidation = (Expense_Accounts_list) => {
    let errorRows = [];
    let isError = false;
    if (
      !Array.isArray(Expense_Accounts_list) ||
      Expense_Accounts_list.length === 0
    ) {
      isError = true;
      setErrorMessage("Please Fill Expense Detail.");
    } else {
      Expense_Accounts_list.forEach((item, index) => {
        let missingFields = [];
        if (!item.glAccount?.split("-")[0] || !item.glAccount.includes(" - "))
          missingFields.push("GL Account Details are missing");
        if (item.amount === undefined || Number(item.amount) === 0)
          missingFields.push("Amount");
        if (!item.costCenter?.split("-")[0] && !item.profitCenter)
          missingFields.push("Cost Center or Profit Center");
        if (item.costCenter?.split("-")[0] && !item.costCenterOwnerName)
          missingFields.push("costCenterOwnerName");

        if (missingFields.length > 0) {
          isError = true;
          errorRows.push({ index: index + 1, missingFields });
        }
      });
      return errorRows;
    }
  };

  const hrTableValidation = (invoice_Accounts_list) => {
    let errorRows = [];
    let isError = false;
    if (
      !Array.isArray(invoice_Accounts_list) ||
      invoice_Accounts_list.length === 0
    ) {
      isError = true;
      setErrorMessage("Please Fill GL  Detail.");
    } else {
      invoice_Accounts_list.forEach((item, index) => {
        let missingFields = [];
        if (!item.glAccount?.split("-")[0]) missingFields.push("GL Account");
        if (item.amount === undefined || Number(item.amount) === 0)
          missingFields.push("Amount");
        if (!item.costCenter?.split("-")[0] && !item.profitCenter)
          missingFields.push("Cost Center or Profit Center");
        if (item.costCenter?.split("-")[0] && !item.costCenterOwnerName)
          missingFields.push("costCenterOwnerName");

        if (missingFields.length > 0) {
          isError = true;
          errorRows.push({ index: index + 1, missingFields });
        }
      });
      return errorRows;
    }
  };

  const fcaTableValidation = (FCA_Details) => {
    console.log(FCA_Details, "FCA detailsss")
    let errorRows = [];
    let isError = false;
    if (
       (selectedRole?.roleName === "Department Coordinator" &&
    showGLTable?.showForRENT ) && (!Array.isArray(FCA_Details) ||
      FCA_Details.length === 0)
    ) {
      isError = true;
      setErrorMessage("Please Fill FCA  Detail.");
    } else {
      FCA_Details.forEach((item, index) => {
        let missingFields = [];
      
        if (item.lastRent === undefined || Number(item.lastRent) === 0)
          missingFields.push("Last Rent");
         if (item.newRent === undefined || Number(item.newRent) === 0)
          missingFields.push("New Rent");
             if (item.from === undefined || item.from === '')
          missingFields.push("From");
              if (item.to === undefined || item.to=== '')
          missingFields.push("To");
             if (item.period === undefined || Number(item.period) === 0)
          missingFields.push("Period");




        if (missingFields.length > 0) {
          isError = true;
          errorRows.push({ index: index + 1, missingFields });
        }
      });
      return errorRows;
    }
  };

    const agreementTableValidation = (Agreement_Details) => {
    console.log(Agreement_Details, "FCA detailsss")
    let errorRows = [];
    let isError = false;
    if ( 
           (selectedRole?.roleName === "Department Coordinator" &&
    showGLTable?.showForRENT ) &&
     ( !Array.isArray(Agreement_Details) ||
      Agreement_Details?.length === 0)
    ) {
      isError = true;
      setErrorMessage("Please Fill Agreement  Details.");
    } else {
      Agreement_Details?.forEach((item, index) => {
        let missingFields = [];
      
        if (item.agreementStartDate === undefined || item.agreementStartDate === '')
          missingFields.push("Agreement Start Date");
         if (item.agreementEndDate === undefined || item.agreementEndDate === '')
          missingFields.push("Agreement End Date");
            



        if (missingFields.length > 0) {
          isError = true;
          errorRows.push({ index: index + 1, missingFields });
        }
      });
      return errorRows;
    }
  };
  useEffect(()=>{
    if(formState.invoice_Type==='Rent'){
      const InvoiceAmount=Number(formState?.invoice_Amount)
      const GLAmount=Number(formState?.invoice_Accounts_list[0].amount)
      if(formState?.invoice_Amount>0 && formState?.FCA_Details[0]?.newRentAmount>0 && formState?.invoice_Accounts_list[0]?.amount>0){
      if(InvoiceAmount===formState?.FCA_Details[0]?.newRentAmount && InvoiceAmount===GLAmount){
      setErrorMessage('')
    }else{
      setErrorMessage('Invoice Amount, GL amount and New Rent Amount should be same for Rent Invoice Type')
    }}
    }
  },[formState.invoice_Amount,formState?.FCA_Details[0]?.newRentAmount, formState?.invoice_Accounts_list[0]?.amount])
  const submitHandler = (e, w) => {
    e.preventDefault();

      const containsSpecialChars = validateSpecialCharacters(
        formState.invoice_Desc
      );
  
      const expenseListContainsError = expenseTableValidation(
        formState.Expense_Accounts_list
      );
      const hrGLTableListError = hrTableValidation(
        formState.invoice_Accounts_list
      );

      const fcaTableListError = fcaTableValidation(formState?.FCA_Details)
      const agreementListError = agreementTableValidation(formState?.Agreement_Details)
    const totalMonths = formState.stamp_Duty_Calculations.reduce(
    (sum, row) => sum + (parseFloat(row.noOfMonths) || 0),
    0
  );

  const tenure = parseFloat(formState?.Agreement_Details?.[0]?.tenure || 0);

      const expenseListContainsSpecialChars = validateExpenseAccountsList(
        formState.Expense_Accounts_list
      );
      const { id } = e.nativeEvent.submitter;
      setFormState((formState) => ({
        ...formState,
        isDraft: id === "saveAsDraft",
        buyer:
          id === "SendToBuyer" && !formState.buyer
            ? poCreated.POCreatedForBuyer
            : formState.buyer,
        prInitiator:
          id === "SendToPRInitiator" && !formState.prInitiator
            ? poCreated.PRCreatedForInitiator
            : formState.prInitiator,
      }));
  
      const threeWayMismatch = [];
      if (selectedRole?.roleName === "IR" && !formState?.isBuyerPR) {
        temp_ActualPoDetail?.invoicePORef_List?.forEach((item) => {
          if (parseInt(item.INPUT_VAL) > parseInt(item.BALANCE_VAL)) {
            //if input amt is greater than available amt
            threeWayMismatch.push({
              GRN: item.RefDoc,
              Item: item.POItem,
              Mismatch: "Invoice amount is greater than available amount.",
            });
  
            // status = "SendToBuyer";
          }
          if (parseInt(item.INPUT_QTY) > parseInt(item.BALANCE_QTY)) {
            //if input qty is greater than available qty
            threeWayMismatch.push({
              GRN: item.RefDoc,
              Item: item.POItem,
              Mismatch: "Invoice quantity is greater than available quantity.",
            });
  
            //status = "SendToPRInitiator";
            // status = "SendToBuyer";
          }
          if (item.selected == true) {
            var _rate = Math.round(
              Number(item.BALANCE_VAL) / Number(item.BALANCE_QTY)
            );
            var _invoiceRate = Math.round(
              Number(item.INPUT_VAL) / Number(item.INPUT_QTY)
            );
            if (_rate !== _invoiceRate) {
              threeWayMismatch.push({
                GRN: item.RefDoc,
                Item: item.POItem,
                Mismatch: "Invoice ratio is not equal to available ratio.",
              });
            }
          }
        });
  
        setThreeWayMismatchItems(threeWayMismatch);
      }
      if (threeWayMismatch.length > 0) {
        // setBuyerStatus(true);
        // setFormState((formState) => ({
        //   ...formState,
        //   buyer: poCreated.POCreatedForBuyer ? poCreated.POCreatedForBuyer : "",
        //   prInitiator: "",
        // }));
        setThreeWayMismatchModal(true);
      } else if (
        formState?.isReturn ||
        formState?.isDelete ||
        formState?.isQuick
      ) {
        setConfirmationModal(true);
      } else {
        if (containsSpecialChars) {
          setSpecialCharError(true);
          setSpecialCharErrorMsg(
            "Invoice Description should not contain any Special character"
          );
        } else if (
          expenseListContainsError?.length > 0 &&
          selectedRole?.roleName === "EFDV Initiator"
        ) {
          let errorMessage = `Please fill Expense Detail required fields and ensure Amount is not zero:\n`;
          expenseListContainsError.forEach(({ index, missingFields }) => {
            errorMessage += `Row ${index}: ${missingFields.join(", ")}\n`;
          });
  
          setErrorMessage(errorMessage);
        }
        
        else if (
          fcaTableListError?.length > 0 &&
          
           selectedRole?.roleName === "Department Coordinator" &&
    showGLTable?.showForRENT 
        ) {
          console.log(fcaTableListError , "fcaTableListError")
          let errorMessage = `Please Fill Payment Details:\n`;
          fcaTableListError.forEach(({ index, missingFields }) => {
            errorMessage += `Row ${index}: ${missingFields.join(", ")}\n`;
          });
          setErrorMessage(errorMessage);
        }

         else if (
          agreementListError?.length > 0 &&
          
           selectedRole?.roleName === "Department Coordinator" &&
    showGLTable?.showForRENT 
        ) {
       
          let errorMessage = `Please Fill Agreement Details:\n`;
          agreementListError.forEach(({ index, missingFields }) => {
            errorMessage += `Row ${index}: ${missingFields.join(", ")}\n`;
          });
          setErrorMessage(errorMessage);
        }             
        else if (
          hrGLTableListError?.length > 0 &&
          selectedRole?.roleName === "HR"
        ) {
          let errorMessage = `Please Fill GL Detail required fields:\n`;
          hrGLTableListError.forEach(({ index, missingFields }) => {
            errorMessage += `Row ${index}: ${missingFields.join(", ")}\n`;
          });
          setErrorMessage(errorMessage);
        } else if (expenseListContainsSpecialChars.length > 0) {
          const errorRowsString = expenseListContainsSpecialChars.join(", ");
          setSpecialCharError(true);
          setSpecialCharErrorMsg(
            `Invoice Description at row ${errorRowsString} should not contain any Special character`
          );
        } else {
          setSpecialCharErrorMsg("");
          setSpecialCharError(false);

          const buyerToCheck = id === "SendToBuyer" ? formState.buyer : "";
          const prInitiatorToCheck = id === "SendToPRInitiator" ? formState.prInitiator : "";

          // Show popup if either is non-empty and not a 36-char GUID

          if(formState.isProceed){
            setErrorMessage("")
            setOpenProceedBtn(true)
          }else if(reviewer==true){
            (!reviewerModal && reviewer && formState.loamReviewer.length!==0) && setOpenProceedBtn(true);
            (!reviewerModal && reviewer && !formState.isProceed && formState.loamReviewer.length!==0) && setErrorMessage("");
            (!reviewerModal && reviewer && !formState.isProceed && formState.loamReviewer.length==0) && setErrorMessage("Please Select Reviewer");
          }else{
            if (
            (id === "SendToBuyer" && (buyerToCheck.length !== 36)) ||
            (id === "SendToPRInitiator" && (prInitiatorToCheck.length !== 36))
          ) {
            setErrAlertMessage("We cannot proceed this request. Buyer/PR Initiator doesn't exists. Please contact Administrator.");
            setAlertMessageForPO(true);
            return;
          }else{
            !reviewerModal && setOpenProceedBtn(true);
            setErrorMessage("");
          }
          }
  
  
          // Continue with form submission logic here
        }
      }
  };
  useEffect(() => {
    getVendorDetail(formState?.vendor_Code, setVendorList, () => {});
    }, [formState?.vendor_Code]);
  const [temporaryPoDetailTotal, setTemporaryPoDetailTotal] = useState({
    grnQty: 0,
    grnAmount: 0,
    invoiceQty: 0,
    invoiceAmount: 0,
  });
  useEffect(() => {
    let grnQty = 0;
    let grnAmount = 0;
    let invoiceQty = 0;
    let invoiceAmount = 0;

    temparary_PoDetail?.invoicePORef_List?.forEach((item) => {
      if (item?.selected) {
        grnQty += Number(item?.Quantity); //grn qty
        grnAmount += Number(item?.Val_Loccur); // grn amount
        invoiceQty += Number(item?.INPUT_QTY); // grn qty
        invoiceAmount += Number(item?.INPUT_VAL); // grn amount
      }
    });
    setTemporaryPoDetailTotal((temporaryPoDetailTotal) => ({
      ...temporaryPoDetailTotal,
      grnQty: grnQty,
      grnAmount: grnAmount,
      invoiceQty: invoiceQty,
      invoiceAmount: invoiceAmount,
    }));
  }, [temparary_PoDetail.invoicePORef_List]);

  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    getRefrenceDataList(
      "PCDVSegments",
      "PCDVSegments",
      () => {},
      setMultipleData
    );

    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );

    getRefrenceDataList(
      "LoamApprover", 
      "loamApprover",
      setFormState,
      setMultipleData
    )
  
    if (invoicePayload && role) {
      getInvoiceByInvoiceIdAndRoleId(
        invoicePayload,
        role,
        setFormState,
        setPoBasedState,
        setStatusForPayload,
        changeHandler
      );
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id,
        setcount
      );
    }
    if (
      edit === "false" ||
      status === "SendToIRFromBuyer" ||
      status === "SendToIRFromLogistics" ||
      status === "SendToIRFromIP" ||
      status === "SendToIRFromTaxTeam" ||
      status === "SendToIRFromSupervisor" ||
      status === "SendToHrFromLineManager" ||
      status === "SendToHrFromSharedServices" ||
      status === "SendToHrFromDirectorHR" ||
      status === "SendToHRFromIP" ||
      status === "SendToHrFromIP" ||
      status === "DraftByHr" ||  
      formState?.isPCDV
    ) {
      if (formState?.isPCDV) {
        getAllInvoiceDetailByInvoiceIdForImport(
          setFormState,
          setMultipleData,
          // () => {},
          invoicePayload?.Invoice_id,
          () => {},
          () => {},
          () => {}
        );
      } else {
        getAllInvoiceDetailByInvoiceIdV2(
          setFormState,
          setMultipleData,
          // () => {},
          invoicePayload?.Invoice_id,
          () => {},
          () => {},
          "HR",
          () => {}
        );
      }
    }
    getUserRoles(
      setRoles,
      setRolesLoading,
      () => {},
      () => {},
      () => {},
      () => {},
      setRolesNavigate
    );
  }, []);

  useEffect(() => {
    setIsPOError((state) => ({
      ...state,
      isPOError: false,
    }));
  }, [search_val]);

  // useEffect(()=>{
  //   if (invoicePayload && role){
  //   getTaxUserForNonPo(formState?.invoice_Type, setTaxuser, setFormState);

  //   }

  // },[invoicePayload,role]);
  // to resolve the issue for SendToIRFromBuyer in below 2 useEffect

  useEffect(() => {
    if (status === "SendToIRFromLogistics" || status === "SendToIRFromBuyer") {
      if (formState.pO_No) {
        setPreData((pre) => ({
          ...pre,
          pO_No: formState.pO_No,
          firstTime: false,
        }));
      } else {
        setFormState((pre) => ({
          ...pre,
          pO_No: preData.pO_No,
        }));
      }
    }
  }, [formState.pO_No]);

  useEffect(() => {
    if (status === "SendToIRFromLogistics" || status === "SendToIRFromBuyer") {
      if (formState.delv_Note_No) {
        setPreData((pre) => ({
          ...pre,
          delv_Note_No: formState.delv_Note_No,
        }));
      } else {
        setFormState((pre) => ({
          ...pre,
          delv_Note_No: preData.delv_Note_No,
        }));
      }
    }
  }, [formState.delv_Note_No]);

  useEffect(() => {
    if (formState?.invoicePORef_List?.length > 0) {
      const newData = [];
      for (let i = 0; i < formState?.invoicePORef_List?.length; i++) {
        const x = formState?.invoicePORef_List[i];
        const obj = {
          selected: true,
          DN_NO: x.dN_NO,
          Val_Loccur: x.val_Loccur,
          AssetNumber: x.assetNumber,
          BALANCE_QTY: x.balancE_QTY,
          BALANCE_VAL: x.balancE_VAL,
          COND_COUNT: x.conD_COUNT,
          COND_ST_NO: x.conD_ST_NO,
          Currency: x.currency,
          DIST_IND: x.disT_IND,
          DN_NO: x.dN_NO,
          DOC_YEAR: x.doC_YEAR,
          DOC_DATE: x.doc_Date,
          DelivUnit: x.delivUnit,
          Dlvqty: "",
          INPUT_QTY: x.inpuT_QTY,
          INPUT_VAL: x.inpuT_VAL,
          INVOICE_QTY: x.invoicE_QTY,
          INVOICE_VAL: x.invoicE_VAL,
          KSCHL: x.kschl,
          ORDER_QTY: x.ordeR_QTY,
          ORDER_UNIT: x.ordeR_UNIT,
          POItem: x.poItem,
          POItemText: x.poItemText,
          PONumber: x.poNumber,
          Plant: x.plant,
          UNIT_PRICE : x.uniT_PRICE,
          Poqty: "",
          Quantity: x.quantity,
          RefDoc: x.refDoc,
          RefDocIT: x.rEF_DOC_IT,
          RefDocNo: x.reF_DOC_NO,
          RefDocNoLong: x.reF_DOC_NO_LONG,
          SEQ_NO: x.seQ_NO,
          SHEET_ITEM: x.sheeT_ITEM,
          SHEET_NO: "",
          SO_ITEM: x.sO_ITEM,
          SO_NO: x.sO_NO,
          VText: x.vText,
          invoice_Id: x.invoicePayload?.Invoice_id,
        };
        newData.push(obj);
      }
      setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
        ...temp_ActualPoDetail,
        invoicePORef_List: newData,
      }));
      checkBal(newData);
      setFalse_PoDetail((false_PoDetail) => ({
        ...false_PoDetail,
        invoicePORef_List: newData,
      }));
    }
  }, [formState?.invoicePORef_List]);

  useEffect(() => {
    if (formState?.loam_approver !== "") {
      setLoamCheck(true);
    } else {
      setLoamCheck(false);
    }
  }, [formState?.loam_approver]);

  useEffect(() => {
    if (formState?.invoice_Id) {
      setFormState((formState) => ({
        ...formState,
        isImport: role?.roleName === "Import" ? true : false,
        isInitiator:
          role?.roleName === "I2P Initiator" ||
          role?.roleName === "Department Coordinator"
            ? true
            : false,
      }));
      if (!formState?.pO_Based) {
        getTaxUserForNonPo(formState?.invoice_Type, setTaxuser, setFormState);
      }
    }
  }, [formState?.invoice_Id]);

  // const [isAnyPoSelected, setIsAnyPoSelected] = useState(false);
  const [firstTime_v1, setFirstTime_v1] = useState(true);

  useEffect(() => {
    setFirstTime_v1(false);
    if (!firstTime_v1) {
      if (temp_ActualPoDetail?.invoicePORef_List?.length > 0) {
        const res = Array.from(
          temp_ActualPoDetail?.invoicePORef_List?.reduce(
            (m, { DN_NO, Val_Loccur }) =>
              m.set(DN_NO, (m.get(DN_NO) || 0) + Number(Val_Loccur)),
            new Map()
          ),
          ([DN_NO, Val_Loccur]) => ({ DN_NO, Val_Loccur })
        );

        let newData = [];
        for (let index = 0; index < res?.length; index++) {
          const item = res?.[index];
          let obj = {
            id: 0,
            invoice_Id: Number(formState?.invoice_Id) || 0,
            poNumber: item.DN_NO,
            vendorAmount: "0",
            sapAmount: item?.Val_Loccur.toString(),
            difference: (-1 * item?.Val_Loccur).toString(),
          };

          newData.push(obj);
        }
        setFormState((formState) => ({
          ...formState,
          invoiceDebugData_List: newData,
        }));
      }
    } else {
      // if (temp_ActualPoDetail?.invoicePORef_List?.length > 0) {
      //   let selected = false;
      //   for (
      //     let i = 0;
      //     i < temp_ActualPoDetail?.invoicePORef_List?.length;
      //     i++
      //   ) {
      //     const element = temp_ActualPoDetail?.invoicePORef_List[i];
      //     if (element?.selected === true) {
      //       selected = true;
      //     }
      //   }
      //   setIsAnyPoSelected(selected);
      // }
    }
  }, [temp_ActualPoDetail]);
  const LoamUserHandler = (newValue) => {
    const hasLowerCareerLadder = loamUser?.some((user) => {
      const selectedCareerLadder = parseInt(
        (newValue?.CareerLadder || newValue?.CarrierLadder)?.replace(/\D/g, ""),
        10
      );
      const userCareerLadder = parseInt(
        (user?.CareerLadder || user?.CarrierLadder)?.replace(/\D/g, ""),
        10
      );
      return userCareerLadder < selectedCareerLadder;
    });
    if (hasLowerCareerLadder) {
      sethigherLoamApprover(true);
    }
    if (!newValue) {
      setFormState({
        ...formState,
        loam_approver: "",
      });
    } else {
      setFormState({
        ...formState,
        loam_approver: newValue?.UserID ? newValue?.UserID : newValue?.Name,
      });
    }

    if (newValue?.UserID === "" || newValue?.UserID === "null") {
      setLoamApprover(true);
    } else {
      setLoamApprover(false);
      setErrorMessage("");
    }
  };

  const [vendorCode, setVendorCode] = useState([]);
  //   const getVendorData = async () => {
  //     getVendorDetail(formState?.vendor_Code, setVendorCode, setLoading);
  //   };
  // useEffect(()=>{
  //   getVendorData ()

  // },[])




useEffect(()=>{


  if(status !== null && status !== "SubmittedByVendor"){

    console.log("?")

    setFormState({
      ...formState,
      po_Date : formState?.po_Date
    })
    

  }

  else {
    
    const parsedInvoiceDate = Date.parse(formState?.invoice_Date)

    let PODate;
    let parsedPODate;

    if(formState?.po_Date !== "" ){
       PODate =  formState?.po_Date
 parsedPODate = Date?.parse(PODate)

setFormState({
  ...formState,
  po_Date : formState?.po_Date
})


    }


if(parsedInvoiceDate < parsedPODate){

  setIsConfirmatoryPO(true)
}
else {
  setIsConfirmatoryPO(false)
}

  }


},[formState?.po_Date , formState?.invoice_Date,formState?.pO_No])


  const poTableAndDetailHandler = () => {
    if (
      formState.pO_No &&
      searchWithPo &&
      !formState.isLogistics &&
      // status !== "SendToIRFromLogistics" &&
      // next 2 lines is for when status is sentToIRFrom... (prevent to load the invoice po detail from sap first time)
      (!preData.firstTime ||
        (status !== "SendToIRFromIP" &&
          status !== "SendToIRFromTaxTeam" &&
          status !== "SendToIRFromSupervisor"))
    ) {
      getPODetails(
        formState.pO_No,
        setPoTableLoading,
        setTemp_ActualPoDetail,
        invoicePayload?.Invoice_id,
        formState,
        setCopyOfPoDetail,
        setErrorMessage,
        setAlertMessageForPO,
        setErrAlertMessage
      );
    }
    if (formState?.pO_No) {
      getVendorByPOForBlock(
        formState?.invoice_Id,
        formState?.pO_No,
        "vendor_Code",
        setFormState,
        setVendorCode,
        setLoading,
        setvendorblock,
        alertMessage,
        setErrAlertMessage,
        setPOcreated
      );
    }

    setTypeByPo(false);

    if (
      formState.pO_No &&
      (status === "SendToIRFromIP" ||
        status === "SendToIRFromTaxTeam" ||
        preData.pO_No) &&
      preData.firstTime
    ) {
      setPreData((preData) => ({
        ...preData,
        firstTime: false,
      }));
    }

    // get po table detail for logistic invoice
    if (
      formState.isLogistics &&
      (!preData.firstTime || status !== "SendToIRFromLogistics") &&
      (formState.invoice_Type === "DN" || formState.invoice_Type === "ITN")
    ) {
      const data = {
        po_no: formState.invoice_Type === "ITN" ? formState?.pO_No : "",
        dn_no: formState.invoice_Type === "DN" ? formState?.pO_No : "",
      };
      setTemp_ActualPoDetail([]);
      setCopyOfPoDetail([]);
      getDN_ITN_Details(
        data,
        setPoTableLoading,
        setTemp_ActualPoDetail,
        invoicePayload?.Invoice_id,
        setCopyOfPoDetail,
        setFormState
      );
      setTypeByDN(false);
    }
  };

  // this method is for Enter Event (PO & DN number)
  const keypressHandler = (event) => {
    const { name } = event.target;
    if (name === "pO_No" && event.key === "Enter") {
      poTableAndDetailHandler();
    } else if (name === "delv_Note_No" && event.key === "Enter") {
      getDNDetailsOnBLur();
      handleDNOpen();
    }
  };

  useEffect(() => {
    if (!typeByPo) {
      poTableAndDetailHandler();
    }
  }, [formState.pO_No]);

  const getDNDetailsOnBLur = () => {
    handleDNOpen();

    if (formState?.delv_Note_No) {
      getDNDetails(
        formState?.delv_Note_No,
        setPoTableLoading,
        setTemp_ActualPoDetail,
        invoicePayload?.Invoice_id,
        formState,
        setCopyOfPoDetail,
        setdnVendorDetail,
        setFormState
      );
      setTypeByDN(false);
    } else {
      poTableAndDetailHandler();
    }
  };

  useEffect(() => {
    if (formState.invoice_Amount) {
      setBalance(formState.invoice_Amount);
    }
  }, [formState.invoice_Amount]);

  // useEffect(() => {
  //   let filtered = [];
  //   if (selectedRole.roleName === "IR") {
  //     for (let i = 0; i < copyOfPoDetail?.copyInvoicePORef_List?.length; i++) {
  //       const item = copyOfPoDetail?.copyInvoicePORef_List[i];
  //       if (
  //         item?.RefDoc?.toLowerCase().includes(formState.grn_No?.toLowerCase())
  //       ) {
  //         filtered.push(item);
  //       }
  //     }
  //     setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
  //       ...temp_ActualPoDetail,
  //       invoicePORef_List: filtered,
  //     }));
  //     setFormState((formState) => ({
  //       ...formState,
  //       delv_Note_No: filtered[0]?.DN_NO,
  //       pO_No: filtered[0]?.PONumber,
  //     }));
  //   }
  // }, [copyOfPoDetail?.copyInvoicePORef_List, formState.grn_No]);

  const [rolesFiltered, setRolesFiltered] = useState(false);

  useEffect(() => {
    if (roles?.length > 0 && !rolesFiltered) {
      const allowedRoles = [
        { role: "I2P Initiator", code: "1" },
        { role: "IR", code: "2" },
        { role: "Import", code: "3" },
        { role: "Logistic", code: "4" },
        { role: "EFDV Initiator", code: "5" },
        { role: "HR", code: "6" },
        { role: "Department Coordinator", code: "7" },
      ];
      let filteredData = [];
      for (let i = 0; i < allowedRoles.length; i++) {
        const allow = allowedRoles[i];
        for (let j = 0; j < roles.length; j++) {
          const rol = roles[j];
          if (allow.role === rol.roleName) {
            filteredData.push(rol);
          }
        }
      }
      setRolesFiltered(true);
      setRoles(filteredData);
    }
  }, [roles]);

  //  faryad attachments
  // useEffect(() => {
  //
  //   if (initialState === false) {
  //     setAttachmentURLList((pre) => [...pre, formState?.invoice_attachment]);
  //     setAttachmentURL(formState?.invoice_attachment);
  //     setinitialState(true);
  //   } else {
  //     let filterd_data = formState.additionalDocIds.filter(
  //       (e) => Number(e) !== 0
  //     );

  //     setAttachmentURLList((pre) => [
  //       formState?.invoice_attachment,
  //       ...filterd_data,
  //     ]);
  //   }
  // }, [formState?.invoice_attachment]);

  const [firstTime, setFirstTime] = useState(true);

  const myStyle = {
    width: "250px",
    height: "100px",
    backgroundColor: "#EBEDEF",
    borderRadius: "5px",
    display: `${disable ? "none" : "flex"}`,
    alignItems: "center",
    justifyContent: "center",
  };
  useEffect(() => {
    if (
      (selectedRole.roleName === "IR" ||
        selectedRole.roleName === "I2P Initiator" ||
        selectedRole?.roleName === "Department Coordinator" ||
        selectedRole.roleName === "HR") &&
      formState?.additionalDocIds?.length > 0
    ) {
      let filterd_data = [];
      filterd_data = formState?.additionalDocIds.filter((x) => x?.path !== "");
      var semiFinal = filterd_data.filter(function (item) {
        return !attachmentURLList.includes(item?.path);
      });
      let i = [formState?.invoice_attachment?.path];
      var final = semiFinal.filter(function (item) {
        return !i.includes(item?.path);
      });
      if (firstTime) {
        setFirstTime(false);
        if (formState?.invoice_attachment?.path) {
          setAttachmentURLList([...final, formState?.invoice_attachment]);
          setAttachmentURL(formState?.invoice_attachment);
        } else {
          setAttachmentURLList([...final, formState?.additionalDocIds]);
          setAttachmentURL(formState?.additionalDocIds[0]);
        }
      } else {
        if (final.length > 0) {
          setAttachmentURLList([...final, formState?.invoice_attachment]);
          // setAttachmentURL(final[0]);
        }
      }
    } else if (formState?.invoice_attachment?.path) {
      setAttachmentURLList([formState?.invoice_attachment]);
      setAttachmentURL(formState?.invoice_attachment);
    }
  }, [formState?.additionalDocIds, formState?.invoice_attachment]);

  useEffect(() => {
    if (
      formState?.invoice_Accounts_list?.length > 0 &&
      edit !== null &&
      role.roleName !== "HR"
    ) {
      let temp = [];
      for (let i = 0; i < formState?.invoice_Accounts_list?.length; i++) {
        const item = formState?.invoice_Accounts_list[i];
        const obj = {
          accountType:'Debit',
          accountId: 0,
          invoice_Id: Number(invoicePayload?.Invoice_id),
          expenseDate: item?.ExpenseDate,
          // glAccount: item?.GLAccount?.split("-")[0].trim(),
          glAccount: item?.GLAccount || "",
          costCenter: item?.CostCenter || "",
          // GLAccount: item?.GLAccount,
          // costCenter: { CostCenterCode: item?.CostCenter || "" },
          // costCenter: item?.CostCenter?.split("-")[0].trim(),
          costCenterOwner: item?.CostCenterOwner,
          costCenterOwnerName: item?.CostCenterOwnerName,
          wbsElement: item?.WBSElement,
          horizonId: item?.HorizonId,
          vendor_Code: item?.VendorCode,
          amount: Number(item?.Amount),
          profitCenter: Number(item?.ProfitCenter),
          department: item?.Department,
          description: item?.Description || "",
          tType: item?.TType || "",
          fixedAsset: item?.FixedAsset || "",
          fsDocDate: item?.FSDocDate || "",
          fsDocNo: item?.FSDocNo || "",
          customerAccountNo: item?.CustomerAccountNo || "",
          vendorCode: item?.VendorCode || "",
        };
        temp.push(obj);
      }
      setFormState((formState) => ({
        ...formState,
        Expense_Accounts_list: temp,
      }));
    }
  }, [formState?.invoice_Accounts_list]);
  const selectRec = (e, index) => {
    if (e.target.checked === true) {
      let finalArray = [];
      let tempArray = dnVendorDetail.dnVendorDetail_List.filter((item) => {
        return item.VendorCode === [index].VendorCode;
      });

      for (let i = 0; i < tempArray.length; i++) {
        let item = tempArray[i];

        item.selected = true;
        finalArray.push(item);
      }

      // tempArray.push(temp)

      // tempArray[index].selected = true;

      setselectdnVendorDetail({
        ...selectdnVendorDetail,
        selectdnVendorDetail_List: finalArray,
      });

      checkBal(tempArray);
    } else {
      let finalArray = [];
      let tempArray = dnVendorDetail.dnVendorDetail_List.filter((item) => {
        return item.VendorCode === [index].VendorCode;
      });

      for (let i = 0; i < tempArray.length; i++) {
        let item = tempArray[i];

        item.selected = false;
        finalArray.push(item);
      }

      setselectdnVendorDetail({
        ...selectdnVendorDetail,
        selectdnVendorDetail_List: finalArray,
      });
      checkBal(tempArray);
    }
  };
  const SubmitDNPopup = () => {
    let filteredData = selectdnVendorDetail.selectdnVendorDetail_List.filter(
      (data) => data.selected === true
    );
    setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
      ...temp_ActualPoDetail,
      invoicePORef_List: filteredData,
    }));
    setFormState((formState) => ({
      ...formState,
      vendor_Code: filteredData[0].Vendor_Code,
      vendor_Name:
        filteredData[0].Vendor_Code + "-" + filteredData[0].Vendor_Name,
    }));
    checkBal(filteredData);
    handleDNClose();
    setTemparary_PoDetail((temparary_PoDetail) => ({
      ...temparary_PoDetail,
      invoicePORef_List: [],
    }));
  };

  // this is used to fill checkbox
  useEffect(() => {
    if (
      formState?.isLogistics &&
      (formState?.invoice_Type === "DN" || formState?.invoice_Type === "ITN")
    ) {
      setPo_dn_State(formState?.invoice_Type);
    } else if (formState?.isLogistics) {
      setFormState((formState) => ({
        ...formState,
        invoice_Type: "DN",
      }));
    } else {
      setPo_dn_State("PO");
    }
  }, [formState?.isLogistics, formState?.invoice_Type]);
  let ReviewerMandatory = multipleData?.invoice_Type.filter((item) => {
    return item.ReferenceCode == formState?.invoice_Type;
  });
  useEffect(() => {
    if (selectedRole?.roleName === "IR" && poBasedState === "Non-PO") {
      const selectedItem = multipleData?.invoice_Type?.find(
        (x) => x?.ReferenceCode === formState?.invoice_Type
      );

      if (
        selectedItem?.ReferenceCode === "Pre Approved Payment" ||
        selectedItem?.ReferenceCode === "Credit Note"
      ) {
        setShowDepartmentCordinator(false);
        setFormState((formState) => ({
          ...formState,
          isDeptCordinator: false,
          dept_coordinator: "",
        }));
      } else if (selectedItem?.ReferenceProp1 !== "1") {
        setShowDepartmentCordinator(true);
        setFormState((formState) => ({
          ...formState,
          isDeptCordinator: true,
          dept_coordinator:
            selectedRole?.roleName === "IR" 
              ? formState?.dept_coordinator
                ? formState?.dept_coordinator
                : formState?.invoice_Type !== "Final Settlement - Distributor" ? user?.LoginId : ""
              : "",
        }));
      } else {
        setShowDepartmentCordinator(false);
        setFormState((formState) => ({
          ...formState,
          isDeptCordinator: false,
          dept_coordinator: "",
        }));
      }
    }
  }, [formState?.invoice_Type, formState.isDeptCordinator]);
  useEffect(() => {
    if (
      selectedRole?.roleName === "I2P Initiator" &&
      poBasedState == "Non-PO"
    ) {
      setFormState((formState) => ({
        ...formState,
        isDeptCordinator: true,
        dept_coordinator:
          selectedRole?.roleName === "I2P Initiator"
            ? formState?.dept_coordinator
              ? formState?.dept_coordinator
              : user?.LoginId
            : "",
      }));
    }
  }, [selectedRole?.roleName, poBasedState]);
  const [vendor__Code, setVendor__Code] = useState("");
  const [vendor__Name, setVendor__Name] = useState("");

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };
  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (
      formState?.invoice_attachment === "" &&
      // selectedRole?.roleName != "EFDV Initiator" &&
      e.dataTransfer.files &&
      e.dataTransfer.files[0]
    ) {
      uploadFile_v1(
        e,
        setFormState,
        setInvoiceloader,
        "invoice_attachment",
        setAttchmentFile_UI,
        invoice_attachmentRef,
        setAttachmentURLList,
        setAttachmentURL,
        attachmentURLList,
        formState.invoice_attachment,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    } else {
      uploadAdditioalDocumentFile(
        e,
        setFormState,
        setAttchmentLoader,
        "additionalDocIds",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage,
        setAttachmentURLList,
        setAttachmentURL   
      );
    }
  };
  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };
  useEffect(()=>{
    if(selectedRole?.roleName === "EFDV Initiator" ){
      if(!(formState?.mpasEFDV)){
        setFormState({
          ...formState,
          loam_approver : "",
          ipUser: ""
        })
      }
    }
  },[selectedRole?.roleName , formState?.mpasEFDV])
   useEffect(() => {
       if (
         multipleData?.paymentTerms?.length > 0 &&
         formState?.vendor_Code?.Payment_Terms
       ) {
         let days = multipleData?.paymentTerms?.filter(
           (item) => item.ReferenceCode === formState?.vendor_Code?.Payment_Terms
         );
         
         let date = moment(formState?.invoice_Date).format("YYYY-MM-DD");
         if (formState?.invoice_Date) {
           setFormState((formState) => ({
             ...formState,
             dueOn: moment(date, "YYYY-MM-DD")
             .add(Number(days[0]?.ReferenceProp1), "days")
             .format("YYYY-MM-DD"),
           })); 
         }
       }

       if (
        multipleData?.paymentTerms?.length > 0 &&
        vendorList.length === 1
      ) {
        let days = multipleData?.paymentTerms?.filter(
          (item) => item.ReferenceCode === vendorList[0]?.Payment_Terms
        );

        let date = moment(formState?.invoice_Date).format("YYYY-MM-DD");
        if (formState?.invoice_Date) {
          setFormState((formState) => ({
            ...formState,
            dueOn: moment(date, "YYYY-MM-DD")
            .add(Number(days[0]?.ReferenceProp1), "days")
            .format("YYYY-MM-DD"),
          }));         
        }
      }
     }, [
       multipleData?.paymentTerms,
       formState?.vendor_Code?.Payment_Terms,
       formState?.invoice_Date,
       vendorList[0],
       
     ]);
    useEffect(() => {
  if (selectedRole?.roleName === "IR" && formState?.vendor_Code) {
    // calculate total amT_LC
    const totalAdvance = vendorAdvanceData?.reduce(
      (sum, item) => sum + (item?.amT_LC || item?.AMT_LC ||  0),
      0
    );

    if (totalAdvance > 0) {
      console.log("Conditions met → showing modal");
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  } else {
    setShowModal(false);
  }
}, [selectedRole?.roleName, formState?.vendor_Code, vendorAdvanceData]);

useEffect(()=>{
if(formState?.vendor_Code){
  getVendorAdvance(formState?.vendor_Code, setVendorAdvanceData,setPageLoader)
}
},[formState?.vendor_Code]) 

     useEffect(() => {
  if (
    selectedRole?.roleName === "Department Coordinator" &&
    showGLTable?.showForRENT &&
    !formState.invoice_Id
  ) {
    setOpenProvince(true);
  } else {
    setOpenProvince(false);
  }
}, [selectedRole, showGLTable?.showForRENT, formState?.invoice_Id]);
    const handleInvoiceBlur = () => {
  const vendorCode = formState?.vendor_Code?.Vendor_Code;
  const invoiceNo = formState?.invoice_No;

  if (vendorCode && invoiceNo) {
    setIsDuplicateInvoice("")
    setLoading(true);
    getDuplicateInvoiceCheck(vendorCode, invoiceNo , setIsDuplicateInvoice , setOpenDuplicateCheckWarning , setLoading);
  }
};
useEffect(() => {
  if (invoice_Amount_formatted) {
    const cleanedValue = invoice_Amount_formatted?.replace(/,/g, "");
    setFormState((prevState) => ({
      ...prevState,
      invoice_Amount: cleanedValue, // without commas
      invoice_Amount_formatted: invoice_Amount_formatted,
    }));
  }
}, [invoice_Amount_formatted]);
  return (
    <>
      {/* <I2pheading /> */}
      {/* {allowToProceed ? ( */}
        <Card
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          {!disable ? (
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={dragloader || pageLoader}
            ></Backdrop>
          ) : null}

          <CardHeader text>
            <CardText
              style={{
                padding: "0px 27px",
                backgroundColor: "#031C30",
                color: "white",
              }}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={2} sm={3} md={3} lg={6} mt={1}>
                  <h1 style={{ fontSize: "20px" }}>
                    {state?.roleName == "IR"
                      ? "Review/Approve Invoice"
                      : "Add New Invoice"}
                  </h1>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <IconButton
                    variant="contained"
                    style={{
                      float: "right",
                      alignItems: "center",
                      margin: "18.760px 0px",
                    }}
                    onClick={() => navigate("/home")}
                  >
                    <ArrowBack
                      style={{ color: "#fff" }}
                      titleAccess="Go Back"
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </CardText>
          </CardHeader>
          <CardBody>
            {/* <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop> */}

            <form onSubmit={(e) => submitHandler(e)}>
              {/* Check boxes */}
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={
                    selectedRole?.roleName === "Logistic" ||
                    selectedRole?.roleName === "Import" ||
                    selectedRole?.roleName === "EFDV Initiator"
                      ? 12
                      : 6
                  }
                >


                  <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                    lg={
                      selectedRole?.roleName === "Logistic" ||
                      selectedRole?.roleName === "Import" ||
                      selectedRole?.roleName === "EFDV Initiator"
                        ? 3
                        : 6
                    }
                  >
                    <Typography style={{ color: "black" }}>
                      <span className={classes.asterisk}>*</span>
                      Submitter Role:
                    </Typography>
                    <Autocomplete
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "30px",
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInputBase-input": {
                          marginTop: "-4px", // Adjust this value to move the text up
                          fontSize: 15,
                        },
                      }}
                      id="submitter_role"
                      options={roles}
                      size="small"
                      value={
                        roles.find((e) => e.roleId === state?.RoleId) || {
                          roleName: "",
                          roleId: "",
                        }
                      }
                      getOptionLabel={(option) =>
                        (option !== "" && `${option?.roleName}`) || ""
                      }
                      loading={rolesLoading}
                      onChange={(event, newValue) => {
                        roleHandler(newValue);
                        dispatch(Role(newValue));
                      }}
                      disabled={disable}
                      renderInput={(params) => (
                        <TextField {...params} type="text" name="" required />
                      )}
                    />
                  </Grid>
                  {selectedRole?.roleName === "EFDV Initiator" && (

<Grid  item
xs={12}
sm={12}
md={3}
lg={
  selectedRole?.roleName === "EFDV Initiator"
    ? 3
    : 6
}
style={{   marginTop: '13px' }}
>
<div className={classes.checkboxItem}>
    <FormControlLabel
      label="MPAS EFDV"
      style={{ color: "black" }}
      color="secondary"
      control={
        <Checkbox
          color="secondary"
          sx={radioStyle}
          fontSize="small"
          checked={formState.mpasEFDV}
          value={formState.mpasEFDV}
          onChange={(event) => {
            setFormState((formState) => ({
              ...formState,
              mpasEFDV: event.target.checked,
            
            }));
            
          }}
          disabled={
           
            edit == "false" 
          }
        />
      }
    />
  </div>
</Grid>
)
}                
</Grid>




                  <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
                  {selectedRole?.roleName === "IR" ||
                  selectedRole?.roleName === "Logistic" ? (
                    <div className={classes.checkboxContainer}>
                      <div className={classes.checkboxItem}>
                        <FormControlLabel
                          label="Urgent"
                          style={{ color: "black" }}
                          color="secondary"
                          control={
                            <Checkbox
                              color="secondary"
                              fontSize="small"
                              sx={radioStyle}
                              checked={formState.urgent}
                              onChange={(event) => {
                                setFormState((formState) => ({
                                  ...formState,
                                  urgent: event.target.checked,
                                }));
                              }}
                              disabled={
                                selectedRole?.roleName === "Logistic" ||
                                edit == "false"
                              }
                            />
                          }
                        />
                      </div>
                      <div className={classes.checkboxItem}>
                        <FormControlLabel
                          label="Skip Tax Team"
                          style={{ color: "black" }}
                          color="secondary"
                          control={
                            <Checkbox
                              color="secondary"
                              sx={radioStyle}
                              fontSize="small"
                              checked={formState.skipTaxStep}
                              onChange={(event) => {
                                setFormState((formState) => ({
                                  ...formState,
                                  skipTaxStep: event.target.checked,
                                  taxTeam: "",
                                }));
                                setAutoSkip(event.target.checked);
                              }}
                              disabled={
                                selectedRole?.roleName === "Logistic" ||
                                edit == "false" ||
                                formState.invoice_Type === "DES" ||
                                formState.invoice_Type ===
                                  "Pre Approved Payment" ||
                                formState.invoice_Type === "Credit Note" ||
                                formState.invoice_Type === "Final Settlement - Distributor"
                              }
                            />
                          }
                        />
                      </div>
                      <div className={classes.checkboxItem}>
                        <FormControlLabel
                          label="Logistic Invoices"
                          style={{ color: "black" }}
                          color="secondary"
                          control={
                            <Checkbox
                              sx={radioStyle}
                              color="secondary"
                              fontSize="small"
                              checked={formState.isLogistics}
                              onChange={(event) => {
                                setFormState((formState) => ({
                                  ...formState,
                                  isLogistics: event.target.checked,
                                }));
                              }}
                              disabled={
                                selectedRole?.roleName === "Logistic" ||
                                edit == "false"
                              }
                            />
                          }
                        />
                      </div>
                      <div className={classes.checkboxItem}>
                        <FormControlLabel
                          label="Vendor Pre Payment"
                          style={{ color: "black" }}
                          color="secondary"
                          control={
                            <Checkbox
                              sx={radioStyle}
                              color="secondary"
                              fontSize="small"
                              checked={formState.isVPPayment}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFormState((formState) => ({
                                    ...formState,
                                    isVPPayment: event.target.checked,
                                    isVFPayment: !event.target.checked,
                                    // pO_Based: false,
                                  }));
                                  // setPoBasedState("Non-PO");
                                } else {
                                  setFormState((formState) => ({
                                    ...formState,
                                    isVPPayment: event.target.checked,
                                  }));
                                  // setPoBasedState("PO");
                                }
                              }}
                              disabled={
                                selectedRole?.roleName === "Logistic" ||
                                edit == "false"
                              }
                            />
                          }
                        />
                      </div>
                      <div className={classes.checkboxItem}>
                        <FormControlLabel
                          label="Vendor Financing Payment"
                          style={{ color: "black" }}
                          color="secondary"
                          control={
                            <Checkbox
                              color="secondary"
                              sx={radioStyle}
                              fontSize="small"
                              checked={formState.isVFPayment}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFormState((formState) => ({
                                    ...formState,
                                    isVFPayment: event.target.checked,
                                    isVPPayment: !event.target.checked,
                                  }));
                                } else {
                                  setFormState((formState) => ({
                                    ...formState,
                                    isVFPayment: event.target.checked,
                                  }));
                                }
                              }}
                              disabled={
                                selectedRole?.roleName === "Logistic" ||
                                edit == "false"
                              }
                            />
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* //Expense Table */}
                  <Grid container style={{ marginTop: "5px" }}>
                    {selectedRole?.roleName === "EFDV Initiator" && (
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <ExpenseTable_V2
                          formState={formState}
                          setFormState={setFormState}
                          disable={disable}
                        />

                        {/* <ExpenseTable
                          formState={formState}
                          setFormState={setFormState}
                          editable={true}
                          deletee={true}
                          disabled={disable}
                          setOpenInvalidWarningDate={setOpenInvalidWarningDate}
                          setInvalidWarningDateState={
                            setInvalidWarningDateState
                          }
                        /> */}
                      </Grid>
                    )}
                  </Grid>
                  <Grid container spacing={1} style={{ marginTop: "2px" }}>
                    {/* {selectedRole?.roleName === "Logistic" ||
            (formState.isLogistics && selectedRole?.roleName === "IR") ? (
              //  Physical/E-Invoice
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl component="fieldset">
                  <FormLabel
                    required
                    classes={{ asterisk: classes.asterisk }}
                    id="demo-row-radio-buttons-group-label"
                  >
                    <b>Physical/E-Invoice</b>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="gender"
                    name="gender1"
                    value={physicalOrEInvoice}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    onChange={(e) => setPhysicalOrEInvoice(e.target.value)}
                  >
                    <FormControlLabel
                      value="Physical"
                      control={<Radio size="small" />}
                      label="Physical"
                      disabled={selectedRole?.roleName === "Logistic"}
                    />
                    <FormControlLabel
                      value="E-Invoice"
                      control={<Radio size="small" />}
                      label="E-Invoice"
                      disabled={selectedRole?.roleName === "Logistic"}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            ) : (
              ""
            )} */}

                    {selectedRole?.roleName === "IR" ||
                    selectedRole?.roleName === "I2P Initiator" ||
                    selectedRole?.roleName === "Department Coordinator" ? (
                      <>
                        {/* //  PO/ Non-PO */}
                        {!formState.isLogistics && (
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <FormControl component="fieldset">
                              {/* <FormLabel
                        classes={{ asterisk: classes.asterisk }}
                        required
                        id="demo-row-radio-buttons-group-label"
                      >
                        <b>PO/ Non-PO</b>
                      </FormLabel> */}
                              <Typography style={Stylecolor}>
                                <span className={classes.asterisk}>*</span>
                                PO / Non-PO:
                              </Typography>
                              <RadioGroup
                                row
                                aria-label="gender"
                                name="gender1"
                                sx={radioLabel}
                                value={poBasedState}
                                color="primary"
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                // value={value}
                                onChange={poBasedHandler}
                                
                              >
                                <FormControlLabel
                                  value="PO"
                                  control={
                                    <Radio
                                      color="primary"
                                      sx={radioStyle}
                                      size="small"
                                    />
                                  }
                                  label="PO"
                                  disabled={edit == "false"}
                                />
                                <FormControlLabel
                                  value="Non-PO"
                                  control={
                                    <Radio
                                      color="primary"
                                      sx={radioStyle}
                                      size="small"
                                    />
                                  }
                                  label="Non-PO"
                                  disabled={edit == "false"}
                                />
                                {/* {selectedRole?.roleName === "IR" ? (
                            <FormControlLabel
                              value="radio3"
                              control={<Radio size="small" />}
                              label="DN"
                              disabled={
                                formState.isVPPayment || edit == "false"
                              }
                            />
                          ) : (
                            ""
                          )} */}
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                        )}
                        {/* //invoice category */}
                        {/* {formState.isLogistics && ( */}
                        {!formState.isLogistics &&
                          poBasedState === "Non-PO" &&
                          selectedRole?.roleName !== "I2P Initiator" && (
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <FormControl component="fieldset">
                                <Typography style={Stylecolor}>
                                  <span className={classes.asterisk}>*</span>
                                  Invoice Category:
                                </Typography>
                              
                                <RadioGroup
                                  row
                                  aria-label="gender"
                                  name="invoiceCategory"
                                  value={formState.invoiceCategory}
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  // value={value}
                                  onChange={changeHandler}
                                >
                                  <FormControlLabel
                                    value="Travel:Dial a car/Hotel(selected)"
                                    control={
                                      <Radio
                                        color="primary"
                                        sx={{
                                          color: "#C5C7CD",
                                          "&.Mui-checked": {
                                            color: "#0095DA",
                                          },
                                        }}
                                        size="small"
                                      />
                                    }
                                    label="Travel:Dial a car/Hotel(selected)"
                                    disabled={disable}
                                  />
                                  <FormControlLabel
                                    value="Brand Related Expense"
                                    control={
                                      <Radio
                                        color="primary"
                                        sx={{
                                          color: "#C5C7CD",
                                          "&.Mui-checked": {
                                            color: "#0095DA",
                                          },
                                        }}
                                        size="small"
                                      />
                                    }
                                    label="Brand Related Expense"
                                    disabled={disable}
                                  />
                                  {selectedRole?.roleName === "IR" ? (
                                    <FormControlLabel
                                      value="Other"
                                      control={
                                        <Radio
                                          color="primary"
                                          sx={{
                                            color: "#C5C7CD",
                                            "&.Mui-checked": {
                                              color: "#0095DA",
                                            },
                                          }}
                                          size="small"
                                        />
                                      }
                                      label="Other"
                                      disabled={disable}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                          )}
 { selectedRole?.roleName === "Department Coordinator" && (

<Grid  item
xs={12}
sm={12}
md={3}
lg={
 
   3
}
style={{   marginTop: '15px' }}
>
<div className={classes.checkboxItem}>
    <FormControlLabel
      label="DES"
      style={{ color: "black" }}
      color="secondary"
      control={
        <Checkbox
          color="secondary"
          sx={radioStyle}
          fontSize="small"
             checked={showGLTable?.showForDES}
          value={'DES'}
          onChange={(e) => {
           const isChecked = e.target.checked;
          setShowGLTable({
            showForDES: isChecked,
            showForRENT: !isChecked && showGLTable.showForRENT ? true : false,
          })
            setFormState((formState) => ({
    ...formState,
    invoice_Type: isChecked ? 'DES' : '', // remove value on uncheck
  }));
          }}
         
          // disabled={
           
          //   true
          // }
        />
      }
    />
  </div>
  <div className={classes.checkboxItem}>
    <FormControlLabel
      label="RENT"
      style={{ color: "black" }}
      color="secondary"
      control={
        <Checkbox
          color="secondary"
          sx={radioStyle}
          fontSize="small"
              checked={showGLTable?.showForRENT}
          value={'Rent'}
          onChange={(e) => {
           const isChecked = e.target.checked;
          setShowGLTable({
            showForDES: !isChecked && showGLTable.showForDES ? true : false,
            showForRENT: isChecked,
          });
                setFormState((formState) => ({
    ...formState,
    invoice_Type: isChecked ? 'Rent' : '', // remove value on uncheck
  }));
          }}
         
          // disabled={
           
          //   true
          // }
        />
      }
    />
  </div>
</Grid>
)
}  
           
                      </>
                    ) : (
                      ""
                    )}

                    {selectedRole === "Logistic" || formState.isLogistics ? (
                      //  DN Invoices / ITN Invoices
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl component="fieldset">
                          <Typography style={Stylecolor}>
                            <span className={classes.asterisk}>*</span>
                            DN Invoices / ITN Invoices:
                          </Typography>

                          <RadioGroup
                            row
                            aria-label="gender"
                            name=""
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            value={formState?.invoice_Type}
                            onChange={(e) => {
                              setFormState((formState) => ({
                                ...formState,
                                invoice_Type: e.target.value,
                              }));
                            }}
                          >
                            <FormControlLabel
                              value="DN"
                              sx={radioLabel}
                              control={
                                <Radio
                                  color="primary"
                                  sx={{
                                    color: "#C5C7CD",
                                    "&.Mui-checked": {
                                      color: "#0095DA",
                                    },
                                  }}
                                  size="small"
                                />
                              }
                              label="DN Invoices"
                              disabled={selectedRole === "Logistic"}
                            />
                            <FormControlLabel
                              value="ITN"
                              sx={radioLabel}
                              control={
                                <Radio
                                  color="primary"
                                  sx={{
                                    color: "#C5C7CD",
                                    "&.Mui-checked": {
                                      color: "#0095DA",
                                    },
                                  }}
                                  size="small"
                                />
                              }
                              label="ITN Invoices"
                              disabled={selectedRole === "Logistic"}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid container spacing={2} style={{ marginTop: "2px" }}>
                    {selectedRole?.roleName === "Import" && (
                      <>
                        {/* isPSID */}
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          {formState.demandType != "Deposit" && (
                            <FormControlLabel
                              style={{ marginLeft: "3px", color: "black" }}
                              label="PSID"
                              color="secondary"
                              control={
                                <Checkbox
                                  color="secondary"
                                  fontSize="small"
                                  checked={formState.isPSID}
                                  name="isPSID"
                                  disabled={disable}
                                  onChange={(event) => {
                                    setFormState((formState) => ({
                                      ...formState,
                                      isPSID: event.target.checked,
                                      psid: "",
                                    }));
                                  }}

                                  // disabled={selectedRole === "Logistic"}
                                />
                              }
                            />
                          )}

                          <FormControlLabel
                            style={{ marginLeft: "3px", color: "black" }}
                            label="Loam Approver"
                            color="secondary"
                            control={
                              <Checkbox
                                color="secondary"
                                fontSize="small"
                                checked={loamCheck}
                                disabled={disable}
                                onChange={(event) => {
                                  setLoamCheck(event.target.checked);
                                  if (event.target.checked == false) {
                                    setFormState((formState) => ({
                                      ...formState,
                                      loam_approver: "",
                                    }));
                                  }
                                }}

                                // disabled={selectedRole === "Logistic"}
                              />
                            }
                          />
                        </Grid>
                        {/* Loam Approver TEXT */}
                        {/* {loamCheck && (
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <FormControl fullWidth size="small">
                      <UsersByRole
                        label="Loam Approver User"
                        apiString="Loam Approver"
                        name="loam_approver"
                        formState={formState}
                        changeHandler={changeHandler}
                        required={formState?.isProceed}
                        classes={classes}
                      />
                    </FormControl>
                  </Grid>
                )} */}
                        {/* PSID */}
                        {/* {formState.isPSID && (
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Typography style={{color:'black'}}>
                      PSID <span className={classes.asterisk}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      name="psid"
                      type="text"
                      value={formState.psid}
                      onChange={changeHandler}
                      size="small"
                      sx={{
                        // width: "70%",
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      id="outlined-basic"
                      variant="outlined"
                    />
                  </Grid>
                )} */}
                        {/* Demand type */}
                        {/* <Grid item xs={12} sm={12} md={3} lg={3}>
                  <FormControl fullWidth size="small">
                    <Typography style={{color:'black'}}>
                      Demand type <span className={classes.asterisk}>*</span>
                    </Typography>

                    <Select
                      size="small"
                      displayEmpty
                      className={classes.selectEmpty}
                      // labelId="demo-simple-select-label"
                      value={formState.demandType || ""}
                      id="demo-simple-select"
                      name="demandType"
                      placeholder="Please Select Value"
                      onChange={changeHandler}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="" disabled>
                        Select a Value
                      </MenuItem>
                      {demandType.map((item) => {
                        return (
                          <MenuItem value={item.role}>{item.role}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid> */}
                      </>
                    )}
                    {/* Invoice Type */}
                    {/* {selectedRole?.roleName === "Import" ||
             (selectedRole?.roleName === "IR" && poBasedState === "Non-PO") ? (
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <FormControl fullWidth size="small">
                  <Typography style={{color:'black'}}>
                    Invoice Type<span className={classes.asterisk}>*</span>
                  </Typography>

                  <Select
                    size="small"
                    // labelId="demo-simple-select-label"
                    value={formState.invoice_Type}
                    name="invoice_Type"
                    id="demo-simple-select"
                    displayEmpty
                    disabled={disable}
                    className={classes.selectEmpty}
                    placeholder="Please Select Value"
                    onChange={changeHandler}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="" disabled>
                      Select a Value
                    </MenuItem>
                    {invoiceType.map((item) => {
                      return <MenuItem value={item.role}>{item.role}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
             ) : (
              ""
             )} */}
                  </Grid>
                  {/* For attachment start here */}
                  <Grid container spacing={1} style={{ marginTop: "2px" }}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={
                        selectedRole?.roleName === "IR" ||
                        selectedRole?.roleName === "I2P Initiator" ||
                        selectedRole?.roleName === "Department Coordinator" ||
                        selectedRole?.roleName === "HR"
                          ? 12
                          : 12
                      }
                    >
                      <Grid
                          Grid container spacing={2}
                          >
    {
                      formState?.mpasEFDV &&
                      (            
                       <>
                       <Grid    item
                                  xs={12}
                                  sm={12}
                                  md={ 3   
                                  }
                                  lg={3}
                                  >
                                <Typography style={{ color: "black" }}>
                                  <span className={classes.asterisk}>
                                   * 
                                  </span>
                                  Loam Approver:
                                </Typography>
                                <Autocomplete
                                  size="small"
                                  style={{ width: "100%" }}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: "30px",
                                      textAlign: "center",
                                      display: "flex",
                                      alignItems: "center",
                                    },
                                    "& .MuiInputBase-input": {
                                      marginTop: "-4px", // Adjust this value to move the text up
                                      fontSize: 15,
                                    },
                                  }}
                                  disabled={disable}
                                  value={
                                    loamUser.find((user) =>
                                      user?.UserID
                                        ? user?.UserID === formState?.loam_approver
                                        : user?.Name === formState?.loam_approver
                                    ) || ""
                                  }
                                  onChange={(e, newValue) => {
                                    LoamUserHandler(newValue);
                                  }}
                              
                                  options={loamUser}
                                  getOptionLabel={(option) =>
                                    option
                                      ? option?.PersonalNumber
                                        ? `${option?.PersonalNumber} -` +
                                          `${option?.Name}`
                                        : `${option?.Name}`
                                      : ""
                                  }
                                  loading={loamLoading}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      // variant="standard"
                                      size="small"
                                      // required
                                      // InputProps={{
                                      //   ...params.InputProps,
                                      //   disableUnderline: true,
                                      // }}
                                      placeholder="Select loam Approver"
                                      required={
                                        formState?.isProceed && !formState?.isReturn
                                      }
                                    />
                                  )}
                                />
                              </Grid>
                             <Grid item
                                  xs={12}
                                  sm={12}
                                  md={
                                    3     
                                  }
                                  lg={3}
                                  >
                                                  <SearchUsersRole
                                                    label="IP User"
                                                    apiString="IP"
                                                    name="ipUser" // pending.
                                                    placeholder="Select a User"
                                                    formState={formState}
                                                    setNewFormState={setFormState}
                                                    changeHandler={changeHandler}
                                                    required={formState?.isProceed}
                                                    disabled={disable}
                                                    classes={classes}
                                                  />
                                                </Grid> 
                                                
                                                <Grid item md={
                                    6
                                      
                                  }
                                  lg={6}></Grid>
                                                     </>      
                         
    
                      )
                     }
    
                        {selectedRole?.roleName === "HR" && (
                          <>
                            {/* Category */}
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <FormControl fullWidth size="small">
                                <Typography style={{ color: "black" }}>
                                  <span className={classes.asterisk}>*</span>
                                  Category:
                                </Typography>

                                <Select
                                  size="small"
                                  // labelId="demo-simple-select-label"
                                  value={formState.invoiceCategory}
                                  id="demo-simple-select"
                                  name="invoiceCategory"
                                  displayEmpty
                                  className={classes.selectEmpty}
                                  onChange={changeHandler}
                                  style={{ height: 30 }}
                                  inputProps={{ "aria-label": "Without label" }}
                                  disabled={disable}
                                >
                                  <MenuItem value="" disabled>
                                    Select a Value
                                  </MenuItem>
                                  {category.map((item) => {
                                    return (
                                      <MenuItem value={item.role}>
                                        {item.role}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </Grid>

                            {/* Description */}
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography style={{ color: "black" }}>
                                <span className={classes.asterisk}>*</span>
                                Description:
                              </Typography>
                              <TextField
                                fullWidth
                                id="outlined-basic"
                                size="small"
                                name="invoice_Desc"
                                value={formState.invoice_Desc}
                                variant="outlined"
                                required={formState?.isProceed}
                                onChange={changeHandler}
                                FormHelperTextProps={{
                                  className: classes.helperText,
                                }}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 30,
                                  },
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                disabled={disable}
                                error={/[!@#$%^&*()_+={}\[\]:;"'<>,?/~\\-`]/.test(
                                  formState?.invoice_Desc
                                )}
                                helperText={
                                  /[!@#$%^&*()_+={}\[\]:;"'<>,?/~\\-`]/.test(
                                    formState?.invoice_Desc
                                  )
                                    ? "Can be a word or number without any special character!"
                                    : null
                                }
                              />
                            </Grid>
                            {/* Date */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={6}
                              lg={6}
                              style={{ paddingRight: "18px" }}
                            >
                              <Typography style={{ color: "black" }}>
                                <span className={classes.asterisk}>*</span>
                                Date:
                              </Typography>
                              <input
                                className={classes.inputField}
                                name="invoice_Date"
                                type="date"
                                max="9999-12-31"
                                onChange={changeHandler}
                                value={formState.invoice_Date || ""}
                                onInput={(newValue) => {
                                  isOldDateValidate(
                                    formatDateTimeForBackend(newValue),
                                    setOpenInvalidWarningDate,
                                    setInvalidWarningDateState
                                  );
                                  setFormState((formState) => ({
                                    ...formState,
                                    invoice_Date:
                                      formatDateTimeForBackend(newValue),
                                  }));
                                  isFutureDate(
                                    formatDateTimeForBackend(newValue),
                                    setFormState,
                                    "invoice_Date"
                                  );
                                }}
                                disabled={disable}
                                style={{
                                  height: 13, // Adjust this value to decrease the height
                                }}
                                required={formState?.isProceed}
                              />
                            </Grid>
                            {(formState.invoiceCategory ===
                              "Final Settlement – Normal" ||
                              formState.invoiceCategory ===
                                "Final Settlement – Death case") && (
                              <>
                                {/* FS DOC Date */}
                                {/* <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={6}
                                  lg={6}
                                  style={{ paddingRight: "19px" }}
                                >
                                  <Typography style={{ color: "black" }}>
                                    <span className={classes.asterisk}>*</span>
                                    FS DOC Date:{" "}
                                  </Typography>
                                  <input
                                    className={classes.inputField}
                                    name="fsDocumentDate"
                                    type="date"
                                    max="9999-12-31"
                                    onChange={changeHandler}
                                    value={formState.fsDocumentDate || ""}
                                    disabled={disable}
                                    onInput={(newValue) => {
                                      setFormState((formState) => ({
                                        ...formState,
                                        fsDocumentDate:
                                          formatDateTimeForBackend(newValue),
                                      }));
                                    }}
                                  />
                                </Grid> */}
                                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          // value={value}
                          // onChange={(newValue) => {
                          //   setValue(newValue);
                          // }}
                          value={formState.fs_Doc_Date || ""}
                          onChange={(newValue) => {
                            setFormState((formState) => ({
                              ...formState,
                              fsDocumentDate: formatDateTimeForBackend(newValue),
                            }));
                          }}
                          error={false}
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              size="small"
                              id="outlined-basic"
                              variant="outlined"
                              onChange={changeHandler}
                              value={formState.fs_Doc_Date || ""}
                              {...params}
                              error={false}
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                            />
                          )}
                        />
                            </LocalizationProvider>*/}

                                {/* Final Settlement Doc */}
                                {/* <Grid item xs={12} sm={12} md={6} lg={6}>
                                  <Typography style={{ color: "black" }}>
                                    <span className={classes.asterisk}>*</span>
                                    Final Settlement Doc:{" "}
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    name="fsDocumentNumber"
                                    value={formState.fsDocumentNumber}
                                    onChange={changeHandler}
                                    sx={{
                                      // width: "70%",
                                      "& legend": { display: "none" },
                                      "& fieldset": { top: 0 },
                                    }}
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disable}
                                  />
                                </Grid> */}
                              </>
                            )}
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography style={{ color: "black" }}>
                                <span className={classes.asterisk}>*</span>
                                Invoice Amount:
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                style={
                                  {
                                    // color: "black !important",
                                  }
                                }
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 30,
                                  },
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                id="outlined-basic"
                                variant="outlined"
                                type="text"
                                pattern="[0-9]*"
                                min={1}
                                // value={formState.invoice_Amount}
                                value={invoice_Amount_formatted}
                                InputProps={{
                                  inputProps: {
                                    min: 1,
                                    step: "0.00000000000000001",
                                    inputMode: "numeric",
                                  },
                                }}
                                required={formState?.isProceed}
                                onChange={changeHandler}
                                name="invoice_Amount"
                                disabled={disable}
                              />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <SearchUsersRole
                                label="Line Manager"
                                apiString="Line Manager"
                                name="lineManager"
                                placeholder="Select a User"
                                formState={formState}
                                setNewFormState={setFormState}
                                changeHandler={changeHandler}
                                required={
                                  formState?.sharedServices ||
                                  formState?.directorHR
                                }
                                classes={classes}
                                disabled={disable}
                              />
                              {/* <UsersByRole
                                label="Line Manager"
                                apiString="Line Manager"
                                name="lineManager"
                                formState={formState}
                                changeHandler={changeHandler}
                                required={formState?.sharedServices || formState?.directorHR}
                                classes={classes}
                                disabled={disable}
                              /> */}
                            </Grid>
                            {formState?.invoiceCategory !==
                              "Employee Advance" &&
                              formState?.invoiceCategory !==
                                "Employee Loan" && (
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                  <SearchUsersRole
                                    label="Shared Services"
                                    apiString="Shared Services"
                                    name="sharedServices"
                                    placeholder="Select a User"
                                    formState={formState}
                                    setNewFormState={setFormState}
                                    changeHandler={changeHandler}
                                    required={
                                      formState?.lineManager ||
                                      formState?.directorHR
                                    }
                                    classes={classes}
                                    disabled={disable}
                                  />
                                  {/* <UsersByRole
                                    label="Shared Services"
                                    apiString="Shared Services"
                                    name="sharedServices"
                                    formState={formState}
                                    changeHandler={changeHandler}
                                    required={
                                       formState?.lineManager || formState?.directorHR 
                                    }
                                    classes={classes}
                                    disabled={disable}
                                  /> */}
                                </Grid>
                              )}
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <SearchUsersRole
                                label="IP User"
                                apiString="IP"
                                name="ipUser" // pending.
                                placeholder="Select a User"
                                formState={formState}
                                setNewFormState={setFormState}
                                changeHandler={changeHandler}
                                required={formState?.isProceed}
                                disabled={false}
                                classes={classes}
                              />
                              {/* <UsersByRole
                                label="IP User"
                                apiString="IP"
                                name="ipUser"
                                formState={formState}
                                changeHandler={changeHandler}
                                required={formState?.isProceed}
                                classes={classes}
                                disabled={disable}
                              /> */}
                            </Grid>
                            {formState?.invoiceCategory !==
                              "Employee Advance" &&
                              formState?.invoiceCategory !==
                                "Employee Loan" && (
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                  <SearchUsersRole
                                    label="Director HR"
                                    apiString="Director HR"
                                    name="directorHR"
                                    placeholder="Select a User"
                                    formState={formState}
                                    setNewFormState={setFormState}
                                    changeHandler={changeHandler}
                                    required={
                                      formState?.lineManager ||
                                      formState?.sharedServices
                                    }
                                    classes={classes}
                                    disabled={disable}
                                  />
                                  {/* <UsersByRole
                                    label="Director HR"
                                    apiString="Director HR"
                                    name="directorHR"
                                    formState={formState}
                                    changeHandler={changeHandler}
                                    required={
                                       formState?.lineManager || formState?.sharedServices 
                                    }
                                    classes={classes}
                                    disabled={disable}
                                  /> */}
                                </Grid>
                              )}
                          </>
                        )}
                        {selectedRole?.roleName === "Import" && (
                          <>
                            {/* Loam Approver TEXT */}
                            {/* {loamCheck && (
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                          <FormControl fullWidth size="small">
                            <UsersByRole
                              label="Loam Approver User"
                              apiString="Loam Approver"
                              name="loam_approver"
                              formState={formState}
                              changeHandler={changeHandler}
                              required={formState?.isProceed}
                              classes={classes}
                              disabled={disable}
                            />
                          </FormControl>
                        </Grid>
                     )}*/}
                            {/* PSID */}
                            {formState.isPSID && (
                              <Grid item xs={12} sm={12} md={3} lg={3}>
                                <Typography style={{ color: "black" }}>
                                  <span className={classes.asterisk}>*</span>
                                  PSID:
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="psid"
                                  type="text"
                                  value={formState.psid}
                                  onChange={changeHandler}
                                  size="small"
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: 30,
                                    },

                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                  id="outlined-basic"
                                  variant="outlined"
                                  disabled={disable}
                                />
                              </Grid>
                            )}
                            {/* Demand type */}

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                              <FormControl fullWidth size="small">
                                <Typography style={{ color: "black" }}>
                                  <span className={classes.asterisk}>*</span>
                                  Demand type:{" "}
                                </Typography>

                                <Select
                                  size="small"
                                  displayEmpty
                                  className={classes.selectEmpty}
                                  // labelId="demo-simple-select-label"
                                  value={formState.demandType || ""}
                                  id="demo-simple-select"
                                  name="demandType"
                                  placeholder="Please Select"
                                  onChange={changeHandler}
                                  style={{ height: 30 }}
                                  disabled={disable}
                                  required={formState?.isProceed}
                                  inputProps={{ "aria-label": "Without label" }}
                                >
                                  <MenuItem value="" disabled>
                                    Select a Value
                                  </MenuItem>
                                  {demandType.map((item) => {
                                    return (
                                      <MenuItem value={item.role}>
                                        {item.role}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </Grid>

                            {/* Invoice Type */}
                            {selectedRole?.roleName === "Import" ||
                            (selectedRole?.roleName === "IR" &&
                              poBasedState === "Non-PO") ||
                            (selectedRole?.roleName === "IP" &&
                              poBasedState === "Non-PO") ? (
                              <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth size="small">
                                  <Typography style={{ color: "black" }}>
                                    <span className={classes.asterisk}>*</span>
                                    Invoice Type:
                                  </Typography>

                                  <Select
                                    size="small"
                                    // labelId="demo-simple-select-label"
                                    value={formState.invoice_Type}
                                    name="invoice_Type"
                                    id="demo-simple-select"
                                    displayEmpty
                                    className={classes.selectEmpty}
                                    required={formState?.isProceed}
                                    // placeholder="Please Select Value"
                                    onChange={changeHandler}
                                    style={{ height: 30 }}
                                    disabled={disable}
                                    inputProps={{
                                      "aria-label": "Without label",
                                    }}
                                  >
                                    <MenuItem value="" disabled>
                                      Select a Value
                                    </MenuItem>
                                    {invoiceType.map((item) => {
                                      return (
                                        <MenuItem value={item.role}>
                                          {item.role}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </Grid>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                        {(selectedRole?.roleName === "Import" ||
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName ===
                            "Department Coordinator") && (
                          <>
                            {(showVendorCodeForImport() ||
                              selectedRole?.roleName === "Logistic" ||
                              (selectedRole?.roleName === "IR" &&
                                poBasedState == "Non-PO") ||
                              // dNInvoicesorITNInvoices === "DN" &&
                              // formState?.isLogistics
                              poBasedState == "Non-PO") && (
                              <>

 {
                                  (selectedRole?.roleName === "IR" && formState?.invoice_Type === "Final Settlement - Distributor" )&& (

                                     <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={
                                    formState?.invoice_Type === "Final Settlement - Distributor" 
                                      ? 6
                                      : 3
                                  }
                                  lg={
                                   formState?.invoice_Type === "Final Settlement - Distributor" 
                                      ? 6
                                      : 3
                                  }
                                >
                                  <FormControl fullWidth size="small">
                                    <Typography style={{ color: "black" }}>
                                      <span className={classes.asterisk}>
                                        *
                                      </span>
                                     Distributor Code:{" "}
                                    </Typography>

                                    <CustomerCode
                                      disabled={disable}
                                      setFormState={setFormState}
                                      formState={formState}
                                      changeHandler={changeHandler}
                                      bordered={true}
                                      user={formState?.distributor_Code}
                                      setvendorblock={setvendorblock}
                                      setErrAlertMessage={setErrAlertMessage}
                                    />
                                  </FormControl>
                                </Grid>
                                  )
                                }

                                {/* vendor code */}
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={
                                    selectedRole?.roleName === "IR" ||
                                    selectedRole?.roleName ===
                                      "I2P Initiator" ||
                                    selectedRole?.roleName ===
                                      "Department Coordinator"
                                      ? 6
                                      : 3
                                  }
                                  lg={
                                    selectedRole?.roleName === "IR" ||
                                    selectedRole?.roleName ===
                                      "I2P Initiator" ||
                                    selectedRole?.roleName ===
                                      "Department Coordinator"
                                      ? 6
                                      : 3
                                  }
                                >
                                  <FormControl fullWidth size="small">
                                    <Typography style={{ color: "black" }}>
                                      <span className={classes.asterisk}>
                                        *
                                      </span>
                                      Vendor Code:{" "}
                                    </Typography>

                                    <VendorCode
                                      disabled={disable}
                                      setFormState={setFormState}
                                      formState={formState}
                                      changeHandler={changeHandler}
                                      bordered={true}
                                      user={formState?.vendor_Code}
                                      setvendorblock={setvendorblock}
                                      setErrAlertMessage={setErrAlertMessage}
                                         onBlur={() => handleInvoiceBlur()}
                                    />
                                  </FormControl>
                                </Grid>
                              </>
                            )}
                          </>
                        )}
                        {((selectedRole?.roleName === "Import" &&
                          formState.demandType !== "") ||
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "HR" ||
                          selectedRole?.roleName === "EFDV Initiator" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName ===
                            "Department Coordinator") && (
                          <>
                            {/* Attach Invoice */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "HR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                              lg={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "HR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                            >
                              <Typography style={{ color: "black" }}>
                                <span className={classes.asterisk}>*</span>
                                Attach Invoice:{" "}
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 30,
                                  },
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                id="outlined-basic"
                                variant="outlined"
                                required={
                                  formState?.invoice_attachment?.path === "" ||
                                  formState?.invoice_attachment === ""
                                }
                                // onChange={() => }
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <input
                                        ref={invoice_attachmentRef}
                                        type="file"
                                        name="invoice_attachment"
                                        accept=".png, .jpg, .jpeg, .pdf"
                                        disabled={invoiceloader || disable}
                                        onChange={async (e) => {
                                          if (formState?.invoice_attachment) {
                                            // If there's already an attachment, delete it first
                                            try {
                                              await deleteInvoice(); // ✅ deleteInvoice must return a promise (it already does because axios returns one)

                                              // After successful delete, call upload
                                              uploadFile_v1(
                                                e,
                                                setFormState,
                                                setInvoiceloader,
                                                "invoice_attachment",
                                                setAttchmentFile_UI,
                                                invoice_attachmentRef,
                                                setAttachmentURLList,
                                                setAttachmentURL,
                                                attachmentURLList,
                                                formState.invoice_attachment,
                                                setDocError,
                                                setAttachError,
                                                setAlertMessage,
                                                invoicePayload,
                                                selectedRole,
                                                dragfile,
                                                setDragFile,
                                                setSuccessMessage
                                              );
                                            } catch (error) {
                                              console.error("Delete failed, not uploading:", error);
                                              setErrorMessage("Failed to delete old attachment. Upload aborted.");
                                            }
                                          } else {
                                            // No old attachment → upload directly
                                            uploadFile_v1(
                                              e,
                                              setFormState,
                                              setInvoiceloader,
                                              "invoice_attachment",
                                              setAttchmentFile_UI,
                                              invoice_attachmentRef,
                                              setAttachmentURLList,
                                              setAttachmentURL,
                                              attachmentURLList,
                                              formState.invoice_attachment,
                                              setDocError,
                                              setAttachError,
                                              setAlertMessage,
                                              invoicePayload,
                                              selectedRole,
                                              dragfile,
                                              setDragFile,
                                              setSuccessMessage
                                            );
                                          }
                                        }}
                                        style={{ width: "209px" }}
                                      />
                                      {invoiceloader ? (
                                        <CircularProgress size={24} />
                                      ) : (
                                        ""
                                      )}
                                    </InputAdornment>
                                  ),
                                }}
                                // FormHelperTextProps={{
                                //   className: classes.helperText,
                                // }}
                                error={alertMessage ? true : false}
                                // helperText={attachError ? `${attachError}` : "File size should be less then or equal to 200MBs"}
                              />
                              {formState?.invoice_attachment?.path && (
                                <>
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      downloadAttachments(
                                        formState?.invoice_attachment?.path
                                      )
                                    }
                                  >
                                    <Download
                                      titleAccess="Download"
                                      color="secondary"
                                      fontSize="small"
                                      style={{ color: disable ? "gray" : "" }}
                                    />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      setWarningFlag(false);
                                      setOpenWarningBox(true);
                                    }}
                                    disabled={disable}
                                  >
                                    <Delete
                                      titleAccess="Delete"
                                      color="danger"
                                      fontSize="small"
                                      style={{ color: disable ? "gray" : "" }}
                                    />
                                  </IconButton>
                                  {
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        const allowedExtensions = [
                                          ".png",
                                          ".pdf",
                                          ".jpg",
                                          ".jpeg",
                                          ".PNG",
                                          ".JPG",
                                          ".JPEG",
                                          ".PNG",
                                          ".PDF",
                                        ];
                                        const fileExtension =
                                          "." +
                                          formState?.invoice_attachment?.path
                                            ?.split("\\")
                                            [
                                              formState?.invoice_attachment?.path?.split(
                                                "\\"
                                              ).length - 1
                                            ].split(".")
                                            .pop();
                                        if (
                                          allowedExtensions.includes(
                                            fileExtension
                                          )
                                        ) {
                                          setAttachmentURL(
                                            formState?.invoice_attachment
                                          );
                                        } else {
                                          setAttachmentURL(
                                            formState?.invoice_attachment
                                          );
                                          window.open(
                                            `${process.env.REACT_APP_API_URL}/${formState?.invoice_attachment?.path}`,
                                            "_blank"
                                          );
                                        }
                                      }}
                                    >
                                      {
                                        formState?.invoice_attachment?.path?.split(
                                          "\\"
                                        )[
                                          formState?.invoice_attachment?.path?.split(
                                            "\\"
                                          ).length - 1
                                        ]
                                      }
                                    </span>
                                  }
                                  {/*  <a
                                style={{
                                  fontSize: "14px",
                                  textDecoration: "none",
                                  color: edit == "false" ? "gray" : "black",
                                  cursor: "pointer",
                                  // pointerEvents: disable ? "none" : ""
                                }}
                                href={`${process.env.REACT_APP_API_URL}/${formState?.invoice_attachment?.path}`}
                                target="_blank"
                              >
                                {
                                  formState?.invoice_attachment?.path?.split(
                                    "\\"
                                  )[
                                    formState?.invoice_attachment?.path?.split(
                                      "\\"
                                    ).length - 1
                                  ]
                                }
                              </a>*/}
                                </>
                              )}
                            </Grid>
                          </>
                        )}
                        {selectedRole?.roleName === "IR" &&
                          poBasedState == "Non-PO" && (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={selectedRole?.roleName === "IR" ? 6 : 3}
                              lg={selectedRole?.roleName === "IR" ? 6 : 3}
                            >
                              <Typography style={{ color: "black" }}>
                                <span className={classes.asterisk}>*</span>
                                Invoice Type:
                              </Typography>
                              <Autocomplete
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "30px",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  },
                                  "& .MuiInputBase-input": {
                                    marginTop: "-4px", // Adjust this value to move the text up
                                    fontSize: 15,
                                  },
                                }}
                                id="submitter_role"
                                options={
                                  multipleData?.invoice_Type.filter((item) => {
                                    if (user?.Location === "1") {
                                      //for MPAS user

                                      return (
                                        item?.ReferenceProp3 === "true" &&
                                        item?.ReferenceProp2 !== "HR"
                                      );
                                    } else {
                                      return item?.ReferenceProp2 !== "HR";
                                    }
                                  }) || []
                                }
                                size="small"
                                value={{
                                  ReferenceCode: formState?.invoice_Type || "",
                                }}
                                disabled={disable}
                                title="select select"
                                getOptionLabel={(option) =>
                                  (option !== "" &&
                                    `${option?.ReferenceCode}`) ||
                                  ""
                                }
                                // loading={rolesLoading}
                                onChange={(event, newValue) => {
                                  const e = {
                                    target: {
                                      name: "invoice_Type",
                                      value: newValue?.ReferenceCode,
                                    },
                                  };

                                  changeHandler(e);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    type="text"
                                    name=""
                                    placeholder="Select a value"
                                    required={formState?.isProceed}
                                  />
                                )}
                              />
                            </Grid>
                          )}
                        {/* update for conflict */}
                        {(selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "Import" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "Department Coordinator" ||
                          selectedRole?.roleName === "Logistic") && (
                          <>
                            {/* Invoice Number */}
                            {formState?.invoice_Type !== "Final Settlement - Distributor" && (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                              lg={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                            >
                              <Typography style={{ color: "black" }}>
                                <span className={classes.asterisk}>*</span>
                                Invoice No:{" "}
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                name="invoice_No"
                                type="text"
                                value={formState.invoice_No}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 30,
                                  },
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                id="outlined-basic"
                                variant="outlined"
                                required={formState?.isProceed}
                                onChange={changeHandler}
                                  onBlur={() => handleInvoiceBlur()}
                                inputProps={{ maxLength: 16 }}
                                // error ={formState.invoice_No.length > 16}
                                // helperText={formState.invoice_No.length > 16 ? 'Invoice Number must be less then or equal to 16 digits!' : ' '}
                                disabled={disable} // disable only when edit status is false
                              />
                            </Grid>
                            )}
                            {/* Invoice Date */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                              lg={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                              style={{ paddingRight: "18px" }}
                            >
                              <Typography style={{ color: "black" }}>
                                <span className={classes.asterisk}>*</span>
                                Invoice Date:{" "}
                              </Typography>

                              <input
                                className={classes.inputField}
                                name="invoice_Date"
                                type="date"
                                // max={moment().format("YYYY-MM-DD")}
                                disabled={disable}
                                style={{
                                  color: disable ? "#B4B4B4" : "black",
                                  backgroundColor: disable ? "white" : null,
                                  height: 13, // Adjust this value to decrease the height
                                }}
                                // oninput event occurs immediately after the content has been changed,
                                //while onchange occurs when the element loses focus
                                onChange={changeHandler}
                                onInput={(newValue) => {
                                  isOldDateValidate(
                                    formatDateTimeForBackend(newValue),
                                    setOpenInvalidWarningDate,
                                    setInvalidWarningDateState
                                    // setFormState
                                  );

                                  setFormState((formState) => ({
                                    ...formState,
                                    invoice_Date:
                                      formatDateTimeForBackend(newValue),
                                  }));
                                  isFutureDate(
                                    formatDateTimeForBackend(newValue),
                                    setFormState,
                                    "invoice_Date"
                                  );
                                }}
                                onBlur={(e) => {
                                  isOldDateValidate(
                                    formatDateTimeForBackend(e.target.value),
                                    setOpenInvalidWarningDate,
                                    setInvalidWarningDateState
                                    // setFormState
                                  );
                                  isFutureDate(
                                    formatDateTimeForBackend(e.target.value),
                                    setFormState,
                                    "invoice_Date"
                                  );
                                }}
                                value={formState.invoice_Date || ""}
                                required={formState?.isProceed}
                              />

                              {/*<LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          // inputProps={{ readOnly: true }}
                          shouldDisableDate={false}
                          // shouldDisableDate={isAboveToday}
                          disabled={disable}
                          dateFormat: "MM/DD/YYY"
                          // minDate={new Date("01-01-1920")}
                          // maxDate={new Date("12-31-2099")}
                          onChange={(newValue) => {
                            setFormState((formState) => ({
                              ...formState,
                              invoice_Date: formatDateTimeForBackend(newValue),
                            }));
                          }}
                          onAccept={(newValue) => {
                            isOldDateValidate(
                              formatDateTimeForBackend(newValue),
                              setOpenInvalidWarningDate,
                              setFormState
                            );
                            setFormState((formState) => ({
                              ...formState,
                              invoice_Date: formatDateTimeForBackend(newValue),
                            }));
                            isFutureDate(
                              formatDateTimeForBackend(newValue),
                              setFormState,
                              "invoice_Date"
                            );
                          }}
                          value={formState.invoice_Date || ""}
                          // error={false}
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              size="small"
                              name="invoice_Date"
                              id="outlined-basic"
                              label="Outlined"
                              variant="outlined"
                              type="date"
                              onChange={changeHandler}
                              onBlur={(e) => {
                                isOldDateValidate(
                                  formatDateTimeForBackend(e.target.value),
                                  setOpenInvalidWarningDate,
                                  setFormState
                                );
                                isFutureDate(
                                  formatDateTimeForBackend(e.target.value),
                                  setFormState,
                                  "invoice_Date"
                                );
                              }}
                              value={formState.invoice_Date || ""}
                              required
                              {...params}
                              // error={false}
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    */}
                            </Grid>
                            {/* Invoice Description */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                              lg={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                            >
                              <Typography style={{ color: "black" }}>
                                <span className={classes.asterisk}>*</span>
                                Invoice Description:{" "}
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 30,
                                  },
                                  input: { color: "black !important" },
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                id="outlined-basic"
                                name="invoice_Desc"
                                value={formState.invoice_Desc}
                                variant="outlined"
                                required={formState?.isProceed}
                                onChange={changeHandler}
                                disabled={disable}
                                inputProps={{ maxLength: 50 }}
                                FormHelperTextProps={{
                                  className: classes.helperText,
                                }}
                                error={/[!@#$%^&*()_+={}\[\]:;"'<>,?/~\\-`]/.test(
                                  formState?.invoice_Desc
                                )}
                                helperText={
                                  /[!@#$%^&*()_+={}\[\]:;"'<>,?/~\\-`]/.test(
                                    formState?.invoice_Desc
                                  )
                                    ? "Can be a word or number without any special character!"
                                    : null
                                }
                              />
                            </Grid>
                          </>
                        )}
                        {(selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "Import" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "Department Coordinator" ||
                          selectedRole?.roleName === "Logistic") && (
                          <>
                            {/* Invoice Amount */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                              lg={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                            >
                              <Typography style={{ color: "black" }}>
                                <span className={classes.asterisk}>*</span>
                                Invoice Amount:
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 30,
                                  },
                                  input: { color: "black !important" },
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                id="outlined-basic"
                                variant="outlined"
                                type="text"
                                pattern="[0-9]*"
                                min={1}
                                name="invoice_Amount"
                                value={formState?.invoice_Type == 'Final Settlement - Distributor' ? invoice_Amount_formatted : formState.invoice_Amount_formatted}
                                // value={formState.invoice_Amount}
                                InputProps={{
                                  min: 1,
                                  step: "0.00000000000000001",
                                  inputMode: "numeric",
                                }}
                                required={formState?.isProceed}
                                onChange={changeHandler}
                                disabled={disable || formState?.invoice_Type == 'Final Settlement - Distributor'}
                              />
                            </Grid>
                          </>
                        )}
                        {/* update for conflict */}

                        {!formState.isLogistics &&
                          (selectedRole?.roleName === "IR" ||
                            selectedRole?.roleName === "I2P Initiator" ||
                            selectedRole?.roleName ===
                              "Department Coordinator" ||
                            (selectedRole?.roleName === "Import" &&
                              formState.demandType !== "")) && (
                            <>
                              {/* PO Number */}
                              {((selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator") &&
                                poBasedState == "PO") ||
                              showVendorAndPO_NumberForImport() ? (
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={
                                    selectedRole?.roleName === "IR" ||
                                    selectedRole?.roleName ===
                                      "I2P Initiator" ||
                                    selectedRole?.roleName ===
                                      "Department Coordinator"
                                      ? 6
                                      : 3
                                  }
                                  lg={
                                    selectedRole?.roleName === "IR" ||
                                    selectedRole?.roleName ===
                                      "I2P Initiator" ||
                                    selectedRole?.roleName ===
                                      "Department Coordinator"
                                      ? 6
                                      : 3
                                  }
                                >
                                  <Typography style={{ color: "black" }}>
                                    {formState?.delv_Note_No ? (
                                      false
                                    ) : (
                                      <span className={classes.asterisk}>
                                        *
                                      </span>
                                    )}
                                    PO Number:
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: 30,
                                      },
                                      input: { color: "black !important" },
                                      "& legend": { display: "none" },
                                      "& fieldset": { top: 0 },
                                    }}
                                    id="outlined-basic"
                                    variant="outlined"
                                    name="pO_No"
                                    // required={formState?.delv_Note_No ? false : true}
                                    required={
                                      formState?.delv_Note_No ||
                                      formState?.isDelete
                                        ? false
                                        : true
                                    }
                                    value={formState.pO_No || ""}
                                    onChange={changeHandler}
                                    onBlur={
                                      typeByPo
                                        ? poTableAndDetailHandler
                                        : () => {}
                                    }
                                    onKeyPress={(e) => keypressHandler(e)} // when enter key press
                                    disabled={disable}
                                  />
                                </Grid>
                              ) : (
                                ""
                              )}
                            </>
                          )}

                        {(selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "Department Coordinator" ||
                          (selectedRole?.roleName === "Import" &&
                            formState.demandType !== "")) && (
                          <>
                            {/* Vendor */}
                            {((selectedRole?.roleName === "IR" ||
                              selectedRole?.roleName === "I2P Initiator" ||
                              selectedRole?.roleName ===
                                "Department Coordinator") &&
                              poBasedState == "PO") ||
                            showVendorAndPO_NumberForImport() ? (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={
                                  selectedRole?.roleName === "IR" ||
                                  selectedRole?.roleName === "I2P Initiator" ||
                                  selectedRole?.roleName ===
                                    "Department Coordinator"
                                    ? 6
                                    : 3
                                }
                                lg={
                                  selectedRole?.roleName === "IR" ||
                                  selectedRole?.roleName === "I2P Initiator" ||
                                  selectedRole?.roleName ===
                                    "Department Coordinator"
                                    ? 6
                                    : 3
                                }
                              >
                                <Typography style={{ color: "black" }}>
                                  <span className={classes.asterisk}>*</span>
                                  Vendor:
                                </Typography>
                                <TextField
                                  fullWidth
                                  size="small"
                                  // disabled={selectedRole?.roleName === "IR"}
                                  disabled={true}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: 30,
                                    },
                                    input: { color: "black !important" },
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                  id="outlined-basic"
                                  variant="outlined"
                                  name="vendor_Name"
                                  required={formState.vendor_Name === ""}
                                  value={formState.vendor_Name}
                                  onChange={changeHandler}
                                />
                              </Grid>
                            ) : (
                              ""
                            )}
                          </>
                        )}

                        {selectedRole?.roleName === "IR" &&
                          formState.isLogistics &&
                          (formState.invoice_Type === "DN" ||
                            formState.invoice_Type === "ITN") && (
                            <>
                              {/* Shipment */}
                              {
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={
                                    selectedRole?.roleName === "IR" ||
                                    selectedRole?.roleName ===
                                      "I2P Initiator" ||
                                    selectedRole?.roleName ===
                                      "Department Coordinator"
                                      ? 6
                                      : 3
                                  }
                                  lg={
                                    selectedRole?.roleName === "IR" ||
                                    selectedRole?.roleName ===
                                      "I2P Initiator" ||
                                    selectedRole?.roleName ===
                                      "Department Coordinator"
                                      ? 6
                                      : 3
                                  }
                                >
                                  <Typography style={{ color: "black" }}>
                                    <span className={classes.asterisk}>*</span>
                                    {formState.invoice_Type === "DN"
                                      ? "Shipment:"
                                      : ""}{" "}
                                    {formState.invoice_Type === "ITN"
                                      ? "STO Number:"
                                      : ""}
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    sx={{
                                      // width: "70%",
                                      "& .MuiInputBase-root": {
                                        height: 30,
                                      },
                                      input: { color: "black !important" },
                                      "& legend": { display: "none" },
                                      "& fieldset": { top: 0 },
                                    }}
                                    id="outlined-basic"
                                    variant="outlined"
                                    name="pO_No"
                                    required={formState?.isProceed}
                                    value={formState.pO_No}
                                    onChange={changeHandler}
                                    onBlur={
                                      typeByPo
                                        ? poTableAndDetailHandler
                                        : () => {}
                                    }
                                    onKeyPress={(e) => keypressHandler(e)} // when enter key press
                                    disabled={disable}
                                  />
                                </Grid>
                              }
                            </>
                          )}

                        {/*{selectedRole?.roleName === "IR" &&
                  (poBasedState == "Non-PO" || formState.isLogistics) && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={selectedRole?.roleName === "IR" ? 6 : 3}
                      lg={selectedRole?.roleName === "IR" ? 6 : 3}
                    >
                      <Typography style={{color:'black'}}>
                        Courier Tracking #
                        <span className={classes.asterisk}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        type="number"
                        name="courier_Tracking_No"
                        value={formState.courier_Tracking_No}
                        InputProps={{ inputProps: { min: 0, step: "0.001" } }}
                        onChange={changeHandler}
                      />
                    </Grid>
                      )}*/}
                        {(((selectedRole?.roleName === "IR" && formState?.invoice_Type !== "Final Settlement - Distributor")&&
                          // !formState?.isVPPayment &&
                          poBasedState === "Non-PO" &&
                          showDepartmentCordinator &&
                          formState?.invoice_Type !== "Pre Approved Payment" &&
                          formState?.invoice_Type !== "Credit Note") ||
                          (selectedRole?.roleName === "I2P Initiator" &&
                            poBasedState === "Non-PO") ||
                          (invoicePayload?.Invoice_id &&
                            formState?.dept_coordinator &&
                            selectedRole?.roleName !== "EFDV Initiator")) && (
                          <>
                            {/* Department Coordinator */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                              lg={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                            >
                              <SearchUsersRole
                                label="Department Coordinator"
                                apiString="Department Coordinator"
                                name="dept_coordinator"
                                placeholder="Select a User"
                                formState={formState}
                                setNewFormState={setFormState}
                                changeHandler={changeHandler}
                                required={formState?.isProceed}
                                disabled={depDisable}
                                classes={classes}
                              />
                              {/* <FormControl fullWidth size="small">
                          <UsersByRole
                            label="Department Coordinator"
                            apiString="Department Coordinator"
                            name="dept_coordinator"
                            formState={formState}
                            changeHandler={changeHandler}
                            required={formState?.isProceed}
                            classes={classes}
                            disabled={depDisable}
                          />
                        </FormControl> */}
                            </Grid>
                          </>
                        )}
                        {(selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "Department Coordinator" ||
                          (selectedRole?.roleName === "IR" &&
                            !formState.isLogistics)) && (
                          <>
                            {/* GRN Number */}
                            {poBasedState == "PO" && (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={
                                  selectedRole?.roleName === "IR" ||
                                  selectedRole?.roleName === "I2P Initiator" ||
                                  selectedRole?.roleName ===
                                    "Department Coordinator"
                                    ? 6
                                    : 3
                                }
                                lg={
                                  selectedRole?.roleName === "IR" ||
                                  selectedRole?.roleName === "I2P Initiator" ||
                                  selectedRole?.roleName ===
                                    "Department Coordinator"
                                    ? 6
                                    : 3
                                }
                              >
                                <Typography style={{ color: "black" }}>
                                  GRN Number:
                                  {/* <span className={classes.asterisk}>*</span> */}
                                </Typography>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: 30,
                                    },
                                    input: { color: "black !important" },
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                  id="outlined-basic"
                                  variant="outlined"
                                  name="grn_No"
                                  // required
                                  value={formState.grn_No}
                                  onChange={changeHandler}
                                  disabled={disable}
                                />
                              </Grid>
                            )}
                            {/* DN Number */}
                            {selectedRole?.roleName === "IR" &&
                              poBasedState === "PO" &&
                              !formState.isLogistics && (
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={selectedRole?.roleName === "IR" ? 6 : 3}
                                  lg={selectedRole?.roleName === "IR" ? 6 : 3}
                                >
                                  <Typography style={{ color: "black" }}>
                                    {formState?.pO_No === "" ? (
                                      <span className={classes.asterisk}>
                                        *
                                      </span>
                                    ) : null}
                                    DN Number:{" "}
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: 30,
                                      },
                                      input: { color: "black !important" },
                                      "& legend": { display: "none" },
                                      "& fieldset": { top: 0 },
                                    }}
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={disable}
                                    name="delv_Note_No"
                                    required={
                                      formState?.pO_No === "" ? true : false
                                    }
                                    value={formState.delv_Note_No || ""}
                                    onChange={changeHandler}
                                    onBlur={
                                      typeByDN ? getDNDetailsOnBLur : () => {}
                                    }
                                    onKeyPress={(e) => keypressHandler(e)}
                                  />
                                </Grid>
                              )}
                          </>
                        )}

                        {(selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "Logistic" ||
                          selectedRole?.roleName === "Import") && (
                          <>
                            {/* Bar code */}
                            {/* poBasedState === "Non-PO" */}
                            {/* {physicalOrEInvoice === "Physical" && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={selectedRole?.roleName === "IR" ? 6 : 3}
                          lg={selectedRole?.roleName === "IR" ? 6 : 3}
                        >
                          <Typography style={{ color: "black" }}>
                            Bar code
                            <span className={classes.asterisk}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            sx={{
                              // width: "70%",
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            id="outlined-basic"
                            variant="outlined"
                            required
                            type="text"
                            name="barcode_No"
                            value={formState.barcode_No}
                            onChange={changeHandler}
                          />
                        </Grid>
                      )} */}

                            {/* Tax Team */}
                            {!formState.skipTaxStep &&
                              // !formState.isVPPayment &&
                              selectedRole?.roleName !== "Import" && (
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={selectedRole?.roleName === "IR" ? 6 : 3}
                                  lg={selectedRole?.roleName === "IR" ? 6 : 3}
                                >
                                  <FormControl fullWidth size="small">
                                    <SearchUsersRole
                                      label="Tax Team"
                                      apiString="Tax Team"
                                      name="taxTeam" // pending.
                                      placeholder="Select a User"
                                      formState={formState}
                                      setNewFormState={setFormState}
                                      changeHandler={changeHandler}
                                      required={formState?.isProceed}
                                      disabled={disable}
                                      classes={classes}
                                    />
                                  </FormControl>
                                  {/* <FormControl fullWidth size="small">
                           
                              {(poBasedState === "Non-PO" &&
                                formState?.invoice_Type &&
                                !formState.isLogistics) ||
                              (!formState.pO_Based &&
                                formState?.invoice_Type &&
                                !formState.isLogistics) ? (
                                <>
                                  <Typography style={{ color: "black" }}>
                               
                                    <span className={classes.asterisk}>*</span>
                                    Tax Team:
                                  </Typography>
                                  <Autocomplete
                                    size="small"
                                    style={{ width: "100%" }}
                                    name="taxTeam"
                                    disabled={disable}
                                    value={
                                      taxuser.find(
                                        (user) =>
                                          user?.id === formState?.taxTeam
                                      ) || ""
                                    }
                                    onChange={(event, newValue) => {
                                      setFormState((formState) => ({
                                        ...formState,
                                        taxTeam: newValue?.id || "",
                                      }));
                                    }}
                                    options={taxuser}
                                    getOptionLabel={(option) =>
                                      option
                                        ? `${option.userName}` ||
                                          `${option.username}`
                                        : ""
                                    }
                                    loading={loading}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        size="small"
                                        required={formState?.isProceed}
                                        placeholder="select a user"
                                      />
                                    )}
                                  />
                               
                                </>
                              ) : (
                                // <UsersByRole
                                //   label="Tax Team"
                                //   apiString="Tax Team"
                                //   name="taxTeam"
                                //   formState={formState}
                                //   changeHandler={changeHandler}
                                //   required={formState?.isProceed}
                                //   classes={classes}
                                //   disabled={disable}
                                // />
                                <SearchUsersRole
                                  label="Tax Team"
                                  apiString="Tax Team"
                                  name="taxTeam" // pending.
                                  placeholder="Select a User"
                                  formState={formState}
                                  setNewFormState={setFormState}
                                  changeHandler={changeHandler}
                                  required={formState?.isProceed}
                                  disabled={disable}
                                  classes={classes}
                                />
                              )}
                            </FormControl> */}
                                </Grid>
                              )}
                            {/* IP user */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={selectedRole?.roleName === "IR" ? 6 : 3}
                              lg={selectedRole?.roleName === "IR" ? 6 : 3}
                            >
                              {/* <FormControl fullWidth size="small">
                          <UsersByRole
                            label="IP User"
                            apiString="IP"
                            name="ipUser"
                            formState={formState}
                            changeHandler={changeHandler}
                            required={formState?.isProceed}
                            classes={classes}
                            disabled={disable}
                          />
                        </FormControl> */}
                              <SearchUsersRole
                                label="IP User"
                                apiString="IP"
                                name="ipUser" // pending.
                                placeholder="Select a User"
                                formState={formState}
                                setNewFormState={setFormState}
                                changeHandler={changeHandler}
                                required={formState?.isProceed}
                                disabled={false}
                                classes={classes}
                              />
                            </Grid>
                            {/*  {formState.isLogistics && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={selectedRole?.roleName === "IR" ? 6 : 3}
                          lg={selectedRole?.roleName === "IR" ? 6 : 3}
                        >
                          <FormControl fullWidth size="small">
                            <UsersByRole
                              label="Logistic Team"
                              apiString="Logistic"
                              name="logisticsTeam"
                              formState={formState}
                              changeHandler={changeHandler}
                              required={formState?.isProceed}
                              classes={classes}
                              disabled={disable}
                            />
                          </FormControl>
                        </Grid>
                   )}*/}
                          </>
                        )}
                        {(selectedRole?.roleName === "I2P Initiator" ||
                          ((selectedRole?.roleName === "Department Coordinator" && formState.invoice_Type!=='DES' ) && (selectedRole?.roleName === "Department Coordinator" && formState.invoice_Type !== "Rent")) ||
                          (selectedRole?.roleName === "IR" &&
                            !formState.isLogistics)) && (
                          <>
                            {/* IR user */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                              lg={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator"
                                  ? 6
                                  : 3
                              }
                            >
                              {selectedRole?.roleName === "I2P Initiator" ||
                              selectedRole?.roleName ===
                                "Department Coordinator" ||
                              invoicePayload?.Invoice_id ? (
                                <SearchUsersRole
                                  label="IR User"
                                  apiString="IR"
                                  name="irUser" // pending.
                                  placeholder="Select a User"
                                  formState={formState}
                                  setNewFormState={setFormState}
                                  changeHandler={changeHandler}
                                  required={formState?.isProceed}
                                  disabled={disable}
                                  classes={classes}
                                />
                              ) : (
                                // <FormControl fullWidth size="small">
                                //   <UsersByRole
                                //     label="IR User"
                                //     apiString="IR"
                                //     name="irUser"
                                //     formState={formState}
                                //     changeHandler={changeHandler}
                                //     required={formState?.isProceed}
                                //     classes={classes}
                                //     disabled={disable}
                                //   />
                                // </FormControl>
                                <>
                                  <Typography style={{ color: "black" }}>
                                    <span className={classes.asterisk}>*</span>
                                    IR User:
                                  </Typography>

                                  <FormControl fullWidth size="small">
                                    <Select
                                      labelId="demo-simple-name-label"
                                      id="demo-simple-name"
                                      // label="Select a Value"
                                      name="irUser"
                                      // defaultValue={user?.LoginId}
                                      value={formState.irUser}
                                      onChange={changeHandler}
                                      style={{ height: 30 }}
                                      // MenuProps={MenuProps}
                                      // InputLabelProps={{ shrink: false, required: false, className: classes.hs_form_required }}
                                      // select
                                      // fullWidth
                                      // size="small"
                                      disabled
                                    >
                                      {!loading ? (
                                        userData.length > 0 ? (
                                          userData
                                            ?.filter((item) => {
                                              return (
                                                item.userId === user?.LoginId
                                              );
                                            })
                                            .map((item, index) => (
                                              <MenuItem
                                                key={index}
                                                value={item.userId}
                                              >
                                                {item.userName}
                                              </MenuItem>
                                            ))
                                        ) : (
                                          <MenuItem disabled>
                                            Not Found
                                          </MenuItem>
                                        )
                                      ) : (
                                        <MenuItem>
                                          <CircularProgress size={24} />
                                        </MenuItem>
                                      )}
                                    </Select>
                                  </FormControl>
                                </>
                              )}
                            </Grid>
                          </>
                        )}
                        {(selectedRole?.roleName === "Import" ||
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "EFDV Initiator" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "Department Coordinator" ||
                          selectedRole?.roleName === "HR" ||
                          selectedRole?.roleName === "Logistic") && (
                          <>
                            {/* comments */}
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography style={{ color: "black" }}>
                                {(formState?.isReturn || reviewer) ? (
                                  <span className={classes.asterisk}>*</span>
                                ) : (
                                  ""
                                )}
                                Comments:
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                // multiline
                                // rows={2}
                                // maxRows={2}
                                // size="small"
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 30,
                                  },
                                  input: { color: "black !important" },
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                id="outlined-basic"
                                variant="outlined"
                                name="comments"
                                required={
                                  formState?.isReturn || formState?.isBuyerPR || reviewer || formState?.isQuick
                                }
                                value={formState.comments}
                                onChange={changeHandler}
                                disabled={disable}
                              />
                            </Grid>
                          </>
                        )}

                        {(selectedRole?.roleName === "Import" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "Department Coordinator" ||
                          selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "HR" ||
                          selectedRole?.roleName === "EFDV Initiator" ||
                          selectedRole?.roleName === "Logistic") && (
                          <>
                            {/* Additional Document */}

                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator" ||
                                selectedRole?.roleName === "HR"
                                  ? 6
                                  : 3
                              }
                              lg={
                                selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" ||
                                selectedRole?.roleName ===
                                  "Department Coordinator" ||
                                selectedRole?.roleName === "HR"
                                  ? 6
                                  : 3
                              }
                              // style={{ marginTop:`${selectedRole?.roleName}` === "HR" ? "6px" : null }}
                            >
                              <Typography style={{ color: "black" }}>
                                Additional Documents:{" "}
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 30,
                                  },
                                  input: { color: "black !important" },
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                id="outlined-basic"
                                variant="outlined"
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <input
                                        ref={additionalAttachmentRef}
                                        type="file"
                                        // accept=".png, .jpg, .jpeg, .pdf"
                                        name="additionalDocIds"
                                        onChange={(e) =>
                                          uploadAdditioalDocumentFile(
                                            e,
                                            setFormState,
                                            setAttchmentLoader,
                                            "additionalDocIds",
                                            additionalAttachmentRef,
                                            setDocError,
                                            setAttachError,
                                            setAlertMessage,
                                            invoicePayload,
                                            selectedRole,
                                            dragfile,
                                            setDragFile,
                                            setSuccessMessage,
                                            setAttachmentURLList,
                                            setAttachmentURL   
                                          )
                                        }
                                        style={{ width: "209px" }}
                                        disabled={disable}
                                        multiple
                                      />

                                      {attachmentLoader ? (
                                        <CircularProgress size={24} />
                                      ) : (
                                        ""
                                      )}
                                    </InputAdornment>
                                  ),
                                }}
                                // FormHelperTextProps={{
                                //   className: classes.helperText,
                                // }}
                                error={alertMessage ? true : false}
                                // helperText={docError ? `${docError}` : null}
                              />

                              {formState.additionalDocIds?.length > 0 &&
                                formState.additionalDocIds?.map((f, index) => {
                                  const s = f?.path?.split("\\");
                                  const ss = s[s?.length - 1];
                                  // const ss = s[s.length !== "NAN" ? s?.length-1 : 0]
                                  // above 2 lines is for get name of file
                                  return (
                                    <>
                                      {f?.path !== "" ? (
                                        <>
                                          <IconButton
                                            size="small"
                                            // disabled={
                                            //   disable ||
                                            //   f.role_Name !== selectedRole?.roleName
                                            // }
                                            onClick={() => {
                                              const files =
                                                formState.additionalDocIds.find(
                                                  (x, i) => {
                                                    const n =
                                                      x?.path?.split("\\");
                                                    const nn = n[n.length - 1];
                                                    return nn === ss;
                                                  }
                                                );
                                              downloadAttachments(files?.path);
                                            }}
                                          >
                                            <Download
                                              titleAccess="Download"
                                              color="secondary"
                                              fontSize="small"
                                              style={{
                                                color: disable ? "gray" : "",
                                              }}
                                            />
                                          </IconButton>
                                          <IconButton
                                            size="small"
                                            disabled={
                                              disable ||
                                              f.role_Name !==
                                                selectedRole?.roleName
                                            }
                                            onClick={() => {
                                              setInvoiceDelete(f);
                                              setOpenWarningBox(true);
                                              setWarningFlag(true);
                                            }}
                                          >
                                            <Delete
                                              titleAccess="Delete"
                                              color="danger"
                                              fontSize="small"
                                              style={{
                                                color:
                                                  disable ||
                                                  f.role_Name !==
                                                    selectedRole?.roleName
                                                    ? "gray"
                                                    : "",
                                              }}
                                            />
                                          </IconButton>
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              const extension = f.path
                                                ?.match(/\.[^.]+$/)[0]
                                                .substring(1);

                                              const allowedExtensions = [
                                                ".png",
                                                ".pdf",
                                                ".jpg",
                                                ".jpeg",
                                                ".PNG",
                                                ".JPG",
                                                ".JPEG",
                                                ".PNG",
                                                ".PDF",
                                              ];
                                              const fileExtension =
                                                "." + ss.split(".").pop();
                                              if (
                                                allowedExtensions.includes(
                                                  fileExtension
                                                )
                                              ) {
                                                setAttachmentURL(f);
                                              } else {
                                                if (
                                                  isContainEmailFormate(
                                                    extension
                                                  )
                                                ) {
                                                  downloadAttachments(f.path);
                                                } else {
                                                  setAttachmentURL(f);

                                                  window.open(
                                                    `${process.env.REACT_APP_API_URL}/${f.path}`,
                                                    "_blank"
                                                  );
                                                }
                                              }
                                            }}
                                          >
                                            {ss}
                                          </span>

                                          {/*  <a
                                        style={{
                                          fontSize: "14px",
                                          textDecoration: "none",
                                          cursor: "pointer",
                                          color:
                                            edit == "false" ? "gray" : "black",
                                          //  pointerEvents: disable ? "none" : ""
                                        }}
                                        href={`${process.env.REACT_APP_API_URL}/Uploads/${ss}`}
                                        target="_blank"
                                      >
                                        {ss}
                                      </a>*/}

                                          <div></div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  );
                                })}
                            </Grid>
                          </>
                        )}
                        {selectedRole?.roleName === "Import" && (
                          <>
                            {loamCheck && (
                              <Grid item xs={12} sm={12} md={3} lg={3}>
                                <Typography style={{ color: "black" }}>
                                  <span className={classes.asterisk}>
                                    {!formState?.isReturn ? "*" : ""}
                                  </span>
                                  Loam Approver:
                                </Typography>
                                <Autocomplete
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: "30px",
                                      textAlign: "center",
                                      display: "flex",
                                      alignItems: "center",
                                    },
                                    "& .MuiInputBase-input": {
                                      marginTop: "-4px", // Adjust this value to move the text up
                                      fontSize: 15,
                                    },
                                  }}
                                  size="small"
                                  style={{ width: "100%" }}
                                  disabled={disable}
                                  value={
                                    loamUser.find((user) =>
                                      user?.UserID
                                        ? user?.UserID ===
                                          formState?.loam_approver
                                        : user?.Name ===
                                          formState?.loam_approver
                                    ) || ""
                                  }
                                  onChange={(e, newValue) => {
                                    const hasLowerCareerLadder = loamUser?.some(
                                      (user) => {
                                        const selectedCareerLadder = parseInt(
                                          newValue?.CarrierLadder?.replace(
                                            /\D/g,
                                            ""
                                          ),
                                          10
                                        );
                                        const userCareerLadder = parseInt(
                                          user?.CarrierLadder?.replace(
                                            /\D/g,
                                            ""
                                          ),
                                          10
                                        );
                                        return (
                                          userCareerLadder <
                                          selectedCareerLadder
                                        );
                                      }
                                    );

                                    if (hasLowerCareerLadder) {
                                      sethigherLoamApprover(true);
                                    }
                                    setFormState({
                                      ...formState,
                                      loam_approver: newValue?.UserID
                                        ? newValue?.UserID
                                        : newValue?.Name,
                                    });

                                    if (
                                      newValue?.UserID === "" ||
                                      newValue?.UserID === "null"
                                    ) {
                                      setLoamApprover(true);
                                    } else {
                                      setLoamApprover(false);
                                      setErrorMessage("");
                                    }
                                  }}
                                  options={loamUser}
                                  getOptionLabel={(option) =>
                                    option
                                      ? option?.PersonalNumber
                                        ? `${option?.PersonalNumber} -` +
                                          `${option?.Name}`
                                        : `${option?.Name}`
                                      : ""
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      // variant="standard"
                                      size="small"
                                      placeholder="Select loam Approver"
                                      required={
                                        formState?.isProceed &&
                                        !formState?.isReturn
                                      }
                                    />
                                  )}
                                />
                                {/* <FormControl fullWidth size="small">
                            <UsersByRole
                              label="Loam Approver User"
                              apiString="Loam Approver"
                              name="loam_approver"
                              formState={formState}
                              changeHandler={changeHandler}
                              required={formState?.isProceed}
                              classes={classes}
                              disabled={disable}
                            />
                          </FormControl> */}
                              </Grid>
                            )}
                          </>
                        )}
                      </Grid>
                      {
  (selectedRole?.roleName === "IR" ||
    selectedRole?.roleName === "I2P Initiator" ||
    selectedRole?.roleName === "Department Coordinator" ||
    (selectedRole?.roleName === "Import" && formState.demandType !== "")
  ) && (
    ((selectedRole?.roleName === "IR" ||
      selectedRole?.roleName === "I2P Initiator" ||
      selectedRole?.roleName === "Department Coordinator") &&
      poBasedState == "PO") ||
    showVendorAndPO_NumberForImport()
  ) && (
    <Grid container spacing={2} marginY={3}>
      {/* PO Date Field */}
     {
      (!formState.isLogistics && formState?.po_Date !== "") &&

      <Grid item xs={12} md={6}>
      <Typography style={{ color: "black" }}>
                                    
        PO Date:

                                    
      </Typography>
      <TextField
        fullWidth
        size="small"
        sx={{
                                      "& .MuiInputBase-root": {
                                        height: 30,
                                      },
          input: { color: "black !important" },
          "& legend": { display: "none" },
          "& fieldset": { top: 0 },
        }}
                                    id="outlined-basic"
        variant="outlined"
        name="po_date"
                                    // required={formState?.delv_Note_No ? false : true}
                                 
                                    value={typeof(formState?.po_Date) == "string" && formState?.po_Date?.split("-")?.reverse()?.join("/") || ""}
        onChange={changeHandler}
                                    onBlur={
                                      typeByPo
                                        ? poTableAndDetailHandler
                                        : () => {}
                                    }
                                    onKeyPress={(e) => keypressHandler(e)} // when enter key press
        disabled={true}
      />
    </Grid>
     }

      {/* Plant Code Field */}

     {
       (!formState.isLogistics && formState?.plant_Code !== "") &&

       <Grid item xs={12} md={6}>
       <Typography style={{ color: "black" }}>
         Plant Code:
       </Typography>
       <TextField
         fullWidth
         size="small"
         sx={{
           "& .MuiInputBase-root": { height: 30 },
           input: { color: "black !important" },
           "& legend": { display: "none" },
           "& fieldset": { top: 0 },
         }}
         id="outlined-plant-code"
         variant="outlined"
         name="plant_Code"
         value={formState?.plant_Code || ""}
         onChange={changeHandler}
         onBlur={typeByPo ? poTableAndDetailHandler : () => {}}
         onKeyPress={(e) => keypressHandler(e)}
         disabled={true}
       />
     </Grid>
     }  
    </Grid>
)}
<Grid container spacing={2} marginY={3}>


{(!formState.isLogistics && formState?.invoice_Date !== "" ) && 
                          (selectedRole?.roleName === "IR" ||
                            selectedRole?.roleName === "I2P Initiator" 
                           ) && (
                            <>
                              {/* PO Number */}
                              {((selectedRole?.roleName === "IR" ||
                                selectedRole?.roleName === "I2P Initiator" )) ||
                              showVendorAndPO_NumberForImport() ? (
                                <Grid
                                  item
                                  xs={12}
                                  marginY={3}
                                  sm={12}
                                  md={
                                    selectedRole?.roleName === "IR" ||
                                    selectedRole?.roleName ===
                                      "I2P Initiator" 
                                      ? 6
                                      : 3
                                  }
                                  lg={
                                    selectedRole?.roleName === "IR" ||
                                    selectedRole?.roleName ===
                                      "I2P Initiator" 
                                      ? 6
                                      : 3
                                  }
                                >
                                  <Typography style={{ color: "black" }}>
                                    
                                    Due Date:
 
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: 30,
                                      },
                                      input: { color: "black !important" },
                                      "& legend": { display: "none" },
                                      "& fieldset": { top: 0 },
                                    }}
                                    id="outlined-basic"
                                    variant="outlined"
                                    name="po_date"
                                    // required={formState?.delv_Note_No ? false : true}
                                 
                                    value={typeof(formState?.dueOn) == "string" && formState?.dueOn?.split("-")?.reverse()?.join("/") || ""}
                                    onChange={changeHandler}
                                    onBlur={
                                      typeByPo
                                        ? poTableAndDetailHandler
                                        : () => {}
                                    }
                                    onKeyPress={(e) => keypressHandler(e)} // when enter key press
                                    disabled={true}
                                  />
                                  
                                </Grid>
                              ) : (
                                ""
                              )}
                            </>
                          )}

                         {/* { formState?.rtbId && (
  <Grid
    item
    xs={12}
    marginY={3}
    sm={12}
    md={selectedRole?.roleName === "IR" || selectedRole?.roleName === "I2P Initiator" ? 6 : 3}
       lg={
                                    selectedRole?.roleName === "IR" ||
                                    selectedRole?.roleName ===
                                      "I2P Initiator" 
                                      ? 6
                                      : 3
                                  }
  >
    <Typography style={{ color: "black" }}>
      RTB ID:
    </Typography>
    <TextField
      fullWidth
      size="small"
      sx={{
        "& .MuiInputBase-root": { height: 30 },
        input: { color: "black !important" },
        "& legend": { display: "none" },
        "& fieldset": { top: 0 },
      }}
      id="outlined-basic"
      variant="outlined"
      name="rtbId"
      value={formState?.rtbId || ""}
      onChange={changeHandler}
      disabled={true}
    />
  </Grid>
)} */}
</Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {(selectedRole?.roleName === "IR" ||
                  selectedRole?.roleName === "I2P Initiator" ||
                  selectedRole?.roleName === "Import" ||
                  selectedRole?.roleName === "Department Coordinator" ||
                  selectedRole?.roleName === "HR") && (
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Heading title="Attachment Preview">
                      <span>
                        {attachmentURLList != ""
                          ? attachmentURL == formState?.invoice_attachment?.path
                            ? " (Invoice Attachmnets)"
                            : "(Additional Documents)"
                          : null}
                      </span>
                    </Heading>

                    {attachmentURLList == "" ? (
                      <>
                        <img
                          // width="80%"
                          // style={imgStyle}

                          width="100%"
                          height="75%"
                          // ref={imgRef}
                          src={AlterImg}
                          alt="file can't preview"
                        />
                      </>
                    ) : (
                      <AttachmentsCover
                        attachmentURLList={attachmentURLList}
                        setAttachmentURLList={setAttachmentURLList}
                        attachmentURL={attachmentURL}
                        setAttachmentURL={setAttachmentURL}
                        formState={formState}
                        invoice_attachmentRef={invoice_attachmentRef}
                      />
                    )}
                  </Grid>
                )}





              </Grid>
              {/* for Image ends here */}
              <Grid container spacing={2} >
              {(selectedRole?.roleName === "IR" || selectedRole?.roleName === "EFDV Initiator") && (
                  <>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                    {((formState?.invoice_Type === "Final Settlement - Distributor" && selectedRole?.roleName === "IR") ||
  (formState?.invoice_Type !== "Final Settlement - Distributor" && !invoiceId && selectedRole?.roleName === "IR") || selectedRole?.roleName === "EFDV Initiator") && <>
                      <Typography style={{ color: "black" }}>
                          <span className={classes.asterisk}>
                                                  {selectedRole?.roleName === "IR"  && formState?.invoice_Type === "Final Settlement - Distributor" ? "*" : ""}
                                                </span>
                           
                            Add Reviewer:{" "}
                          </Typography>
                              <Autocomplete
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: (formState.loamReviewer?.length || 0) === 0 ? "30px" : "auto",
                                  textAlign: "center",
                                  display: "flex",
                                  alignItems: "center",
                                },
                                "& .MuiInputBase-input": {
                                  marginTop: "-4px",
                                  fontSize: 15,
                                },
                              }}
                              multiple                             
                              disabled={disable}
                              options={filteredUserData || []} // Ensure options is never undefined
                              getOptionLabel={(option) => option.userName}
                              getOptionDisabled={(option) =>
                                formState?.loamReviewer?.includes(option?.userId) || false
                              }
                              value={formState?.loamReviewer?.length!==0 && formState?.loamReviewer?.map((reviewerId) =>
                                reviewerData?.find((user) => user.userId === reviewerId)
                              ) || []}
                              loading={loading}
                              onChange={(event, newValue) => {
                                setFormState((prevFormState) => ({
                                  ...prevFormState,
                                  loamReviewer: newValue?.map(user => user?.userId) || [],
                                }));
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  size="small"
                                   required = {(selectedRole?.roleName === "IR"  && formState?.invoice_Type === "Final Settlement - Distributor" && formState.loamReviewer?.length === 0) ? true : false }
                                  fullWidth
                                  placeholder={
                                    (formState.loamReviewer?.length || 0) === 0
                                      ? "Select Reviewers"
                                      : ""
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {loading ? (
                                          <CircularProgress
                                            color="inherit"
                                            size={20}
                                          />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    key={index}
                                    label={option?.userName}
                                    onDelete={() => {
                                      const updatedReviewers = formState?.loamReviewer?.filter(
                                        userId => userId !== option.userId
                                      ) || [];
                                      setFormState((prevFormState) => ({
                                        ...prevFormState,
                                        loamReviewer: updatedReviewers,
                                      }));
                                    }}
                                    deleteIcon={<CloseIcon />}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      backgroundColor: "#e0e0e0",
                                      padding: "2px",
                                      marginRight: "4px",
                                    }}
                                    {...getTagProps({ index })}
                                  />
                                ))
                              }
                            />                           
                            </>
                              } 
                    </Grid>
                     {/* {(
 formState?.rtbId
) && (
  <Grid container spacing={2} marginY={2}>
    <Grid item xs={12}>
      <RTBLineItems_Table 
      formState={formState}
      setFormState={setFormState}
      selectedRole={selectedRole}
      setSelectedTotal={() => {}}
      disabled={disable}
      />
    </Grid>
  </Grid>
)} */}

 {
                      formState?.invoice_Type === "Final Settlement - Distributor" && (
                         <Grid item xs={12} sm={12} md={3} lg={3}>
                                              <Typography style={{ color: "black" }}>
                                                <span className={classes.asterisk}>
                                                  {!formState?.isReturn ? "*" : ""}
                                                </span>
                                                Loam Approver:
                                              </Typography>
                                              <Autocomplete
                                                sx={{
                                                  "& .MuiInputBase-root": {
                                                    height: "30px",
                                                    textAlign: "center",
                                                    display: "flex",
                                                    alignItems: "center",
                                                  },
                                                  "& .MuiInputBase-input": {
                                                    marginTop: "-4px", // Adjust this value to move the text up
                                                    fontSize: 15,
                                                  },
                                                }}
                                                size="small"
                                                style={{ width: "100%" }}
                                                // disabled={reviwerFlag}
                                                value={
                                                  loamUser.find((user) =>
                                                    user?.UserID
                                                      ? user?.UserID === formState?.loam_approver
                                                      : user?.Name === formState?.loam_approver
                                                  ) || ""
                                                }
                                                onChange={(e, newValue) => {
                                                  LoamUserHandler(newValue);
                                                }}
                                                options={loamUser}
                                                getOptionLabel={(option) =>
                                                  option
                                                    ? option?.PersonalNumber
                                                      ? `${option?.PersonalNumber} -` +
                                                        `${option?.Name}`
                                                      : `${option?.Name}`
                                                    : ""
                                                }
                                                loading={loamLoading}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    // variant="standard"
                                                    size="small"
                                                    // required
                                                    // InputProps={{
                                                    //   ...params.InputProps,
                                                    //   disableUnderline: true,
                                                    // }}
                                                    placeholder="Select loam Approver"
                                                    required={
                                                      formState?.isProceed &&
                                                      !formState?.isReturn
                                                    }
                                                  />
                                                )}
                                              />
                                            </Grid>
                      )
                    }
                  
  
                  </>
                )}
                </Grid>
              <Grid container spacing={1} style={{ marginTop: "2px" }}>
                {selectedRole?.roleName === "IR" && (
                  <>
                    {/* Additional comments */}
                    <Grid item xs={12} sm={12} md={3} lg={12}>
                      <Typography style={{ color: "black" }}>
                        Additional Comments:
                        {/* <span className={classes.asterisk}>*</span> */}
                      </Typography>
                      <TextField
                        fullWidth
                        multiline
                        name="aditional_Comments"
                        value={formState.aditional_Comments}
                        onChange={(e) => {
                          setFormState({
                            ...formState,
                            aditional_Comments: e.target.value,
                          });
                        }}
                        // rows={2}
                        maxRows={4}
                        // size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        disabled={disable}
                        // required={formState?.isQuick}
                      />
                    </Grid>
                  </>
                )}
                {/*<Grid container xs={12} sm={12} md={6} lg={6}>
            {(selectedRole?.roleName === "IR" ||
              selectedRole?.roleName === "Import" ||
              selectedRole?.roleName === "I2P Initiator" ||
              selectedRole?.roleName === "Logistic") && (
              <><FileAttachments imgsrc={imgsrc} imgPreview={imgPreview} docsrc={docsrc} docPreview={docPreview}/></>)}</Grid> */}


 {(selectedRole?.roleName === "Department Coordinator" &&
      showGLTable?.showForRENT &&
      !formState.invoice_Id) && (
      <ProvinceModal
        setOpen={setOpenProvince}
        open={openProvince}
        formState={formState}
        setFormState={setFormState}
      />
    )}


                {selectedRole?.roleName === "HR"||
                                    (selectedRole?.roleName === "Department Coordinator" && (showGLTable?.showForDES || showGLTable?.showForRENT) || (selectedRole?.roleName === "IR" && formState?.invoice_Type === "Final Settlement - Distributor") )?  (
                  <>
                    {/* //Vendor Table */}
                    {formState.invoiceCategory ===
                      "Final Settlement – Death case" && (
                      <Grid container spacing={2} style={{ marginTop: "30px" }}>
                        <Grid item xs={12} sm={12} md={6} lg={12}>
                          <Vendor_Table
                            formState={formState}
                            setFormState={setFormState}
                            disabled={disable}
                            vendorList={vendorList}
                            setVendorList={setVendorList}
                          />
                        </Grid>
                      </Grid>
                    )}

                    {/* //Table G_L */}
                    <Grid container spacing={0} >
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Heading title="G/L Account" />
                        <GL_Table_V2
                          formState={formState}
                          setFormState={setFormState}
                          show={false}
                          reviwerFlag={disable ? true : false}
                          setInvoice_Amount_formatted = {setInvoice_Amount_formatted}
                          role={(selectedRole?.roleName === "Department Coordinator" && (formState.invoice_Type=='DES' ||  formState.invoice_Type=='Rent'))?"": (selectedRole?.roleName === "IR" && formState?.invoice_Type === "Final Settlement - Distributor") ? "IR" : "HR"}    
                          setErrorMessage={setErrorMessage}
                          />
                      </Grid>
                       
                    </Grid>

                     {(selectedRole?.roleName === "Department Coordinator" && (showGLTable?.showForRENT)) &&
                  <Grid container spacing={0} style={{ marginTop: "0px" }}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>

                      <DepartmentCoordinatorRent 
                        formState={formState}
                        setFormState={setFormState}
                        show={false}
                        reviwerFlag={disable ? true : false}
                        role={(selectedRole?.roleName === "Department Coordinator" && formState.invoice_Type=='Rent')?"":"HR"}    />
</Grid>
                </Grid>
 }
                       {(!formState.isImport && selectedRole?.roleName === "Department Coordinator" && (formState.invoice_Type=='DES' || formState?.invoice_Type == "Rent"))   && (
                                          <Grid
                                            container
                                            spacing={1}
                                            style={{ marginTop: formState?.invoice_Type == "Rent" ? "10px" : "1px", padding: " 0px 5px " }}>
                                            {/* Loam Approver */}
                                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                              <Typography style={{ color: "black" }}>
                                                <span className={classes.asterisk}>
                                                  {!formState?.isReturn ? "*" : ""}
                                                </span>
                                                Loam Approver:
                                              </Typography>
                                              <Autocomplete
                                                sx={{
                                                  "& .MuiInputBase-root": {
                                                    height: "30px",
                                                    textAlign: "center",
                                                    display: "flex",
                                                    alignItems: "center",
                                                  },
                                                  "& .MuiInputBase-input": {
                                                    marginTop: "-4px", // Adjust this value to move the text up
                                                    fontSize: 15,
                                                  },
                                                }}
                                                size="small"
                                                style={{ width: "100%" }}
                                                // disabled={reviwerFlag}
                                                value={
                                                  loamUser.find((user) =>
                                                    user?.UserID
                                                      ? user?.UserID === formState?.loam_approver
                                                      : user?.Name === formState?.loam_approver
                                                  ) || ""
                                                }
                                                onChange={(e, newValue) => {
                                                  LoamUserHandler(newValue);
                                                }}
                                                options={loamUser}
                                                getOptionLabel={(option) =>
                                                  option
                                                    ? option?.PersonalNumber
                                                      ? `${option?.PersonalNumber} -` +
                                                        `${option?.Name}`
                                                      : `${option?.Name}`
                                                    : ""
                                                }
                                                loading={loamLoading}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    // variant="standard"
                                                    size="small"
                                                    // required
                                                    // InputProps={{
                                                    //   ...params.InputProps,
                                                    //   disableUnderline: true,
                                                    // }}
                                                    placeholder="Select loam Approver"
                                                    required={
                                                      formState?.isProceed &&
                                                      !formState?.isReturn
                                                    }
                                                  />
                                                )}
                                              />
                                            </Grid>
                                           
                                            <Grid item xs={12} sm={12} md={6} lg={3}>
                              <SearchUsersRole
                                label="IP User"
                                apiString="IP"
                                name="ipUser" // pending.
                                placeholder="Select a User"
                                formState={formState}
                                setNewFormState={setFormState}
                                changeHandler={changeHandler}
                                required={formState?.isProceed}
                                disabled={false}
                                classes={classes}
                              />
                              {/* <UsersByRole
                                label="IP User"
                                apiString="IP"
                                name="ipUser"
                                formState={formState}
                                changeHandler={changeHandler}
                                required={formState?.isProceed}
                                classes={classes}
                                disabled={disable}
                              /> */}
                            </Grid>
                                            {/* Add Reviewer */}
                                            <Grid item xs={12} sm={12} md={6} lg={3}>
                                              <Typography style={{ color: "black" }}>
                                                {/* {RequiredReviwer ? (
                                                  <span className={classes.asterisk}>*</span>
                                                ) : null} */}
                                                Add Reviewer:{" "}
                                              </Typography>
                                              <Autocomplete
                                                sx={{
                                                  "& .MuiInputBase-root": {
                                                    height:
                                                      (formState.loamReviewer?.length || 0) === 0
                                                        ? "30px"
                                                        : "auto",
                                                    textAlign: "center",
                                                    display: "flex",
                                                    alignItems: "center",
                                                  },
                                                  "& .MuiInputBase-input": {
                                                    marginTop: "-4px",
                                                    fontSize: 15,
                                                  },
                                                }}
                                                multiple
                                                options={filteredUserData || []} // Ensure options is never undefined
                                                getOptionLabel={(option) => option.userName}
                                                getOptionDisabled={(option) =>
                                                  formState?.loamReviewer?.includes(
                                                    option?.userId
                                                  ) || false
                                                }
                                                value={formState?.loamReviewer!=="" && formState?.loamReviewer?.map((reviewerId) =>
                                                  reviewerData?.find((user) => user.userId === reviewerId)
                                                ) || []}
                                                loading={loading}
                                                onChange={(event, newValue) => {
                                                  setFormState((prevFormState) => ({
                                                    ...prevFormState,
                                                    loamReviewer:
                                                      newValue?.map((user) => user?.userId) || [],
                                                  }));
                                                  if (
                                                    (formState?.loamReviewer !== undefined ||
                                                      formState?.loamReviewer !== "" || formState?.loamReviewer.length > 0) &&
                                                    ReviewerMandatory[0]?.ReferenceProp5 ==
                                                      "True" &&
                                                    selectedRole?.roleName ===
                                                      "Department Coordinator"
                                                  ) {
                                                    setErrorMessage("");
                                                  }
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    placeholder={
                                                      (formState.loamReviewer?.length || 0) === 0
                                                        ? "Select Reviewers"
                                                        : ""
                                                    }
                                                    InputProps={{
                                                      ...params.InputProps,
                                                      endAdornment: (
                                                        <>
                                                          {loading ? (
                                                            <CircularProgress
                                                              color="inherit"
                                                              size={20}
                                                            />
                                                          ) : null}
                                                          {params.InputProps.endAdornment}
                                                        </>
                                                      ),
                                                    }}
                                                  
                                                  />
                                                )}
                                                renderTags={(value, getTagProps) =>
                                                  value.map((option, index) => (
                                                    <Chip
                                                      key={index}
                                                      label={option?.userName}
                                                      onDelete={() => {
                                                        const updatedReviewers =
                                                          formState?.loamReviewer?.filter(
                                                            (userId) => userId !== option.userId
                                                          ) || [];
                                                        setFormState((prevFormState) => ({
                                                          ...prevFormState,
                                                          loamReviewer: updatedReviewers,
                                                        }));
                                                      }}
                                                      deleteIcon={<CloseIcon />}
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        backgroundColor: "#e0e0e0",
                                                        padding: "2px",
                                                        marginRight: "4px",
                                                      }}
                                                      {...getTagProps({ index })}
                                                    />
                                                  ))
                                                }
                                              />


                                            </Grid>



                                            {
         (  formState?.loamReviewer?.length > 0 && selectedRole?.roleName === "Department Coordinator" ) && 
            <Grid
            item xs={12} sm={12} md={6} lg={3}
          >
            <FormControl component="fieldset">
              <Typography style={{
                color: "black"
              }}>
               Sequential/Parallel
              </Typography>
              <RadioGroup
                row
                aria-label="gender"
                name="gender1"
                value={isParallel}
                aria-labelledby="demo-row-radio-buttons-group-label"
                onChange={ (e)=>{
                  setIsParallel(e.target.value)
                }}        
              >
                <FormControlLabel
                 value= "Sequential"
                  control={<Radio size="small" />}
                  label="Sequential"
                  style={{ color: "black" }} 
                />
                <FormControlLabel
               value = "Parallel"
                  control={<Radio size="small" />}
                  label="Parallel"
                  style={{ color: "black" }}
                 
                />
              </RadioGroup>
            </FormControl>
          </Grid>
           }
                    
                                            {/*
                                      <Grid item xs={12} sm={12} md={3} lg={3}>
                                        <Button
                                          color="secondary"
                                          variant="contained"
                                          sx={{ mt: 3 }}
                                        >
                                          Add Another Reviewer
                                        </Button>
                                      </Grid>
                                          */}
                                          </Grid>
                                        )}
                  </>
                ) : (
                  ""
                )}

 {/* Rent Fields */}



                {/* //Comment history */}
                {(selectedRole?.roleName === "IR" ||
                  selectedRole?.roleName === "Import" ||
                  selectedRole?.roleName === "I2P Initiator" ||
                  selectedRole?.roleName === "Department Coordinator" ||
                  selectedRole?.roleName === "HR" ||
                  selectedRole?.roleName === "EFDV Initiator") &&
                  invoicePayload?.Invoice_id &&
                  role && (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <CommentHistory
                        commentsList={commentsList}
                        commentsLoading={commentsLoading}
                      />
                    </Grid>
                  )}
                {selectedRole?.roleName === "IR" ? (
                  <>
                    <form>
                      <Dialog
                        open={open}
                        onClose={handleClose}
                        fullWidth
                        maxWidth="xl"
                        // style={{ maxWidth: "100%" }}
                        // maxHeight="100vh" // Set maxHeight to 100% of viewport height
                        height="100%" // Set maxWidth to false for 100% width
                        zIndex="3"
                      >
                        <DialogTitle>
                          <Typography
                            variant="h4"
                            required
                            id="demo-row-radio-buttons-group-label"
                            style={{
                              margin: "20px 4px 0px 0px",
                              color: "black",
                            }}
                          >
                            <b>
                              {formState?.isLogistics
                                ? "DN Number/ ITN Number"
                                : "PO Number/ DN Number"}
                            </b>
                          </Typography>
                        </DialogTitle>
                        <DialogContent>
                          <Grid container spacing={1} mt={1}>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={3}
                              lg={3}
                              style={{ marginLeft: "4px" }}
                            >
                              <FormControl component="fieldset">
                                <RadioGroup
                                  row
                                  aria-label="gender"
                                  name="gender1"
                                  value={po_dn_State}
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  // value={value}
                                  onChange={(e) => {
                                    setPo_dn_State(e.target.value);
                                  }}
                                >
                                  <FormControlLabel
                                    value={
                                      formState?.isLogistics ? "ITN" : "PO"
                                    }
                                    control={<Radio size="small" />}
                                    label={
                                      formState?.isLogistics
                                        ? "ITN Number"
                                        : "PO Number"
                                    }
                                  />

                                  <FormControlLabel
                                    value="DN"
                                    control={<Radio size="small" />}
                                    label="DN Number"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                              <TextField
                                id="outlined-basic"
                                label="Search"
                                // required
                                // InputLabelProps={{required:false}}
                                variant="outlined"
                                value={search_val}
                                fullWidth
                                size="small"
                                onChange={multiVal}
                              />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                              <TextField
                                id="outlined-basic"
                                label="Filter"
                                // required
                                // InputLabelProps={{required:false}}
                                variant="outlined"
                                value={filter}
                                fullWidth
                                size="small"
                                onChange={(e) => {
                                  setFilter(e.target.value);
                                }}
                              />
                            </Grid>
                          </Grid>
                          {isPOError.isPOError && (
                            <Typography p={1} mt={1} style={{ color: "red" }}>
                              {isPOError.pomessage}{" "}
                            </Typography>
                          )}
                          {/* <DialogContentText> */}
                          <POTableFor_Model
                            // selected_PoRec={selected_PoRec}
                            //setSelected_PoRec={setSelected_PoRec}
                            // setSelectedTotal={setSelectedTotal}
                            setSelectedTotal={() => {}}
                            Invoice_id={invoicePayload?.Invoice_id}
                            formState_v1={temparary_PoDetail}
                            filter={filter}
                            formState={{
                              invoicePORef_List: filter
                                ? temparary_PoDetail.invoicePORef_List.filter(
                                    (x) => x.RefDoc === filter
                                  )
                                : temparary_PoDetail.invoicePORef_List,
                            }}
                            setFormState={setTemparary_PoDetail}
                            disabled={false}
                            checkedBox={true}
                            deletee={false}
                            loading={multiValLoading}
                          />
                          <Grid item xs={12} sm={12} md={6} lg={12}>
                            <Grid container style={{ marginLeft: "7px" }}>
                              <Grid item xs={6} sm={6} md={6} lg={3}>
                                <Typography component="h2">
                                  Invoice Amount:
                                </Typography>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={3}>
                                {addZeroes(
                                  temporaryPoDetailTotal?.invoiceAmount
                                )}
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={3}>
                                <Typography component="h2">
                                  Invoice Qty:
                                </Typography>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={3}>
                                {addZeroes(temporaryPoDetailTotal?.invoiceQty)}
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={3}>
                                <Typography component="h2">
                                  GRN Amount:
                                </Typography>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={3}>
                                {addZeroes(temporaryPoDetailTotal?.grnAmount)}
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={3}>
                                <Typography component="h2">GRN Qty:</Typography>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={3}>
                                {addZeroes(temporaryPoDetailTotal?.grnQty)}
                              </Grid>
                            </Grid>
                          </Grid>
                          {/* <Table sx={{ width: "60%" }}>
                          <TableRow>
                            <TableCell style={tableheading}>
                              Invoice Amount:
                            </TableCell>
                            <TableCell style={tableBorder}>
                              {addZeroes(temporaryPoDetailTotal?.invoiceAmount)}
                            </TableCell>
                            <TableCell style={tableheading}>
                              Invoice Qty
                            </TableCell>
                            <TableCell style={tableBorder}>
                              {addZeroes(temporaryPoDetailTotal?.invoiceQty)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={tableheading}>
                              GRN Amount:
                            </TableCell>
                            <TableCell style={tableBorder}>
                              {addZeroes(temporaryPoDetailTotal?.grnAmount)}
                            </TableCell>
                            <TableCell style={tableheading}>GRN Qty:</TableCell>
                            <TableCell style={tableBorder}>
                              {addZeroes(temporaryPoDetailTotal?.grnQty)}
                            </TableCell>
                          </TableRow>
                        </Table> */}
                          {/* </DialogContentText> */}
                        </DialogContent>
                        {/* <Box
                    display="flex"
                    justifyContent={"flex-end"}
                    mt={2}
                    mb={2}
                    mr={5}
                  > */}
                        <DialogActions>
                          <Button
                            color="primary"
                            variant="outlined"
                            onClick={handleClose}
                          >
                            Close
                          </Button>
                          <Button
                            color="secondary"
                            variant="contained"
                            onClick={submitPopup}
                          >
                            Submit
                          </Button>
                        </DialogActions>
                        {/* </Box> */}
                      </Dialog>
                    </form>
                    {(formState?.pO_Based || formState?.isLogistics) && (
                      <>
                        {/* <Grid container spacing={0} style={{ marginTop: "10px" }}> */}
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          style={{ display: disable ? "none" : "" }}
                        >
                          <Heading title="PO Details" />
                          <Button
                            color="secondary"
                            variant="contained"
                            onClick={handleClickOpen}
                            // style={{
                            //   display: disable ? "none" : "",
                            // }}
                          >
                            Add New
                          </Button>
                          {formState?.isLogistics && (
                            <Button
                              style={{ marginLeft: "10px" }}
                              color="secondary"
                              variant="contained"
                              onClick={() => setOpenDebugDialog(true)}
                            >
                              Debug
                            </Button>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={12}>
                          {/* this po detail is for user to only on view invoice */}
                          {selectedRole.roleName == "IR" &&
                          edit == "false" &&
                          (formState?.pO_Based || formState?.isLogistics) ? (
                            <PODetail
                              formState={false_PoDetail}
                              setSelectedTotal={setSelectedTotal}
                              setFormState={setFalse_PoDetail}
                              Invoice_id={invoicePayload?.Invoice_id}
                              disabled={edit === "false"}
                              deletee={edit !== "false"}
                              checkedBox={edit !== "false"}
                              edit={edit}
                              selectedRole={selectedRole}
                              loading={poLoading}
                            />
                          ) : (
                            <>
                              {(formState?.pO_Based ||
                                formState?.isLogistics) && (
                                <PoDetail_Table_V2
                                  Invoice_id={invoicePayload?.Invoice_id}
                                  formState={temp_ActualPoDetail}
                                  setSelectedTotal={setSelectedTotal}
                                  setFormState={setTemp_ActualPoDetail}
                                  setFormState_v1={setFormState}
                                  grn_No={formState.grn_No}
                                  isLogistics={formState.isLogistics}
                                  selectedRole={selectedRole}
                                  copyOfPoDetail={copyOfPoDetail}
                                  loading={poLoading}
                                  searchWithPo={searchWithPo}
                                  disabled={false}
                                  deletee={true}
                                  checkedBox={true}
                                  edit={edit}
                                  status={status}
                                  // alertMessage={alertMessage}
                                  // setAlertMessage={setAlertMessage}
                                  // erralertMessage={erralertMessage}
                                />
                              )}
                            </>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={3}>
                          <Box style={myStyle}>
                            <Typography
                              style={{
                                width: "200px",
                                height: "50px",
                                borderRadius: "4px",
                                color: "white",
                                padding: "8px 10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "left",

                                backgroundColor: `${
                                  Number(formState?.invoice_Amount)?.toFixed(
                                    2
                                  ) == selectedTotal
                                    ? "#3AB44A"
                                    : "#fc4b6c"
                                }`,
                              }}
                            >
                              Balance:{" "}
                              {addZeroes(
                                Number(
                                  Number(formState?.invoice_Amount)?.toFixed(2)
                                ) - Number(selectedTotal) || 0
                                // "d"
                              )}
                            </Typography>
                          </Box>
                        </Grid>

                        {/* </Grid> */}
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}
                {dnVendorDetail.dnVendorDetail_List.length > 1 ? (
                  <>
                    <Dialog
                      open={openfordn}
                      onClose={handleDNClose}
                      fullWidth={true}
                    >
                      <DialogTitle>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <FormControl component="fieldset">
                            <FormLabel
                              classes={{ asterisk: classes.asterisk }}
                              required
                              id="demo-row-radio-buttons-group-label"
                            >
                              <b>DN Vendor Detail</b>
                            </FormLabel>
                          </FormControl>
                        </Grid>
                      </DialogTitle>
                      <DialogContent>
                        <TableContainer className="scrollable">
                          <Table
                            className={classes.table}
                            aria-label="a dense table"
                            // padding="normal"
                            size="small"
                          >
                            <TableHead>
                              <TableRow sx={{ backgroundColor: "#A5ACB0" }}>
                                <TableCell
                                  align="center"
                                  sx={{ fontWeight: "bold", color: "#fff" }}
                                >
                                  #
                                </TableCell>
                                <TableCell
                                  sx={{ fontWeight: "bold", color: "#fff" }}
                                ></TableCell>
                                <TableCell
                                  sx={{ fontWeight: "bold", color: "#fff" }}
                                >
                                  Vendor Code
                                </TableCell>
                                <TableCell
                                  sx={{ fontWeight: "bold", color: "#fff" }}
                                >
                                  Vendor Name
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {dnVendorDetail.dnVendorDetail_List?.length > 1 &&
                                // dnVendorDetail.dnVendorDetail_List.reduce((finalArray, current) => {
                                //   let obj = finalArray.find((item)=> item?.Vendor_Code === current.Vendor_Code);
                                //    if(obj){
                                //     return finalArray
                                //    }
                                //    return finalArray.cancat([current])
                                // })
                                // for removing duplicate vendorCode  from array
                                dnVendorDetail.dnVendorDetail_List
                                  .filter((value, index) => {
                                    const _value = JSON.stringify(value);
                                    return (
                                      index ===
                                      dnVendorDetail.dnVendorDetail_List.findIndex(
                                        (obj) => {
                                          return (
                                            JSON.stringify(obj.VendorCode) ===
                                            _value.VendorCode
                                          );
                                        }
                                      )
                                    );
                                  })
                                  .map((item, index) => {
                                    return (
                                      <TableRow
                                        sx={{
                                          backgroundColor: "rgb(240,240,240)",
                                        }}
                                      >
                                        <TableCell
                                          className={classes.cellPadding}
                                          align="center"
                                          scope="row"
                                        >
                                          {index + 1}
                                        </TableCell>
                                        <TableCell>
                                          <input
                                            type="checkbox"
                                            checked={
                                              item?.selected ? true : false
                                            }
                                            onChange={(e) => {
                                              selectRec(e, index);
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          {item?.Vendor_Code}
                                        </TableCell>
                                        <TableCell>
                                          {item?.Vendor_Name}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </DialogContent>
                      {/* <Box
                display="flex"
                justifyContent={"flex-end"}
                mt={2}
                mb={2}
                mr={5}
              > */}
                      <DialogActions>
                        <Button
                          color="primary"
                          variant="outlined"
                          onClick={handleDNClose}
                        >
                          Close
                        </Button>
                        <Button
                          color="secondary"
                          variant="contained"
                          onClick={SubmitDNPopup}
                        >
                          Submit
                        </Button>
                      </DialogActions>
                      {/* </Box> */}
                    </Dialog>
                  </>
                ) : (
                  ""
                )}
                {(selectedRole?.roleName === "I2P Initiator" ||
                  selectedRole?.roleName === "Department Coordinator" ||
                  selectedRole?.roleName === "EFDV Initiator" ||
                  selectedRole?.roleName === "Import" ||
                  selectedRole?.roleName === "HR" ||
                  selectedRole?.roleName === "IR") && (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <FormControlLabel
                        style={{
                          display: disable ? "none" : null,
                        }}
                        label={
                          <Typography sx={{ color: "black" }}>
                            {`I have verified invoice as per`}{" "}
                            <Typography
                              variant="caption"
                              color="secondary"
                              onClick={setOpenInvoiceGuideLine}
                              style={{ fontSize: "1rem" }}
                            >
                              Invoice check list
                            </Typography>
                          </Typography>
                        }
                        color="secondary"
                        control={
                          <Checkbox
                            color="secondary"
                            fontSize="small"
                            checked={formState.verified || disable}
                            // required
                            required={
                              formState?.isProceed || formState?.isReturn || (reviewer && !reviewerModal)
                            }
                            onChange={(event) => {
                              setFormState((formState) => ({
                                ...formState,
                                verified: event.target.checked,
                              }));
                            }}
                            disabled={disable}
                          />
                        }
                      />
                    </Grid>
                    {(Post && allowToProceed) && (
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        {(selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "Import" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "Department Coordinator" ||
                          selectedRole?.roleName === "HR" ||
                          selectedRole?.roleName === "EFDV Initiator") && (
                          <Button
                            style={{
                              margin: "3px 3px 3px 0px",
                              color: "white",
                              display: disable ? "none" : "",
                              backgroundColor: "#ED1C24",
                            }}
                            variant="contained"
                            color="danger"
                            onClick={() => navigate("/home")}
                          >
                            CANCEL
                          </Button>
                        )}
                        {(selectedRole?.roleName === "I2P Initiator" ||
                          
                          selectedRole?.roleName === "Import" ||
                          selectedRole?.roleName === "HR" ||
                          selectedRole?.roleName === "EFDV Initiator") && (
                          <Button
                            style={{
                              margin: "2px",
                              display: disable ? "none" : "",
                            }}
                            variant="contained"
                            color="success"
                            type="submit"
                            id="saveAsDraft"
                            // onClick={}
                            disabled={disable}
                          >
                            SAVE AS DRAFT
                          </Button>
                        )}
                        {(status === "SendToIR" ||
                          status === "SendToIRFromTaxTeam" ||
                          status === "SubmittedByVendor") && (
                          // {status === "SendToIR" && (
                          <Button
                            style={{
                              margin: "2px",
                              display: disable ? "none" : "",
                              color: "white",
                              fontWeight: "700",
                              backgroundColor: "black",
                            }}
                            variant="contained"
                            color="inherit"
                            // type="submit"
                            // id="saveAsDraft"
                            onClick={() => setOpenIrModal(true)}
                          >
                            Change IR
                          </Button>
                        )}
                        {selectedRole?.roleName === "IR" &&
                          formState?.pO_Based && (
                            <Button
                              style={{
                                margin: "2px",
                                display: edit == "false" ? "none" : "",
                                color: "white",
                                fontWeight: "700",
                                backgroundColor: "black",
                              }}
                              variant="contained"
                              color="inherit"
                              // type="submit"
                              // id="saveAsDraft"
                              // disabled={!isAnyPoSelected}
                              type="submit"
                              id="SendToBuyer"
                              onClick={() => {
                                setFormState((formState) => ({
                                  ...formState,
                                  isReturn: false,
                                  isProceed: false,
                                  isBuyerPR: true,
                                  isQuick:false,
                                  isDelete: false,
                                  IsSendToBuyer: true,
                                }));
                                setBuyerStatus(true);
                                setPRInitiatorStatus(false);
                              }}
                            >
                              Send to Buyer
                            </Button>
                          )}

                        {(status === "SendToIR" ||
                          status === "SendToIRFromTaxTeam" ||
                          status === "SendToIRFromIP" ||
                          status === "SendToIRFromSupervisor") && (
                          <Button
                            style={{
                              margin: "2px",
                              display: edit == "false" ? "none" : "",
                              color: "white",
                              fontWeight: "700",
                              backgroundColor: "black",
                            }}
                            variant="contained"
                            color="inherit"
                            type="submit"
                            // id="saveAsDraft"
                            onClick={() => {
                              setFormState((formState) => ({
                                ...formState,
                                isReturn: true,
                                isProceed: false,
                                isQuick:false,
                                isDelete: false,
                              }));
                              setConfirmationMessage(
                                "Are you sure to send invoice to Initiator"
                              );
                              setStatusForPayload("SendToInitiatorFromIR");
                              // setConfirmationModal(true);
                            }}
                          >
                            Send to Initiator
                          </Button>
                        )}
       {(
  
  (formState?.invoice_Type !== "Final Settlement - Distributor" && selectedRole?.roleName === "IR")
) && <Button
                                style={{
                                  margin: "2px",
                                  backgroundColor: "black",
                                  color: "white",
                                  display: edit == "false" ? "none" : "",
                                  // display: `${formState.skipTaxStep}` === "true" ? "none": ""
                                }}
                                variant="contained"
                                type="submit"
                                onClick={() => { 
                                // {((invoiceId=="" || invoiceId==null) && formState.verified) &&
                                //    createInvoiceByIR(
                                //     formState,
                                //     temp_ActualPoDetail,
                                //     setFormState,
                                //     poBasedState,
                                //     setErrorMessage,
                                //     setSuccessMessage,
                                //     setAttachInvoiceLoading,
                                //     setOpenProceedBtn,
                                //     navigate,
                                //     searchWithPo,
                                //     buyerStatus,
                                //     PRInitiatorStatus,
                                //     setPost
                                //   )}
                                // ((invoiceId=="" || invoiceId==null) && formState.loamReviewer=="") && setErrorMessage("Please select reviewer") 
                               if((invoiceId=="" || invoiceId==null) && formState.loamReviewer=="" && formState.loamReviewer.length==0 ){
                                setErrorMessage("Please select reviewer")
                                formState?.comments=="" && setReviewer(true)
                                setFormState((formState) => ({
                                  ...formState,
                                  isReturn: false,
                                  isProceed: false,
                                  isDelete: false,
                                }))
                              }else{
                                if((invoiceId=="" || invoiceId==null) && formState.loamReviewer?.length!==0) {
                                  setErrorMessage("")
                                   setFormState((formState) => ({
                                  ...formState,
                                  isReturn: false,
                                  isProceed: false,
                                  isDelete: false,
                                }))}
                                else if(invoiceId!=="") { 
                                  setFormState((formState) => ({
                                  ...formState,
                                  isReturn: false,
                                  isProceed: false,
                                  isDelete: false,
                                }))
                                formState?.comments=="" && setReviewer(true)

                                formState?.comments!=="" && setReviewerModal(true)
                              }
                                else if (invoiceId!=="" && invoiceId!==null){
                                  setFormState((formState) => ({
                                    ...formState,
                                    isReturn: false,
                                    isProceed: false,
                                    isDelete: false,
                                  }))
                                  formState?.comments=="" && setReviewer(true)

                                  formState?.comments!=="" && setReviewerModal(true)
                                  }
                               }
                                }}
                              >
                                Send to Reviewer
                              </Button>}
                        {(selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "Import" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName === "Department Coordinator" ||
                          selectedRole?.roleName === "HR" ||
                          selectedRole?.roleName === "EFDV Initiator") &&
                          invoicePayload?.Invoice_id && (
                            <Button
                              style={{
                                margin: "2px",
                                display: edit == "false" ? "none" : "",
                                color: "white",
                                fontWeight: "700",
                                backgroundColor: "black",
                              }}
                              variant="contained"
                              color="inherit"
                              type="submit"
                              // id="saveAsDraft"
                              onClick={() => {
                                setFormState((formState) => ({
                                  ...formState,
                                  isReturn: false,
                                  isProceed: false,
                                  isDelete: true,
                                }));
                                setConfirmationMessage(
                                  "Are you sure to Delete an Invoice"
                                );
                                setStatusForPayload("Deleted");
                                // setConfirmationModal(true);
                              }}
                            >
                              Delete Invoice
                            </Button>
                          )}
                        {selectedRole?.roleName === "IR" &&
                          invoicePayload?.Invoice_id &&
                          // !formState?.pO_Based &&
                          (formState?.isQuickPay ||
                            formState?.isSubmittedByVendor) && (
                            <Button
                              style={{
                                margin: "2px",
                                display: edit == "false" ? "none" : "",
                                color: "white",
                                fontWeight: "700",
                                backgroundColor: "black",
                              }}
                              variant="contained"
                              color="inherit"
                              type="submit"
                              // id="saveAsDraft"
                              onClick={() => {
                                setFormState((formState) => ({
                                  ...formState,
                                  isReturn: false,
                                  isProceed: false,
                                  isQuick: true,
                                }));
                                setConfirmationMessage(
                                  "Are you sure you want to Reject an Invoice"
                                );
                                setStatusForPayload("Reject");
                                // setConfirmationModal(true);
                              }}
                            >
                              Return to Vendor
                            </Button>
                          )}
                        {selectedRole?.roleName === "IR" &&
                          formState?.pO_Based && (
                            <Button
                              style={{
                                margin: "2px",
                                color: "white",
                                fontWeight: "700",
                                backgroundColor: "black",
                                display: edit == "false" ? "none" : "",
                              }}
                              variant="contained"
                              color="inherit"
                              // type="submit"
                              // id="saveAsDraft"
                              type="submit"
                              id="SendToPRInitiator"
                              onClick={() => {
                                setFormState((formState) => ({
                                  ...formState,
                                  isReturn: false,
                                  isProceed: false,
                                  isBuyerPR: true,
                                  isQuick:false,
                                  isDelete: false,
                                  IsSendToBuyer: false,
                                }));
                                // setConfirmationMessage(
                                //   "Are you sure to Delete an Invoice"
                                // );
                                setPRInitiatorStatus(true);
                                setBuyerStatus(false);
                              }}
                              // onClick={() => {
                              //   setConfirmationMessage(
                              //     "Are you sure to send invoice to PR Initiator"
                              //   );
                              //   setStatusForPayload("");
                              //   setConfirmationModal(true);
                              // }}
                            >
                              Send to PR Initiator
                            </Button>
                          )}

                        {(selectedRole?.roleName === "IR" ||
                          selectedRole?.roleName === "Import" ||
                          selectedRole?.roleName === "HR" ||
                          selectedRole?.roleName === "EFDV Initiator" ||
                          selectedRole?.roleName === "I2P Initiator" ||
                          selectedRole?.roleName ===
                            "Department Coordinator") && (
                          <Button
                            style={{
                              margin: "2px",
                              display: disable ? "none" : "",
                            }}
                            variant="contained"
                            color="secondary"
                            type="submit"
                            id="proceed"
                            disabled={isDuplicateInvoice !== ""||errorMessage!==""}
                            // disabled={
                            //   !formState?.isLogistics
                            //     ? selectedRole?.roleName === "IR" &&
                            //       poBasedState === "PO" &&
                            //       formState?.invoice_Amount != selectedTotal
                            //     : false
                            // }
                            onClick={() => {
                              setFormState((formState) => ({
                                ...formState,
                                isReturn: false,
                                isProceed: true,
                                isBuyerPR: false,
                                isQuick:false,
                                isDelete: false,
                              }));
                            }}
                          >
                            PROCEED
                          </Button>
                        )}
                        {/* {poBasedState === "PO"
                    ? (selectedRole?.roleName === "IR" ||
                        selectedRole?.roleName === "I2P Initiator"||
                        selectedRole?.roleName === "EFDV Initiator") && (
                        <Button
                          style={{ margin: "2px" }}
                          variant="contained"
                          color="secondary"
                          type="submit"
                          id="proceed"
                          disabled={
                            selectedRole?.roleName === "IR" &&
                            formState?.invoice_Amount != selectedTotal
                          }
                          // onClick={setOpenProceedBtn}
                        >
                          PROCEED
                        </Button>
                      )
                    : (selectedRole?.roleName === "IR" ||
                        selectedRole?.roleName === "I2P Initiator") && (
                        <Button
                          style={{ margin: "2px" }}
                          variant="contained"
                          color="secondary"
                          type="submit"
                          id="proceed"
  
                          // onClick={setOpenProceedBtn}
                        >
                          PROCEED
                        </Button>
                      )} */}
                      </Grid>
                    )}
                  </>
                )}
              </Grid>

              {/* {openProceedBtn && (
            <ProceedBtn
              open={openProceedBtn}
              close={() => setOpenProceedBtn(false)}
              
            />
          )} */}
              {/* )} */}
            </form>
          </CardBody>

          {openDebugDialog && (
            <DebugDialog
              open={openDebugDialog}
              debugData={formState}
              // debugData={debugData}
              setDebugData={setFormState}
              handleClose={() => setOpenDebugDialog(false)}
              status={status}
              selectedRole={selectedRole?.roleName}
            />
          )}
          {/* openInvalidWarningDate, setOpenInvalidWarningDate */}
          {openInvalidWarningDate && (
            <OldDateWarning
              open={openInvalidWarningDate}
              close={() => setOpenInvalidWarningDate(false)}
              InvalidWarningDateState={InvalidWarningDateState}
            />
          )}
          {openInvoiceGuideLine && (
            <InvoiceGuideLine
              open={openInvoiceGuideLine}
              close={setOpenInvoiceGuideLine}
            />
          )}
          {openProceedBtn && (
            <ProceedBtn
              open={openProceedBtn}
              close={() => setOpenProceedBtn(false)}
              submit={confirmedForInvoiceCreation}
              attachInvoiceLoading={attachInvoiceLoading}
              formState={formState}
            />
          )}
          {openIrModal && (
            <ChangeIrModal
              open={openIrModal}
              close={() => setOpenIrModal(false)}
              Invoice_Id={invoicePayload.Invoice_id}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
              setLoading={setAttachInvoiceLoading}
              loading={attachInvoiceLoading}

              setCommentsList =   {setCommentsList}
        setCommentsLoading = {setCommentsLoading}
        invoicePayload = {invoicePayload?.Invoice_id}
        setcount = {setcount}
              

            />
          )}
          {reviewerModal && (
            <ReviewerModal
              open={reviewerModal}
              close={() => setReviewerModal(false)}
              newFormState={formState}
              setNewFormState={setFormState}
              statusForPayload={statusForPayload}
              setStatusForPayload={setStatusForPayload}
              Invoice_Id={invoicePayload.Invoice_id!==0 && invoicePayload.Invoice_id!==null ? invoicePayload.Invoice_id:successMessage}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
              setLoading={setAttachInvoiceLoading}
              loading={attachInvoiceLoading}
              setAllowToProceed={setAllowToProceed}
            />
          )}
          {/* {successMessage && (
          <news
            open={successMessage !== ""}
            message={successMessage}
            handleClose={() => setSuccessMessage("")}
            variant="success"
          />
        )} */}
          {successMessage && (
            <CustomSnackbar
              open={successMessage !== ""}
              message={successMessage}
              handleClose={() => setSuccessMessage("")}
              variant="success"
            />
          )}
          {errorMessage && (
            <>
              {" "}
              <Grid container spacing={0}>
                <Grid item>
                  <Error
                    titleAccess="Error"
                    className={classes.asterisk}
                    fontSize="small"
                  />{" "}
                </Grid>
                <Grid item>
                  <Typography className={classes.asterisk} ml={1}>
                    {" "}
                    {errorMessage}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
          {confirmationModal && (
            <ConfirmationModal
              open={confirmationModal}
              close={() => setConfirmationModal(false)}
              message={confirmationMessage}
              // submit={() =>
              //   changeInvoiceStatus(
              //     formState.invoice_Id,
              //     statusForPayload,
              //     setConfirmationModal,
              //     setAttachInvoiceLoading,
              //     setSuccessMessage,
              //     setErrorMessage,
              //     navigate,
              //     formState.comments
              //   )
              // }
              submit={confirmedForInvoiceCreation}
              loading={attachInvoiceLoading}
            />
          )}
          {threeWayMismatchModal && (
            <ThreeWayCheckModal
              open={threeWayMismatchModal}
              close={() => setThreeWayMismatchModal(false)}
              message={threeWayMismatchItems}
              // submit={() =>
              //   changeInvoiceStatus(
              //     formState.invoice_Id,
              //     statusForPayload,
              //     setConfirmationModal,
              //     setAttachInvoiceLoading,
              //     setSuccessMessage,
              //     setErrorMessage,
              //     navigate,
              //     formState.comments
              //   )
              // }
              submit={confirmedForInvoiceCreation}
              loading={attachInvoiceLoading}
            />
          )}
          {loading &&
             <Backdrop
             sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
             open={loading}>
             <CircularProgress color="inherit" />
           </Backdrop>}
          {openWarningBox && (
            <WarningBox
              open={openWarningBox}
              close={() => setOpenWarningBox(false)}
              submit={warningFlag ? deleteAttachmentFunc : deleteInvoice}
              message="Are you sure to delete attachment"
              deleteLoader={deleteLoader}
              allow={1}
            />
          )}
          {alertMessage && (
            <POAlertDialog
              setAlertMessage={setAlertMessage}
              message={attachError ? attachError : docError}
              setErrAlertMessage={() => {}}
            />
          )}
          
           {isConfirmatoryPO && 
            <POAlertDialog
            setAlertMessage={setAlertMessage}
            message= "Confirmatory PO"
            setErrAlertMessage={() => {}}
          />}
        
          {alertMessageforPO && selectedRole?.roleName === "IR" && (
            <POAlertDialog
              setAlertMessage={setAlertMessageForPO}
              message={erralertMessage}
              setErrAlertMessage={() => {}}
            />
          )}
          {higherLoamApprover && (
            <POAlertDialog
              setAlertMessage={sethigherLoamApprover}
              message="You have selected a higher-order Loam Approver!"
              setErrAlertMessage={() => {}}
            />
          )}
          {vendorblock && (
            <POAlertDialog
              setAlertMessage={setvendorblock}
              message={erralertMessage}
              setErrAlertMessage={() => {}}
            />
          )}
          {specialCharError && (
            <POAlertDialog
              setAlertMessage={setSpecialCharError}
              message={specialCharErrorMsg}
              setErrAlertMessage={() => {}}
            />
          )}
          {/* { showModal && (
            <AdjustAdvanceModal
            open = {true}
            setFormState = {setFormState}
            formState = {formState}
            close={()=>setShowModal(false)}
            ></AdjustAdvanceModal>
          )} */}
         {
 (openDuplicateCheckWarning && !loading) && (
    <WarningBox
      open={openDuplicateCheckWarning}
      close={() => setOpenDuplicateCheckWarning(false)}
      message={isDuplicateInvoice}
      allow={1}
    />
  )
}
        </Card>
      {/* ) : (
        <PageNotFound />
      )} */}
    </>
  );
};

export default NewInvoice;
